import $ from 'jquery';
import isEmpty from 'lodash/isEmpty';

import BetslipKeyboard from './keyboard/BetslipKeyboard';
import { emit } from '~shared/utils/event';
import { get } from '~shared/utils/http';
import {
    getBetslipSelections,
    getUserBetslip,
    getAvailableBetTypes,
    getContingencies,
    getAvailableFreeBets,
    getCastmarketId,
    getOriginalSelectionNamesById,
    getNotFcTcSelectionsCount,
    getMapSelectionIdToCombinations,
    getSelectionSuspendedSingle,
    BETSLIP_AFTER_SYNC_EVENT,
    BETSLIP_BEFORE_SYNC_EVENT,
    BETSLIP_BET_PLACED_EVENT,
    BETSLIP_CLOSED_EVENT,
    BETSLIP_CONTINGENCIES_KEY,
    BETSLIP_EMPTY_EVENT,
    BETSLIP_OPENED_EVENT,
    BETSLIP_PLACEMENT_SHOWN_EVENT,
    BETSLIP_RECEIPT_SHOWN_EVENT,
    BETSLIP_SELECTIONS_DETAILS_KEY,
    BETSLIP_SELECTIONS_REMOVED_EVENT,
    BETSLIP_SELECTION_ADDED_EVENT,
    BETSLIP_SELECTION_REMOVED_EVENT,
    BETSLIP_STARTUP_MY_BETS_KEY,
    BETSLIP_USER_BETSLIP_KEY,
    BETSLIP_OPENBETS_LAUNCH_EVENT,
    BETSLIP_OPENBETS_DESTROY_EVENT,
    BETSLIP_ON_OPEN_BETS_PAGE_KEY,
    BETSLIP_POPULATE_SELECTIONS,
    BETSLIP_POPULATE_SURVEY_ID,
    BETSLIP_AVAILABLE_FREEBETS_KEY,
    BETSLIP_RACING_SPORTS,
    COOKIE_BANNER_VISIBILITY_STATE_KEY,
    FREEBETS_BET_TYPES,
    getI18nBetErrorKey,
    shouldDisplayTaxMessage,
    getUserTaxOnReturnsForDisplay,
    onFreeBetsStateChange,
    showHideAcceptOdds,
    toggleAcceptOdds,
    toggleAcceptOddsAllSwitches,
    setAcceptOddsFlag,
    setAvailableBetTypes,
    getUpdatedMultipleOdds,
    bsNumber,
} from '~shared/utils/betslip';
import {
    decimalPriceOdds,
} from '~shared/utils/selections';
import { getState, setState, subscribeToStateChange } from '~shared/utils/state';
import {
    bbModal_open,
    bbModal_close,
    bbModal_changePage,

    createCloseEvents,
} from '../../bb-modal/bbModal';
import { createBbTabs, disableBbTabs, enableBbTabs } from '../../bb-tabs/tabs';
import {
    buildSpectateUrl,
} from '~spa/Utils/Spectate';
import { isLargeContainer } from '~spa/Utils/ContainerSize';
import {
    isUserLoggedIn,
    getIsMobileWrapperFlag,
    getOddsFormat,
    getIsBogRestricted,
    getUserTaxOnReturns,
    setCustomerAcceptOddsFlag,
    getCustomerAcceptOddsFlag,
    shouldHideLogin,
} from '~shared/utils/user';
import {
    DEFAULT_DECIMAL_PLACES,
    SELECTION_ODDS_DECIMAL_PRECISION_LOWER,
} from '~shared/utils/constants';
import {
    betPlacementSucceeded,
    openLoginModal,
    playerHasPendingAction,
    updateWrapperOpenBetsNumber,
    kickUser,
} from '~spa/Utils/WrapperIntegration/Ucf';
import i18n from '~shared/utils/i18n';
import formatCurrency, { deLocalizeNumberString } from '~shared/utils/currencyUtils';
import {
    GTM_BETSLIP,
    GTM_EW_ENABLE,
    GTM_EW_DISABLE,
    GTM_STAKE,
    WS_HANDLER_COMPONENT_NAME,
    GTM_BET_TYPE_INFO_EVENT,
    GTM_BET_TYPE_INFO,
    GTM_EVENT_EXPAND,
    GTM_EVENT_COLLAPSE,
} from './constants';
import {
    eCommerceGTMPurchase,
    eCommerceGTMSelection,
    actionTypes,
    pushToDataLayer,
} from 'shared/utils/google-tag-manager';

import { addAmericanOdds, calculateAmericanPrice, getPriceOdds } from '~shared/components/sport-event/utils';
import { betslipCheckForInstructionCard } from '~shared/components/instruction-card/utils/utils';
import { MAIN_WS_HANDLER_NAME } from '~legacy/modules/ws-interface/wsInterface';
import { getEachwayAllowed } from '~shared/utils/user';

const base_url = buildSpectateUrl('/');
let selection_button_gtm;

const getInitialState = () => ({
    /**
     * Betslip's root element.
     * @type {Jquery Object}
     */
    betslipElt: null,

    /**
    * This object will hold the selected selections ids ordered and categorized
    * @type {Object}
    */
    selectionsIds: {allSelectionsOrdered: [], singles: [], scorecast: [], fc_tc: []},

    /**
    * maximum of bet that can be placed in the betslip
    * @type {Number}
    */
    maxSelections: 0,

    /**
    * Dom object that correspond to the counter btn that launch the betslip model
    * @type {Jquery Object}
    */
    betslipCounterBtn: null,

    oddsFormat: getOddsFormat(),

    /**
     * Holds the details for every selection in the betslip
     * @type {Object}
     */
    selectionsDetails: {},

    /**
     * List of available multibets based on current selections in the betslip
     * @type {Object}
     */
    availableBetTypes: {},

    /**
     * This object holds object of selection ids and their bet locate value
     * @type {Object}
     */
    betLocateDataBySelectionId: {},

    /**
     * This object will hold the selected bets structure to pass when placing a bet
     * @type {object}
     */
    selectedBets: null,

    /**
     * Selection details returned from the backend
     * @type {Array}
     */
    selectionDetails: [],

    /**
    * Timer to synchronize the betslip changes with redis on changing a stake
    */
    betslipSaveChangesSyncTimer: null,

    /**
    * Timer to synchronize the new betslip modification (remove bet) in order to save to redis and get new information
    */
    betslipRemoveSyncTimer: null,

    /**
    * Timer to synchronize the new betslip modification (add bet) in order to save to redis and get new information
    */
    betslipAddSyncTimer: null,

    /**
    * timeout for synchronizing betslip changes that is used by betslipSaveChangesSyncTimer && betslipRemoveSyncTimer
    */
    betslipSyncTimeout: 800,

    /**
    * Current user betslip to be store
    */
    userBetslip: null,

    /**
    * Selection ids for related contingencies
    * @type {Array}
    */
    contingencies: [],

    /**
     * This object will hold a selectionId => price hashmap with the original prices the
     * selections had when the used added them to the betslip.
     * @type {Object}
     */
    originalPrices: {},

    /**
    * http statuses when all bets have been declined
    */
    allBetDeclinedErrorStatuses: [400, 401, 409],

    /**
     * List of error codes for which we will should show popup
     * when all bets have been declined
     * @type {Array}
     */
    popupOnErrorCodes: [
        'CHARGE_FAILED',
        'INSUFFICIENT_FUNDS',
        'PLACEMENT_FAILED',
        'PLAYER_HAS_PENDING_ACTION',
        'PRICE_CHANGED',
        'SELECTION_SUSPENDED_MULTIBET',
        'SELECTION_SUSPENDED_SINGLE',
        'STORE_PENDING_FAILED',
        'UNKNOWN_ERROR',
        'UNAUTHORIZED',
        'REACHED_DAILY_WAGER_LIMIT',
        'REACHED_WEEKLY_WAGER_LIMIT',
        'REACHED_MONTHLY_WAGER_LIMIT',
        'REACHED_DAILY_LOSS_LIMIT',
        'REACHED_WEEKLY_LOSS_LIMIT',
        'REACHED_MONTHLY_LOSS_LIMIT',
        'CUSTOMER_EXCEEDED_SPAIN_INPLAY_WAGERING_LIMIT',
        'GEO_ERROR',
        'TIME_LIMIT_REACHED',
    ],

    /**
     * List of selections to retain in the format accepted by the add method
     * @type {Array}
     */
    selectionsToRetain: [],

    /**
     * List of declined selections to retain in the format accepted by the add method
     * @type {Array}
     */
    declinedSelectionsToRetain: [],

    /**
    * List of suspended selections at the selection Level
    *@type {Array of Strings}
    */
    suspendedSelections: [],

    /**
    * List of suspended selections at a Market level
    *@type {Array of Strings}
    */
    suspendedMarketsSelections: [],

    /**
    * List of suspended selections at an Event level
    *@type {Array of Strings}
    */
    suspendedEventsSelections: [],

    /**
    * a flag to decide whether we should reload the site on betslip closing or not; to be used in case a user login from the betslip
    * @type {Boolean}
    */
    shouldReloadSite: false,

    /**
     * array containing tuples with betId - gaComponent
     * to be used with betLocate (deprecated).
     * NB: This is now used to track the bet source for reporting.
     * @see https://dedsert.atlassian.net/wiki/spaces/DEV/pages/74612887/Frontend+Tracking+Google+Analytics+Betlocate+Optitrack+Qubit
     * @type {[Array]}
     */
    betLocateArray: {},

    /**
    * this is used when adding a bet to the betslip while the timer is on betslipAddSyncTimer
    * @type {Array} of selection ids
    */
    newAddedSelections: [],

    fancyKeyboard: null,

    /**
    * websocket handler for preplay and inplay
    * @type {Object}
    */
    mainWsHandler: {},

    /**
    * selector counter of openbets in the betslip tab
    * @type {jQuery Element}
    */
    betslipOpenBetsCounter: null,

    /**
    * selector counter of bets in the betslip tab
    * @type {jQuery Element}
    */
    betslipBetsCounter: null,

    /**
     * Saved metadata about selections. Allows the meta data to be persisted whenever
     * the userbetslip is built.
     * @type {Object}
     * @see {@link pushSelectionMetaData}
     * @see {@link popSelectionMetaData}
     * @see {@link buildBetslipStructure}
     */
    savedSelectionMetaData: {},

    modalIsOpened: false,

    surveySelections: {},

    /**
     * The list of unsubscribe functions from subscriptions
     * @type {Array}
     */
    clientStateSubscribers: [],
});

const BetslipController = {
    resetControllerToInitialState: function() {
        Object.assign(this, getInitialState());
    },

    unsubscribeFromClientState: function() {
        if (typeof this.clientStateSubscribers === 'undefined') {
            return;
        }

        this.clientStateSubscribers.forEach(
            (unsubscribe) => unsubscribe()
        );
    },

    /**
     * Remove WS handler callbacks
     * @returns {void}
     */
    removeWsHandlers: function() {
        if (typeof this.removeWsHandlerCallbacks === 'undefined') {
            return;
        }

        this.removeWsHandlerCallbacks.forEach(cb => cb());
    },

    /**
    * Initializes the betslip
    * @param {object} settings settings
    * @param {object} wsInterface wsInterface
    * @returns {void}
    */
    init: function(settings, wsInterface) {

        this.resetControllerToInitialState();
        this.babyBetslipContainer = $('.baby-betslip__container');
        this.babyBetslipButton = $('.baby-betslip__button');
        this.betslipElt = $("#betslip");
        this.betslipButton = $('#betslip_button');
        this.betslipTabbed = this.betslipElt.find('.betslipTabbed');
        this.betslipCounterBtn = $("#betslip_selections_counter");
        this.betslipGetOnButton = $('#betslip-get-on');
        this.betslipLaunchPointContainer = $('#betslip-mobile-container');
        this.maxSelections = Number(settings.maxSelections);
        this.oddsFormat = settings.oddsFormat;
        this.openBetslipButton =  $('#open_betslip_button');
        this.fancyKeyboard = new BetslipKeyboard({isMobile: settings.isMobile});
        this.mainWsHandler = wsInterface.requestHandler(MAIN_WS_HANDLER_NAME);
        this.removeWsHandlerCallbacks = [];
        this.betslipOpenBetsCounter = $("#mybets-counter");
        this.betslipOpenBetsTab = $('#bb-tab-my-bets');
        this.betslipBetsCounter = $("#betslip-counter");
        this.betslipBetsHeaderCounter = $('#betslip-header-counter');
        this.betslipCheckbox = $('#betslip-collapse-checkbox');
        this.isSelectionInOrdered = this.isSelectionInOrdered.bind(this);
        this.lang = {
            stake: i18n.t('betslip.stake'),
            na: i18n.t('betslip.na'),
            back: i18n.t('betslip.back_betslip'),
            ew: i18n.t('betslip.ew'),
            sp: i18n.t('betslip.sp'),
        };

        this.taxMessageEl = this.betslipElt.find('.betslip-footer__tax-message');
        this.shouldDisplayTaxMessage = shouldDisplayTaxMessage();
        this.selectionsDetails = getBetslipSelections();
        this.userBetslip = getUserBetslip();
        this.originalPrices = this.userBetslip.originalPrices;
        this.betLocateArray = !$.isEmptyObject(this.userBetslip.betLocateArray)
            ? this.userBetslip.betLocateArray
            : {}; // Make sure it's an object even if the one stored in redis is empty
        this.availableBetTypes = this._normalizeAvailableBetTypes(getAvailableBetTypes());
        this.contingencies = getContingencies();

        this.initEventHandlers();
        this.initWebSocketListeners();
        this.initSelectionsIds();
        this.setBetslipCounter(this.selectionsIds.allSelectionsOrdered.length);
        this.updateSuspendedList(this.selectionsDetails);
        this.updatePotentialReturnsAndStakes();
        this.buildBetsStructure(this.selectionsIds, this.availableBetTypes);
        this.updateSelectionsToRetain(this.selectionsIds.allSelectionsOrdered);
        this.toggleNumberOfOddsChanges(this.betslipElt.find('.betslip-selections--odds-have-changed:not(.betslip-selections--selection-suspended, .betslip-selections--market-suspended, .betslip-selections--event-suspended)').length);
        this.toggleMultibets();
        this.toggleSubmitButton();
        this.fancyKeyboard.init();
        this.initBetslipTabbed();
        this.showBetslipTabContentAfterLoading();
        this.handleOpenBetsPage();
        this.setWrapperOpenBetsNumber();
        this.setStartupMode();
        this.setPopulatedMode();
        this.populateSurveySelections();
        betslipCheckForInstructionCard(this.selectionsIds);
        this.setLoginHiddenByRegulationCss();

        this.handleFreeBetChange();
        this.getAllFreeBets();

        this.setBabyBetslipBottomPosition();
        createCloseEvents();

        $(document).trigger('betslip:launch');
    },

    setLoginHiddenByRegulationCss: function () {
        const $openPopupEl = $('#betslip-get-on__open-login-popup');
        if (shouldHideLogin() && $openPopupEl.length) {
            $openPopupEl.addClass('hide');
        }
    },

    setBabyBetslipBottomPosition: function () {
        const cookieBannerVisibility = getState(
            COOKIE_BANNER_VISIBILITY_STATE_KEY
        );

        if (!cookieBannerVisibility) {
            return;
        }

        const { height = 0 } = cookieBannerVisibility;
        this.betslipLaunchPointContainer.css({
            '--baby-betslip-bottom-gap': `${height}px`,
        });
    },

    /**
     * Initialise betslip tabs
     *
     * @since OR-1379/Navigation enhancements.
     */
    initBetslipTabbed: function() {
        /**
         * OR-1379 prevent betslip bethistory from appearing on accounts/bets page. BetHistory app uses a
         * single store and actions to feed the BetList component. The store only contains the current page
         * of bets and is tightly coupled to BetHistory and BetslipOpenBets. Ideally we refactor. Here we
         * disable the 'My Bets' tab when on accounts/bets.
         * @see betslip.php 'bethistory_open' class is added there
         */

        /**
         * @see https://dedsert.atlassian.net/browse/OR-1379
         */
        createBbTabs(this.betslipTabbed);

        if (getState(BETSLIP_ON_OPEN_BETS_PAGE_KEY)) {
            this.disableOpenBetsTab();
        }
    },

    /**
     * Defines the Betslip Startup mode.
     * It's important especially in the case when customer is on content page
     * and clicks Wrapper's My Bets CTA button.
     * Betslip isn't rendered on the content page but the Wrapper redirects
     * user to sportsbook content and we must open My Bets tab by default.
     */
    setStartupMode: function() {
        const myBetsTab = getState(BETSLIP_STARTUP_MY_BETS_KEY) === true;
        if (!myBetsTab) {
            return;
        }

        this.selectMyBetsTab();
        if (!isLargeContainer()) {
            this.openBetslip();
        }

        setState(BETSLIP_STARTUP_MY_BETS_KEY, false);
    },

    /**
     * Defines Betlisp Populated mode.
     * It takes care of populating Betlisp if it's not rendered.
     * @returns {Void} stop execution if there is no selections.
     */
    setPopulatedMode: function() {
        const selections = getState(BETSLIP_POPULATE_SELECTIONS);
        if (!selections) {
            return;
        }

        const surveyId = getState(BETSLIP_POPULATE_SURVEY_ID);
        this.populateBetslip(selections, surveyId);
        setState(BETSLIP_POPULATE_SELECTIONS, false);
        setState(BETSLIP_POPULATE_SURVEY_ID, false);
    },

    /**
     * '#betslip.bb_tabs_content' has inline style (display: none).
     * This prevents it from being visible while it takes forever for it and
     * receipt modal to load. Remove the inline style here.
     * @see betslip.php
     * @since OR-1379
     */
    showBetslipTabContentAfterLoading: function() {
        this.betslipElt.find('.bb_tabs_content').css('display', '');
    },

    /**
     * Sends number of Open Bets to the Wrapper.
     */
    setWrapperOpenBetsNumber: function() {
        const openBetsNumber = parseInt(this.betslipOpenBetsCounter.text());
        updateWrapperOpenBetsNumber(openBetsNumber);
    },

    /**
     * gets free bets available for selected bet
     * @param {*} elem selected stake input
     * @return {void}
     */
    getSelectionFreeBets: function(elem, rerenderFreebetsModule = false) {
        const that = this;
        const betslipFancyKeyboard = this.fancyKeyboard;
        let keyboardElem;
        let freeBets = {};

        if (!betslipFancyKeyboard.keyboardView.is(':animated')) {
            if (betslipFancyKeyboard.stakeLabel) {
                //binded label is different from prev or we need to re-render freebet container
                if (betslipFancyKeyboard.stakeLabel.attr('id') !== elem.attr('id') || rerenderFreebetsModule) {
                    //if keyboard is out
                    if (betslipFancyKeyboard.isVisible && !rerenderFreebetsModule) {
                        betslipFancyKeyboard.fkDisappear();
                    }
                    keyboardElem = betslipFancyKeyboard.fkBindKeyboardToElement(elem, freeBets, that.getUsedFreebetsIds()); // this is the bit that shows the free bets
                }
            } else {
                keyboardElem = betslipFancyKeyboard.fkBindKeyboardToElement(elem, freeBets, that.getUsedFreebetsIds());
            }
        }

        // only check for free bets if user is logged in
        if (isUserLoggedIn()) {
            if (typeof keyboardElem === 'undefined') {
                return;
            }

            const scorecast = elem.closest('li').hasClass('betslip-selections--scorecast');
            const fcTc = elem.closest('li').hasClass('betslip-selections--castmarket');
            const selectionId = `${elem.data('id')}`;
            const isMultiBet = (isNaN(Number(selectionId)) && !scorecast && !fcTc);
            let freeBets = {};
            const availableFreeBets = getAvailableFreeBets();

            if (isMultiBet) {
                freeBets = availableFreeBets[`multi_${selectionId}`];
            } else {
                const freeBetType = elem.closest('li').data('freebet-type');
                freeBets = Object.values(availableFreeBets[`${freeBetType}`]);
            }
            keyboardElem.fkFreebetShowModule(freeBets, that.getUsedFreebetsIds(), elem, rerenderFreebetsModule);
        }
    },

    getOrderedSelectionIds: function() {

        const singles = [];
        const fcTcs = [];
        const scorecast = [];

        this.selectionsIds.allSelectionsOrdered.forEach(orderedSelection => {
            if (orderedSelection.single) {
                singles.push(orderedSelection.single);
            } else if (orderedSelection.scorecast) {
                scorecast.push(orderedSelection.scorecast);
            } else {
                const selection = orderedSelection[0];
                if (selection && selection.fc_tc) {
                    fcTcs.push(selection.fc_tc);
                }
            }
        });

        return {
            scorecast,
            singles,
            fc_tc: fcTcs,
        };
    },

    isEmptySelectedBets: function() {
        if (isEmpty(this.selectedBets.fc_tc) &&
            isEmpty(this.selectedBets.multiples) &&
            isEmpty(this.selectedBets.scorecast) &&
            isEmpty(this.selectedBets.selections) &&
            isEmpty(this.selectedBets.single)) {
                return true;
            }

        return false;
    },

    getAllFreeBets: function() {
        let that = this;
        if (!isUserLoggedIn() ||
            isEmpty(this.selectionsDetails) ||
            !that.selectionsIds.allSelectionsOrdered.length) {
            return;
        }

        const allSelectionsOrdered = that.selectionsIds.allSelectionsOrdered;

        if (Object.keys(this.selectionsDetails).length !== allSelectionsOrdered.length) {
            return;
        }

        const orderedSelections = that.getOrderedSelectionIds();
        const orderedSelectionIds = {
            allSelectionsOrdered,
            ...orderedSelections,
        };

        that.buildBetsStructure(orderedSelectionIds, that.availableBetTypes, true);

        if (that.isEmptySelectedBets()) {
            return;
        }

        $.ajax({
            url: `${base_url}betslip/getFreeBetsBetslip`,
            type: 'POST',
            crossDomain: false,
            xhrFields: {
                withCredentials: true,
            },
            data: {betslip: JSON.stringify(that.selectedBets)},
        })
        .done(function(response) {
            setState(BETSLIP_AVAILABLE_FREEBETS_KEY, response.free_bets);
            that.setFreebetIndicator();
        });
    },

    setFreebetIndicator: function () {
        const that = this;
        const usedFreeBets = that.getUsedFreebetsIds();
        const availableFreeBets = getAvailableFreeBets();

        that.betslipElt.find('.selection-stake-details__stake-holder').each(function() {
            const elem = $(this);

            if (elem.length > 0) {
                const scorecast = elem.closest('li').hasClass('betslip-selections--scorecast');
                const fcTc = elem.closest('li').hasClass('betslip-selections--castmarket');

                const freeBetType = elem.closest('li').data('freebet-type');
                const selectionFreeBets = availableFreeBets[`${freeBetType}`];
                const stakeValue = parseFloat(elem.data('value'));
                const hideIndicator = !isNaN(stakeValue) && stakeValue;
                const showFreebetIndicator = !$.isEmptyObject(selectionFreeBets) ? that.unusedFreeBets(selectionFreeBets, usedFreeBets) && !hideIndicator : false;

                const stakeContainer = elem.closest('.stake-selection-container');
                if (showFreebetIndicator) {
                    stakeContainer.addClass('selection-stake-details__stake-row--stake-container_free-bet');
                    elem.addClass('selection-stake-details__stake-holder_free-bet');
                } else {
                    stakeContainer.removeClass('selection-stake-details__stake-row--stake-container_free-bet');
                    elem.removeClass('selection-stake-details__stake-holder_free-bet');
                }
            }
        });

        that.betslipElt.find('.betslip-multiples__bet-type__stake').each(function() {
            const elem = $(this);

            if (elem.length > 0) {
                const boundToElement = elem.closest('li.betslip-multiples__bet-type');
                const selectionBetType = elem.data('id');
                const selectionFreeBets = availableFreeBets[`multi_${selectionBetType}`];
                const hasUnusedFreeBets = !$.isEmptyObject(selectionFreeBets) ? that.unusedFreeBets(selectionFreeBets, usedFreeBets) : false;
                const stakeValue = parseFloat(elem.data('value'));
                const hideIndicator = !isNaN(stakeValue) && stakeValue;

                const showFreebetIndicator = hasUnusedFreeBets
                    && boundToElement.data('freebetAvailable')
                    && !hideIndicator;

                const stakeContainer = elem.closest('.stake-selection-container');
                if (showFreebetIndicator) {
                    stakeContainer.addClass('betslip-multiples__bet-type__stake-details--stake-container_free-bet');
                    elem.addClass('betslip-multiples__bet-type__stake_free-bet');
                } else {
                    stakeContainer.removeClass('betslip-multiples__bet-type__stake-details--stake-container_free-bet');
                    elem.removeClass('betslip-multiples__bet-type__stake_free-bet');
                }
            }
        });
    },

    unusedFreeBets: function (allFreeBets, usedFreeBets) {
        let usedBet = 0;
        allFreeBets.forEach(freeBet => {
            if (usedFreeBets.indexOf(freeBet.id) > -1) {
                usedBet++;
            }
        });

        return (allFreeBets.length - usedBet) > 0;
    },

    /**
    * Initializes event handlers on the DOM
    */
    initEventHandlers: function() {
        var that = this;

        that.betslipElt.on('bbModal:opened', function () {
            emit(BETSLIP_OPENED_EVENT);
        });

        that.betslipElt.on('bbModal:closed', function () {
            emit(BETSLIP_CLOSED_EVENT);
        });

        that.betslipElt.on('bbModal:overlayDialogOpen', function () {
            that.betslipElt.addClass('bb-betslip__dialog--open');
        });

        that.betslipElt.on('bbModal:overlayDialogClose', function () {
            // user might've been kicked out and then el does not exist
            if (that.betslipElt) {
                that.betslipElt.removeClass('bb-betslip__dialog--open');
            }
        });

        $('#betslip-placement').on('bbModal:pageChanged', function() {
            emit(BETSLIP_PLACEMENT_SHOWN_EVENT);
        });

        $('#betslip-receipt').on('bbModal:pageChanged', function () {
            emit(BETSLIP_RECEIPT_SHOWN_EVENT);
        });

        var betslipFancyKeyboard = this.fancyKeyboard;

        $(document).on('click', '#betslip_button', function(e) {
            e.preventDefault();
            that.hideLoadingSpinner();
            that.checkForClearButton();
        });

        $(document).on('click', '[data-bb-modal-close], .bb-modal-overlay', function () {
            that.setBabyBetslipValueFromBetslip();
        });

        const eachWayEvent = 'click taphold';
        const eachWaySelectors = '.each-way-checkbox';
        $(document).off(eachWayEvent, eachWaySelectors).on(eachWayEvent, eachWaySelectors, function() {
            $(this).closest('.betslip-each-way-block').find('.betslip-each-way-block__text').toggleClass('selected');
            $(this).attr('checked', function(index, attr){
                return !attr;
            });
            $(this).trigger('stakeValueChanged');
            const gtmAttributeParts = $(this).attr('data-spectate-product').split(';');
            let gtmPrefix = gtmAttributeParts[0];
            let gtmAttribute = gtmAttributeParts[1];
            if (gtmAttributeParts.length === 3) {
                gtmPrefix = `${gtmAttributeParts[0]};${gtmAttributeParts[1]}`;
                gtmAttribute = `${gtmAttributeParts[2]}`;
            }
            if(gtmAttribute === `${GTM_EW_ENABLE}`) {
                $(this).attr('data-spectate-product', `${gtmPrefix};${GTM_EW_DISABLE}`);
            } else {
                $(this).attr('data-spectate-product', `${gtmPrefix};${GTM_EW_ENABLE}`);
            }
        });

        /**
         * .off().on() Solution. Why?
         * Everytime we reinstantiate Betslip without page reload,
         * we have to remove previous event listeners then add a new on,
         * so we always have only 1 listener.
         * If we didn't do this, it leads into multiple callback being fired
         * when the betslip has been reinitialized multiple times.
         * For example:
         *     Login -> Logout -> Login -> Logout -> ...
         */
        const addToBetslipEvent = 'click';
        const addToBetslipSelectors = '.bb-sport-event__selection:not(.bb-sport-event__selection--inactive)';
        $(document).off(addToBetslipEvent, addToBetslipSelectors).on(addToBetslipEvent, addToBetslipSelectors, function(e) {
            e.preventDefault();
            var $this = $(this);
            // If the button has already been clicked and is busy do nothing
            if($this.hasClass('selection-button-busy')) {

                return;
            }

            // Add class and remove when action is complete
            $this.addClass('selection-button-busy');
            // Remove the GTM tag so it won't send data when clicked while button is busy
            selection_button_gtm = $this.attr('data-spectate-product');
            $this.removeAttr('data-spectate-product');

            var scorecast = $this.hasClass('scorecast');
            var selectionId = "";
            var selection = {};
            var addToEnd = false;
            var shouldChangeView = $this[0].hasAttribute('data-recommended-selection') ? false : true;


            if (scorecast) {
                selection.scorecast = [$this.attr('data-firstgoalscorer-id'), $this.attr('data-correctscore-id')];
                selectionId = selection.scorecast.join('_');
            } else {
                selectionId = $this.attr('data-selection-id');
                selection.single = selectionId;
            }
            /**
             * @todo The gaComponent is used for GA tracking but also for BetLocate. The gaComponentLookup() call,
             * betLocateAdd() and add() calls should be refactored.
             */
            var gaComponent = that.gaComponentLookup($(this));
            that.betLocateAdd(String(selectionId), gaComponent);
            that.add([selection], gaComponent, false, addToEnd, shouldChangeView);
        });

        $(document).on('click taphold', '#betslip-get-on, #betslip-get-on-odds-changed, #betslip-get-on-selection-suspended', function(e) {
            e.preventDefault();
            if (!$(this).hasClass('betslip-footer__get-on--disabled')) {
                that.buildBetsStructure(that.selectionsIds, that.availableBetTypes);
                that.updateSelectionsToRetain(that.selectionsIds.allSelectionsOrdered);
                that.bet(that.selectedBets);
            } else {
                that.hideLoadingSpinner();
            }
        });

        $(document).on('stakeValueChanged', function(e) {
            that.toggleSubmitButton();
            var stakeInput = $(e.target);
            var selectionOrMultipleRow = stakeInput.closest('.selection-stake-details__stake-row, .betslip-multiples__bet-type__stake-details');
            var saveBetslip = false;
            // If this is called by clicking an EW checkbox, fetch the correspoding stake input
            if (stakeInput.hasClass('each-way-checkbox')) {
                saveBetslip = true; // Force saving the betslip since we actually changed the EW checkbox
            }

            // Update the free bet value label in case EW was checked or we are enabling/disabling EW
            var freebetVoucher = selectionOrMultipleRow.find('.offVoucher');
            if (freebetVoucher.length) {
                var ewCheckbox = stakeInput.hasClass('each-way-checkbox') ? stakeInput : selectionOrMultipleRow.find('.each-way-checkbox');
                that.updateFreeBetLabel(freebetVoucher, ewCheckbox.is(':checked'));
            }

            if (!stakeInput.is('#stake-multiples-singles')) { // This is already called by the change method of #stake-multiples-singles
                that.updatePotentialReturnsAndStakes();
            }

            // Did something really change?
            var id = stakeInput.data('id');
            var value = parseFloat(stakeInput.data('value'));
            var selections = typeof(that.userBetslip) !== 'undefined' ? that.userBetslip['selections'] : {};

            if (stakeInput.hasClass('selection-stake-details__stake-holder')) {
                // A single selection
                if (!$.isEmptyObject(selections) && typeof selections[id] !== 'undefined' && selections[id].stake !== value) {
                    saveBetslip = true;
                    that.resetUserEntryMultiSingles();
                }
            } else {
                // A multiple
                saveBetslip = true;
                //singles multibet
                if (stakeInput.is('#betslip #stake-multiples-singles')) {
                    var singlesStakesValue = $(stakeInput).data('value');
                    var singlesIndividualLabels;
                    if (singlesStakesValue === 0 || isNaN(singlesStakesValue)) {
                        singlesIndividualLabels = that.lang.stake;
                    } else {
                        singlesIndividualLabels = formatCurrency(
                            singlesStakesValue,
                            null,
                            null,
                            false,
                            false,
                            DEFAULT_DECIMAL_PLACES,
                        );
                    }

                    //get all selections that aren't suspended
                    var unsuspendedSelections = that.getUnsuspendedSelectionsElt();
                    unsuspendedSelections.find('.selection-stake-details__stake-holder[data-freebet-id=""]').data('value', singlesStakesValue).attr('data-value', singlesStakesValue).text(singlesIndividualLabels);
                    that.updatePotentialReturnsAndStakes();
                }
            }

            if (saveBetslip) {
                that.buildBetslipStructure(that.selectionsIds, that.availableBetTypes);
                //to handle EW change and other side-effects
                that.betslipElt.trigger('betslip:content_change');
                that.synchronizeBetslip();
                that.setFreebetIndicator();
            }
        });

        that.betslipElt.on('click taphold', '.betslip-multiples__bet-type__info-button', function(e) {
            if (!$(this).hasClass('betslip-multiples__bet-type__info-button--expanded')) {
                that.toggleMultipleInfo($(this), true);
            } else {
                that.toggleMultipleInfo($(this), false);
            }

            that.hideLoadingSpinner();
            e.preventDefault();
        });

        that.betslipElt.on('focus', '.betslip-multiples__bet-type__stake', function() {
            var multipleToggleBtn = $(this).closest('.betslip-multiples__bet-type').find('.betslip-multiples__bet-type__info-button');
            that.toggleMultipleInfo(multipleToggleBtn, false);
        });

        that.betslipElt.on('click taphold', '#each-way-multiples-singles', function() {
            var singlesEachWay = that.betslipElt.find('.selection-stake-details__each-way');
            singlesEachWay.find('.each-way-checkbox').prop('checked', $(this).is(':checked'));
            singlesEachWay.find('.betslip-each-way-block__text').toggleClass('selected');

            that.updatePotentialReturnsAndStakes();
        });

        that.betslipElt.on('click taphold', '.betslip-receipt-bet__header', function(e) {
            e.preventDefault();
            that.hideLoadingSpinner();
            $(this).closest('.betslip-receipt-bet').find('.betslip-receipt-bet__selections-details').toggleClass('hide');
        });

        that.betslipElt.on('click taphold', '.betslip-selections .remove', function() {
            var selectionId = $(this).data('removeSelectionId');
            const betslipSelection = $(this).closest('li');
            const isCastmarket = $(betslipSelection).hasClass('betslip-selections--castmarket');
            var isScorecast = typeof selectionId === 'string' && selectionId.indexOf('_') > -1; // No need to traverse the DOM to check the class of the selection element
            var toRemove = [];

            if (isCastmarket) {
                toRemove.push([{fc_tc: selectionId.split('_')}]);
            } else if (isScorecast) {
                toRemove.push({scorecast: selectionId.split('_')});
            } else {
                toRemove.push({single: selectionId});
            }
            betslipFancyKeyboard.fkDisappear();
            that.removeSelectionsFromBetslip(toRemove);
        });

        that.betslipElt.on('click taphold', '#betslip-clear', function clickOnClearButton(e) {
            e.preventDefault();
            e.stopPropagation();
            that.hideLoadingSpinner();

            that.removeSelectionsFromBetslip(that.selectionsIds.allSelectionsOrdered.slice(0), true);

            betslipFancyKeyboard.fkDisappear();
            that.resetBetslip();
            bbModal_close(that.betslipElt);
        });

        that.betslipElt.on('click tap', '.selection-stake-details__stake-holder, .betslip-multiples__bet-type__stake', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const elem = $(this);
            that.getSelectionFreeBets(elem);
        });

        that.betslipElt.on('click taphold', '.selection-stake-details__price--select-odds', function clickOnChosingOdds() {
            const selectionId = $(this).data('chooseOddsId');
            const selectionDetail = that.selectionsDetails[selectionId];
            const spSelected = that.betslipElt.find(`.betslip-selections[data-selection-id="${selectionId}"]`).data('selectedPriceIsSp');

            if ($(this).hasClass('selection-stake-details__price--select-odds--disabled')) {
                return false;
            }

            const bbModal = that.betslipElt.data('bbModal');
            const price = that.getPrice(selectionDetail.decimal_price, selectionDetail.fraction_price, null, selectionDetail.american_price);
            const sp = that.lang.sp;
            let popupContent = `<ul id="betslip-select-odds" data-choose-odds-id="${selectionId}">`;
            popupContent += `<li class="betslip-select-odds-choice ${(!spSelected ? 'selected' : '')}" data-value="${price}" data-bb-modal-overlay-dialog-close><span class="betslip-select-odds-price">${price}</span></li>`;
            popupContent += `<li class="betslip-select-odds-choice ${(spSelected ? 'selected' : '')}" data-value="${sp}" data-bb-modal-overlay-dialog-close> ${sp} </span></li></ul>`;

            betslipFancyKeyboard.fkDisappear();
            bbModal.loadOverlayDialogContent(popupContent);
            const openEvenIfModalClosed = true;
            bbModal.openOverlayDialog(
                'betslip-dialog betslip-dialog--select-odds',
                openEvenIfModalClosed
            );
        });

        that.betslipElt.on('click taphold', '.betslip-select-odds-choice', function selectPriceOnDialogClick() {
            var selectionId = $(this).closest('#betslip-select-odds').data('chooseOddsId');
            var selectionEl = that.betslipElt.find('.betslip-selections[data-selection-id="' + selectionId + '"]');
            var newValue = $(this).data('value');

            //update the price in the betslip view
            $("#selection-stake-details-price-" + selectionId).text(newValue);

            //update the betslip structure and the original price
            if (newValue === that.lang.sp) {
                that.userBetslip.selections[selectionId].sp_selected = true;
                that.userBetslip.originalPrices[selectionId].sp = true;
                that.originalPrices[selectionId].sp = true;
                selectionEl.data('selectedPriceIsSp', true).attr('data-selected-price-is-sp', true);
            } else {
                that.userBetslip.selections[selectionId].sp_selected = false;
                that.userBetslip.originalPrices[selectionId].sp = false;
                that.originalPrices[selectionId].sp = false;
                selectionEl.data('selectedPriceIsSp', false).attr('data-selected-price-is-sp', false);
            }

            that.updatePotentialReturnsAndStakes();
            that.synchronizeBetslip();
        });

        that.betslipElt.on('click taphold', '#betslip-receipt-continue', function resetBetslipOnContinueButtonClick(e) {
            e.preventDefault();

            if (Object.keys((that.selectionsDetails || {})).length > 0) {
                // a recommended selection might have been added from receipt
                that.checkForClearButton();
                bbModal_changePage(that.betslipElt, 0);
            } else {
                betslipFancyKeyboard.fkDisappear();
                bbModal_close(that.betslipElt);
            }
        });

        that.betslipElt.on('bbModal:closed', function betslipClosed(event) {
            that.modalIsOpened = false;
            betslipFancyKeyboard.fkDisappear();
            if (that.shouldReloadSite && event.target.getAttribute('id') === 'betslip') {
                that.shouldReloadSite = false;
                location.reload();
            }

            if (that.betslipElt && !that.betslipElt.hasClass('bb-modal-visible') && that.selectionsIds.allSelectionsOrdered.length > 0) {
                that.betslipLaunchPointContainer.removeClass('hide');
                $('.l-baby-betslip').css('display', 'block');
            }

            that.betslipTabbed.bb_tabs('select', 0); //switch to betslip

        });

        that.betslipElt.on('bbModal:opened', function openBetslip(event) {
            that.checkForClearButton();
            const hasValueFromBabyBetslip = that.setBetslipValueFromBabyBetslip();

            if (hasValueFromBabyBetslip){
                $('#betslip-get-on')
                    .removeClass('betslip-footer__get-on--disabled');
                that.updatePotentialReturnsAndStakes();
            }
            if (event.target.getAttribute('id') === 'betslip' && !hasValueFromBabyBetslip) {
                that.openKeyboardOnLoneSelection();
            }
            that.modalIsOpened = true;
            that.betslipLaunchPointContainer.addClass('hide');
            $('.l-baby-betslip').css('display', 'none');
        });

        that.betslipElt.on('click taphold', '#betslip-receipt-retain', function retainSelectionsOnButtonClick(e) {
            e.preventDefault();
            that.retainSelections(that.selectionsToRetain);
            if (that.shouldReloadSite) {
                that.storeUserBetslip();
                // don't reload until above is complete
                window.setTimeout(function refreshPage() {
                    location.reload();
                }, 0);

            }
        });

        that.betslipElt.on('click taphold', '#betslip-retain-declined-bet-only', function backToBetslipOnButtonClick(e) {
            e.preventDefault();
            that.hideLoadingSpinner();
            that.checkForClearButton();
        });

        that.betslipElt.on('click taphold', '#betslip-get-on__open-login-popup', function openLoginPopup(e) {
            e.preventDefault();
            e.stopPropagation();
            that.hideLoadingSpinner();
            betslipFancyKeyboard.fkDisappear();

            bbModal_close(that.betslipElt);
            openLoginModal();

        });

        that.betslipElt.on('click taphold', '.modal-login-btn', (e) => {
            e.preventDefault();
            openLoginModal();
        });

        $(document).on('bb_tabs.change', '.betslipTabbed', function tabbedBetslipSelectedTabDidChange(e,tab, tabContent) {
            that.populateOpenBetsTab(tab,tabContent);
        });

        $(document).off('fc_tc:betslip').on('fc_tc:betslip', function(e) {
            const { market, selected } = e.detail;
            const selections = selected.map(({ selectionId, variant }) => ({
                id: selectionId, variant, market,
            })).sort(({ variant: placeA }, { variant: placeB }) => {
                if (placeA === 'any') {
                    return 0;
                }

                return parseInt(placeA, 10) - parseInt(placeB, 10);
            });

            that.add([{
                fc_tc: selections,
            }], false, false, false, true);
        });

        const oddsToggleSwitchEvent = 'click taphold';
        const oddsToggleSwitchSelector = '.betslipOddsToggle .betslipOddsToggle__switch';
        $(document).off(oddsToggleSwitchEvent, oddsToggleSwitchSelector).on(oddsToggleSwitchEvent, oddsToggleSwitchSelector, (e) => {
            const initialValue = e.target.dataset.oddsToggle;
            const acceptOdds = initialValue === 'true' || initialValue === '1' ? false : true;
            setAcceptOddsFlag(acceptOdds).then(response => {
                if (response.ok) {
                    setCustomerAcceptOddsFlag(acceptOdds);
                    toggleAcceptOddsAllSwitches();
                }
            });

        });
    },

     /**
    * check if is a valid stake value;
    * @param value {Object}
    * @return {Boolean}
    */
    isValidStakeValue: function (value) {
        return value && value !== '0';
    },

     /**
    * Set stale value on betslip;
    * @param stakeLabel {Element}
    * @param value {String}
    */
    setStake: function (stakeLabel, value) {
        const floatValue = (value || '0').replace(',', '.')
        stakeLabel.attr('data-value', parseFloat(floatValue, 10));
        stakeLabel.data('value', parseFloat(floatValue, 10));
        stakeLabel.text(this.isValidStakeValue(value) ? value : this.lang.stake);
    },

     /**
    * Set Each way value on betslip;
    * @param stakeLabel {Element}
    * @param ew {Boolean}
    */
    setEw: function(ewCheckbox, ew) {
        ewCheckbox.prop('checked', ew);
        if (ew) {
            ewCheckbox.closest('.betslip-each-way-block').find('.betslip-each-way-block__text').addClass('selected');
        } else {
            ewCheckbox.closest('.betslip-each-way-block').find('.betslip-each-way-block__text').removeClass('selected');
        }
        ewCheckbox.trigger('stakeValueChanged');
    },

    /**
    * Set Freebet on betslip;
    * @param stakeLabel {Element}
    * @param ew {Boolean}
    */
    setFreeBet: function(stakeLabel, freeBetId){
        stakeLabel.data('freebet-id', freeBetId).attr('data-freebet-id', freeBetId);
        stakeLabel.show().siblings('.freebetVoucher').remove();
        this.drawFreebetBlock(freeBetId, stakeLabel);
        stakeLabel.trigger('stakeValueChanged');
    },

    /**
    * Get dataseeta values from BabyBetslip elements;
    * @param El {Element}
    */
    getDataFromBabyBetslip: function (El){
        return {
            value: El.attr('data-value') || '0',
            selectionId:  parseInt(El.attr('data-id'), 10),
            betType: El.attr('data-bet_type'),
            freebetId: parseInt(El.attr('data-freebet-id'), 10),
        }
    },

    /**
    * Set betslip stake with data from babybetslip, return a boolean if a valid value or freebet was setted;
    * @return {Boolean}
    */
    setBetslipValueFromBabyBetslip: function (){
        const babyBetslipStake = $('#baby-betslip-stake');
        const freebet = $('#baby-betslip-selected-freebet');

        const babyBetslipEW = $('.baby-betslip__ew-checkbox');
        const ew = babyBetslipEW.attr('data-each_way') === 'true';
        const {
           value, selectionId, betType, freebetId,
        } = this.getDataFromBabyBetslip(babyBetslipStake.length !== 0  ? babyBetslipStake : freebet);

        if (selectionId) {
            const stakeLabel = $(`#stake-selection-${selectionId}`);
            const ewCheckbox = $(`#each-way-selection-${selectionId}`);
            this.setStake(stakeLabel, value);
            this.setEw(ewCheckbox, ew);
            if (freebetId) {
                this.setFreeBet(stakeLabel, freebetId);
                return true;
            }

            const stakeLabelContainer = stakeLabel.closest('.stake-selection-container');
            stakeLabelContainer.removeClass('selection-stake-details__stake-row--stake-container_free-bet--active');
            this.setFreebetIndicator();

            return this.isValidStakeValue(value);
        } else {
            const stakeLabel = $(`#stake-multiples-${betType}`);
            const ewCheckbox = $(`#each-way-multiples-${betType}`);
            this.setStake(stakeLabel, value);
            this.setEw(ewCheckbox, ew);
            if (freebetId) {
                this.setFreeBet(stakeLabel, freebetId);
                return true;
            }

            const multiStakeLabelContainer = stakeLabel.closest('.stake-selection-container');
            multiStakeLabelContainer.removeClass('betslip-multiples__bet-type__stake-details--stake-container_free-bet--active');
            this.setFreebetIndicator();

            return this.isValidStakeValue(value);
        }
    },

     /**
    * Send betslip stake data to baby betslip and clear betslip data;
    * @return {Boolean}
    */
    setBabyBetslipValueFromBetslip: function() {
        const babyBetslipStake = $('#baby-betslip-stake');
        const freebet = $('#baby-betslip-selected-freebet');
        const {
            selectionId, betType,
        } = this.getDataFromBabyBetslip(babyBetslipStake.length !== 0  ? babyBetslipStake : freebet);

        let value;
        let ew;
        let freebetId;
        let freebetValue;

        // Clear betslip on close;
        if (selectionId) {
            const stakeLabel = $(`#stake-selection-${selectionId}`);
            const ewCheckbox = $(`#each-way-selection-${selectionId}`);
            freebetId = stakeLabel.data('freebet-id');
            value =  stakeLabel.attr('data-value');
            ew = ewCheckbox.is(':checked');

            this.setStake(stakeLabel, '');
            this.setEw(ewCheckbox, false);
            if (freebetId) {
                stakeLabel.show().siblings('.freebetVoucher').remove();
                stakeLabel.data('freebet-id', '').attr('data-freebet-id', '');
            }
        } else {
            const stakeLabel = $(`#stake-multiples-${betType}`);
            const ewCheckbox = $(`#each-way-multiples-${betType}`);
            freebetId = stakeLabel.data('freebet-id');
            value = stakeLabel.attr('data-value');
            ew = ewCheckbox.is(':checked');

            this.setStake(stakeLabel, '');
            this.setEw(ewCheckbox, false);
            if (freebetId) {
                stakeLabel.show().siblings('.freebetVoucher').remove();
                stakeLabel.data('freebet-id', '').attr('data-freebet-id', '');
            }
        }


        value = value === '0' || value === 0 ? '' : value;
        if (freebetId) {
            const freeBetType = FREEBETS_BET_TYPES[betType];
            const availableFreeBets = getAvailableFreeBets();
            ({ value: freebetValue } = availableFreeBets[freeBetType].find(({ id }) => freebetId === id));
        }

        // Send data to BabyBetslip
        if (value !== null && value !== undefined) {
            this.betslipElt.trigger('babybetslip:update_from_betslip', {
                user_input: value.toString().replace('.', ','),
                each_way_selected: ew,
                free_bet_id: freebetId,
                free_bet_value: freebetValue,
            });
        }
    },

    afterLoginSuccessCallback: function() {
        var bbModal = this.betslipElt.data('bbModal');
        bbModal.closeOverlayDialog();
        this.buildBetsStructure(this.selectionsIds, this.availableBetTypes, this.suspendedSelections);
        this.updateSelectionsToRetain(this.selectionsIds.allSelectionsOrdered);
        this.bet(this.selectedBets);
        this.changeLoginState();
    },

    changeLoginState: function() {
        this.betslipElt.find('.betslip-footer__logged-in').show();
        this.betslipElt.find('.betslip-footer__logged-out').hide();
        this.shouldReloadSite = true;
    },

    populateOpenBetsTab: function(tab, tabContent) {
        var betslip_logged_in = isUserLoggedIn();

        if (tab.data('target-id') === '#target_openbets') {
            if (betslip_logged_in === true) {
                /**
                 * OR-1379 prevent betslip bethistory from appearing on accounts/bets page. See notes earlier
                 * in this file.
                 */
                if (getState(BETSLIP_ON_OPEN_BETS_PAGE_KEY)) {
                    this.selectBetslipTab(); //switch to betslip
                    return;
                }

                this.getOpenBets();
            } else {
                /**
                 * @todo
                 * @see https://dedsert.atlassian.net/browse/GR-143
                 */
                const loginMessage = i18n.t(
                    `betslip.see_open_bets${shouldHideLogin() ? '_nolink' : ''}`,
                    { link_class: 'modal-login-btn' }
                );
                
                tabContent.empty().append(`
                    <div class="betslip-content__empty-info">${loginMessage}</div>
                    <div class="betslip-footer"></div>
                `);
            }
        } else if (tab.data('target-id') === '#target_betslip') {
            //destroy openbets app if tab is closed
            $(document).trigger(BETSLIP_OPENBETS_DESTROY_EVENT);
        }
    },

    getOpenBets: function () {
        $(document).trigger(BETSLIP_OPENBETS_LAUNCH_EVENT);
        var self = this;
        $("#betslip").on("bethistory:paginate", '#target_openbets', function() {
            $(window).scrollTop(self.betslipElt.offset().top - 30); //scroll to betslip for mobile
        });
    },

    checkForClearButton: function() {
        if (this.selectionsIds.allSelectionsOrdered.length > 0) {
            $('#betslip-clear').removeClass('betslip-title__clear__hidden');
        } else {
            $('#betslip-clear').addClass('betslip-title__clear__hidden');
        }

        betslipCheckForInstructionCard(this.selectionsIds);
    },

    /**
    * this will determinated depending the eventType given which event we should register to the websocket
    * @param {String} eventType it can be 'inplay' or 'preplay'
    * @param {Object} selectionsDetails
    * @return {Array} [{event_id: int, markets: []}]
    */
    getEventsByType: function(eventType, selectionsDetails) {
        var selectionsIds = [];
        var formattedData = {};

        for (var selectionId in selectionsDetails) {
            if ((eventType === 'inplay' && selectionsDetails[selectionId].is_inplay && !selectionsDetails[selectionId].is_outright) ||
                (eventType === 'preplay' && !selectionsDetails[selectionId].is_inplay || selectionsDetails[selectionId].is_outright)) {
                selectionsIds.push(selectionId);
            }
        }

        if (selectionsIds.length) {
            formattedData = this.formatDataToSubscribeWebsocketEvents_v2(selectionsIds, selectionsDetails);
        }

        return formattedData;
    },

    /**
     * Process selections data and into an array of objects cokmpatable with the wsInterface.(un)subscribe()
     * function
     * @param {Array} selectionIds Array of objects {single: 123} (from this.allSelectionsOrdered)
     * @param {Object} selectionsDetails from this.selectionsDetails
     * @param {String} [eventType='all'] 'preplay' or 'inplay', default 'all'
     * @returns {Array} Array of objects to pass to wsInterface.(un)subscribe()
     */
    formatDataToSubscribeWebsocketEvents_v2: function(selectionIds, selectionsDetails) {
        var formattedData = [];
        Object.keys(selectionIds).forEach(function(selectionKey) {
            if (
                typeof selectionIds[selectionKey] !== 'undefined'
                && typeof selectionIds[selectionKey].single !== 'undefined' // i.e. not scorecast
            ) {
                const selectionId = parseInt(selectionIds[selectionKey].single, 10);

                if (typeof selectionsDetails !== 'undefined'
                    && typeof selectionsDetails[selectionId] !== 'undefined') {
                    const {
                        event_id: eventId, market_id: marketId,
                    } = selectionsDetails[selectionId];
                    formattedData.push({
                        selection_id: selectionId,
                        market_id: parseInt(marketId, 10),
                        event_id: parseInt(eventId, 10),
                    });
                }
            }
        });

        return formattedData;
    },

    initWebSocketListeners: function() {
        var that = this;

        if (!$.isEmptyObject(this.mainWsHandler)) {
            this.mainWsHandler.onConnection( function betslipRegisterPreplayEvent() {
                let subscriptions = that.formatDataToSubscribeWebsocketEvents_v2(that.selectionsIds.allSelectionsOrdered, that.selectionsDetails);
                if (subscriptions.length) {
                    that.mainWsHandler.subscribe(subscriptions);
                }
            }, true);
            this.removeWsHandlerCallbacks.push(this.mainWsHandler.registerHandler('price_update', this.priceUpdateHandler, WS_HANDLER_COMPONENT_NAME));
            this.removeWsHandlerCallbacks.push(this.mainWsHandler.registerHandler('event_off', this.eventOffHandler, WS_HANDLER_COMPONENT_NAME));
            this.removeWsHandlerCallbacks.push(this.mainWsHandler.registerHandler('inplay_update', that.inplayPriceUpdateHandler, WS_HANDLER_COMPONENT_NAME));
        }
    },

    /**
    * subscribe to events updates for newly selections added to the betslip
    * @param {array} selectionsIds selection ids
    * @returns {void}
    */
    updateWebsocketEventsToListen: function(selectionsIds) {
        /**
         * @todo AM-2540 can simplify this - no need for differentiation between sockets
         */
        const inplayEvents = [];
        const preplayEvents = [];

        for (let i = 0; i < selectionsIds.length; i++) {
            const selectionId = selectionsIds[i];
            if (this.selectionsDetails[selectionId]) {
                const {
                    is_inplay: isInplay, is_outright: isOutright,
                } = this.selectionsDetails[selectionId];
                if (isInplay && !isOutright) {
                    inplayEvents.push({single: selectionId});
                } else {
                    preplayEvents.push({single: selectionId});
                }
            }
        }

        if (inplayEvents.length) {
            this.mainWsHandler.subscribe(this.formatDataToSubscribeWebsocketEvents_v2(inplayEvents, this.selectionsDetails));
        }

        if (preplayEvents.length) {
            this.mainWsHandler.subscribe(this.formatDataToSubscribeWebsocketEvents_v2(preplayEvents, this.selectionsDetails));
        }
    },

    /**
    * Normalise the inplay message to make it have the same format as the preplay one
    * @param {Object} msg
    * @return {Object} normalized message
    */
    inplayPriceUpdateHandler: function(msg) {
        var normalized = {};
        var normalizedEvent = {};
        var normalizedMarkets = [];
        //normalize the msg to make it the same as preplay to call the priceUpdate method for both
        if (typeof msg.event !== 'undefined') {
            normalizedEvent = msg.event;
            if (typeof msg.event.markets !== 'undefined') {
                for (var m in msg.event.markets) {
                    var market = msg.event.markets[m];
                    var normalizedSelections = {};
                    if (typeof market.selections !== 'undefined') {
                        for (var s in market.selections) {
                            var selection = market.selections[s];
                            normalizedSelections[selection.id] = selection;
                        }
                    }
                    market.selections = normalizedSelections;
                    normalizedMarkets.push(market);
                }
                normalizedEvent.markets = normalizedMarkets;
            }
        }

        normalized = {action: msg.action, events: [normalizedEvent]};
        BetslipController.priceUpdateHandler(normalized);

        return normalized;
    },

    /**
    * initialize the suspended list (events, markets, selections) if needed
    * @param {Object} selectionsDetails
    */
    updateSuspendedList: function(selectionsDetails) {
        if (!$.isEmptyObject(selectionsDetails)) {
            for (var selectionId in selectionsDetails) {
                if (typeof selectionsDetails[selectionId].selection_active !== 'undefined' &&
                    !selectionsDetails[selectionId].selection_active &&
                    this.suspendedSelections.indexOf(String(selectionId)) < 0) {
                    this.suspendedSelections.push(selectionId);
                }

                if (typeof selectionsDetails[selectionId].tradable !== 'undefined' &&
                    !selectionsDetails[selectionId].tradable && selectionsDetails[selectionId].is_outright &&
                    this.suspendedSelections.indexOf(String(selectionId)) < 0) {
                    this.suspendedSelections.push(selectionId);
                }

                if (typeof selectionsDetails[selectionId].market_active !== 'undefined' &&
                    !selectionsDetails[selectionId].market_active &&
                    this.suspendedMarketsSelections.indexOf(String(selectionId)) < 0) {
                    this.suspendedMarketsSelections.push(selectionId);
                }

                if (typeof selectionsDetails[selectionId].event_active !== 'undefined' &&
                    !selectionsDetails[selectionId].event_active &&
                    this.suspendedEventsSelections.indexOf(String(selectionId)) < 0) {
                    this.suspendedEventsSelections.push(selectionId);
                }
            }
        }
    },

    /**
    * Called when event_off is send for preplay
    * Suspend selections that are related to the event_id that is off
    * @param {Object} msg
    */
    eventOffHandler: function(msg) {
        var events = msg.events;
        var selections = {};

        events.forEach(function(eventId) {
            //get all selections that are in the betslip related to this event
            var selectionsEltToSuspend = $('#betslip .betslip-selections[data-event-id="' + eventId + '"]');
            if (selectionsEltToSuspend.length) {
                for (var i = 0; i < selectionsEltToSuspend.length; i++) {
                    var selectionId = $(selectionsEltToSuspend[i]).data('selectionId');
                    if (typeof selections[selectionId] === 'undefined') {
                        selections[selectionId] = {'event_active': false};
                    }
                }

                BetslipController.drawSuspendedSelections(selections);
            }
        });
    },

    /**
    *Dertermine if the inplay event is not longer active
    *@param {Object} eventDetails
    *@param {Boolean}
    */
    isInplayEventOff: function(eventDetails) {
        var eventOffStatus = ['off', 'ended', 'retired', 'manually_deactivated', 'canceled'];
        var matchStatus = (typeof eventDetails.match_status !== 'undefined') ? eventDetails.match_status.toLowerCase() : false;
        return (
                (typeof eventDetails.tradable !== 'undefined' && !eventDetails.tradable) ||
                (matchStatus && eventOffStatus.indexOf(matchStatus) >-1)
               );
    },

    /**
    * Called by preplay Event handler websocket on price_update and by inplay Event handler websocket on inplay_udate messages
    * update the view with the new price and the suspended selections
    * @param {Object} msg
    */
    priceUpdateHandler: function(msg) {
        var eventList = msg.events;
        var synchronizeBetslip = false;
        var selectionsToSuspend = [];
        var selectionsToUnsuspend = [];
        var selectionsDetailsToSuspend = {};
        var selectionsDetailsToUnsuspend = {};
        // RT-4309 new list of actually changes selections to avoid unnecessary function calls
        var selectionsToChange = [];
        var selectionId = null;
        var isInplayAction = (typeof msg.action !== 'undefined' && msg.action === 'inplay_update');
        var i;

        eventList.forEach(events => {
            var eventId = events.id;
            const isInplay = isInplayAction || (typeof events.is_inplay !== 'undefined' && Boolean(events.is_inplay));
            //check if we have this eventId into the betslip (with inplay we can have unwanted events)
            var selectionsEvent = BetslipController.betslipElt.find('.betslip-selections[data-event-id="' + eventId + '"]');
            if (selectionsEvent.length) {
                selectionsToChange.push(eventId);
                var markets = events.markets;

                //CHECK IF WE NEED TO SUSPEND OR UNSUSPEND THE RELATED SELECTIONS
                if ((typeof events.active !== 'undefined' && !events.active) ||
                    (isInplay && BetslipController.isInplayEventOff(events))) {

                    selectionsToSuspend = selectionsEvent;
                    for (i = 0; i < selectionsToSuspend.length; i++) {
                        selectionId = $(selectionsToSuspend[i]).data('selectionId');
                        if (typeof selectionsDetailsToSuspend[selectionId] === 'undefined') {
                            selectionsDetailsToSuspend[selectionId] = {'event_active': false};
                        } else {
                            selectionsDetailsToSuspend[selectionId]['event_active'] = false;
                        }
                    }
                } else if (typeof events.active !== 'undefined' ||
                    (isInplay && typeof events.tradable !== 'undefined')) {
                    //un-suspend the selection if needed
                    selectionsToUnsuspend = BetslipController.betslipElt.find('.betslip-selections--event-suspended[data-event-id="' + eventId + '"]');
                    for (i = 0; i < selectionsToUnsuspend.length; i++) {
                        selectionId = $(selectionsToUnsuspend[i]).data('selectionId');
                        if (typeof selectionsDetailsToUnsuspend[selectionId] === 'undefined') {
                            selectionsDetailsToUnsuspend[selectionId] = {'event_active': true};
                        } else {
                            selectionsDetailsToUnsuspend[selectionId]['event_active'] = true;
                        }
                    }
                }

                for (var m in markets) {
                    var marketId = markets[m].id;
                    var selectionsMarket = BetslipController.betslipElt.find('.betslip-selections[data-event-id="' + eventId + '"][data-market-id="' + marketId+ '"]');
                    var selections = markets[m].selections || {};

                    selectionsDetailsToSuspend = BetslipController
                        .addSuspendedCastmarketSelections(selectionsDetailsToSuspend, selections, eventId);

                    if (selectionsMarket.length) { //if this market is contained in the betslip
                        var marketsExtraInfo = markets[m].extra_info;

                        //CHECK IF WE NEED TO SUSPEND OR UNSUSPEND THE RELATED SELECTIONS
                        if ((typeof markets[m].active !== 'undefined' && !markets[m].active) ||
                            (isInplay && typeof markets[m].tradable !== 'undefined' && !markets[m].tradable)) {

                            selectionsToSuspend = selectionsMarket;
                            for (i = 0; i < selectionsToSuspend.length; i++) {
                                selectionId = $(selectionsToSuspend[i]).data('selectionId');
                                if (typeof selectionsDetailsToSuspend[selectionId] === 'undefined') {
                                    selectionsDetailsToSuspend[selectionId] = {'market_active': false};
                                } else {
                                    selectionsDetailsToSuspend[selectionId]['market_active'] = false;
                                }
                            }
                        } else if (typeof markets[m].active !== 'undefined' ||
                            (isInplay && typeof markets[m].tradable !== 'undefined')) {
                            //un-suspend the selection if needed
                            selectionsToUnsuspend = BetslipController.betslipElt.find('.betslip-selections--market-suspended[data-event-id="' + eventId + '"][data-market-id="' + marketId+ '"]');
                            for (i = 0; i < selectionsToUnsuspend.length; i++) {
                                selectionId = $(selectionsToUnsuspend[i]).data('selectionId');
                                if (typeof selectionsDetailsToUnsuspend[selectionId] === 'undefined') {
                                    selectionsDetailsToUnsuspend[selectionId] = {'market_active': true};
                                } else {
                                    selectionsDetailsToUnsuspend[selectionId]['market_active'] = true;
                                }
                            }
                        }

                        if (marketsExtraInfo !== null &&
                            typeof marketsExtraInfo !== 'undefined' &&
                            typeof marketsExtraInfo.place_odds_divisor !== 'undefined' &&
                            typeof marketsExtraInfo.places_paid !== 'undefined') {
                            // Update EW terms. Please note that we don't update EW allowed (ie: show/hide the checkbox) as it is too complex to handle edge cases
                            // than the gain we have to handle such rare situation.
                            var ewCheckboxes = BetslipController.betslipElt.find('.betslip-selections[data-event-id="' + eventId + '"][data-market-id="' + marketId + '"] .each-way-checkbox');
                            var placeOddsDivisor = parseInt(marketsExtraInfo.place_odds_divisor, 10);
                            var placesPaid = parseInt(marketsExtraInfo.places_paid, 10);
                            ewCheckboxes.attr('data-place-odds-divisor', placeOddsDivisor)
                                .data('placeOddsDivisor', placeOddsDivisor)
                                .attr('data-places-paid', placesPaid)
                                .data('placesPaid', placesPaid);
                        }

                        if (selections) {
                            synchronizeBetslip = BetslipController.updatePrices(selections);
                            for (selectionId in selections) {
                                var betslipSelectionEl = BetslipController.betslipElt.find('.betslip-selections[data-selection-id="' + selectionId + '"]');
                                var isOutright = typeof BetslipController.selectionsDetails[selectionId] !== 'undefined' && BetslipController.selectionsDetails[selectionId].is_outright;

                                const isSelectionInBetslip = Boolean(betslipSelectionEl.length)
                                const { active: selectionActive = false, tradable: selectionTradable = false } = selections[selectionId];
                                const isSelectionInactive = (!selectionActive || ((isInplay || isOutright) && !selectionTradable));
                                //CHECK IF WE NEED TO SUSPEND OR UNSUSPEND THE SELECTIONS
                                if (isSelectionInBetslip && isSelectionInactive) {
                                    if (typeof selectionsDetailsToSuspend[selectionId] === 'undefined') {
                                        selectionsDetailsToSuspend[selectionId] = {'selection_active': false};
                                    } else {
                                        selectionsDetailsToSuspend[selectionId]['selection_active'] = false;
                                    }
                                } else if (typeof selections[selectionId].active !== 'undefined' ||
                                    (isInplay && typeof selections[selectionId].tradable !== 'undefined')) {
                                    //un-suspend the selection if needed
                                    if (isSelectionInBetslip &&
                                        betslipSelectionEl.hasClass('betslip-selections--selection-suspended')) {
                                        if (typeof selectionsDetailsToUnsuspend[selectionId] === 'undefined') {
                                            selectionsDetailsToUnsuspend[selectionId] = {'selection_active': true};
                                        } else {
                                            selectionsDetailsToUnsuspend[selectionId]['selection_active'] = true;
                                        }
                                    }
                                }
                            }
                        } // end selections
                    } // end Market
                } //end markets loop
            } //end Events
    });

        // If no selections in BS affected - no need to execute susequent logic
        if (!selectionsToChange.length) {
            return false;
        }

        BetslipController.updateMultiplesPrices();

        if (!$.isEmptyObject(selectionsDetailsToSuspend)) {
            BetslipController.drawSuspendedSelections(selectionsDetailsToSuspend);
        }

        if (!$.isEmptyObject(selectionsDetailsToUnsuspend)) {
            BetslipController.drawUnsuspendedSelections(selectionsDetailsToUnsuspend);
        }

        if ($.isEmptyObject(selectionsDetailsToSuspend) && $.isEmptyObject(selectionsDetailsToUnsuspend)) {
            BetslipController.toggleNumberOfOddsChanges(BetslipController.betslipElt.find('.betslip-selections--odds-have-changed:not(.betslip-selections--selection-suspended, .betslip-selections--market-suspended, .betslip-selections--event-suspended)').length);
            BetslipController.updatePotentialReturnsAndStakes();
        }

        if (synchronizeBetslip) {
            BetslipController.buildBetslipStructure(BetslipController.selectionsIds, BetslipController.availableBetTypes);
            BetslipController.synchronizeBetslip();
        }
    },

    /**
     * using the updated selection-details, use the new prices to update
     * the odds for the multiple elements in the Betslip
     *
     * @returns {void}
     */
    updateMultiplesPrices: function() {
        const updatedAvailableBetTypes = getUpdatedMultipleOdds(
            BetslipController.selectionsDetails, BetslipController.availableBetTypes,
        );

        BetslipController.availableBetTypes = updatedAvailableBetTypes;
        const stateAvailableBetTypes = Object.keys(updatedAvailableBetTypes)
            .map(betTypeSlug => updatedAvailableBetTypes[betTypeSlug]);
        setAvailableBetTypes(stateAvailableBetTypes);
        BetslipController.updateMultiplesPricesHtml(updatedAvailableBetTypes);
    },

    /**
     * Update multibets prices in html elements
     *
     * @param {Object} updatedAvailableBetTypes
     * @returns {void}
     */
    updateMultiplesPricesHtml: function(updatedAvailableBetTypes) {
        const multiplesWrapper = $('#betslip-placement');

        if (multiplesWrapper.length) {
            Object.keys(updatedAvailableBetTypes).forEach(betTypeSlug => {
                const {
                    potential_returns_multiplier: newOdds,
                } = updatedAvailableBetTypes[betTypeSlug];
                const multibetBlockId = `betslip-multibet-type-${betTypeSlug}`;
                const oddsClass = 'betslip-multiples__bet-type__odds--value';
                const oddsElement = multiplesWrapper.find(`#${multibetBlockId} .${oddsClass}`);

                const htmlUpdateValue = getPriceOdds(
                    newOdds,
                    BetslipController.oddsFormat,
                    SELECTION_ODDS_DECIMAL_PRECISION_LOWER
                );

                oddsElement.text(htmlUpdateValue);
            });
        }
    },

    /**
     * Will explore the betslip elements to find castmarket-selections
     * affected by the "selections" param
     *
     * @param {Object} initialSuspendedSelections selectionId-keyed map; will be enhaced
     * @param {Object} selections selectionId-keyed object with posible suspended selections
     *
     * @returns {Object} same structure as initial, enhaced with new entries and tags
     */
    addSuspendedCastmarketSelections: function (initialSuspendedSelections, selections, eventId) {
        const selectionsThatMightAffectCastmarketBets = Object.keys(selections)
            .filter(id => !(selections[id].active));
        const affectedSelections = BetslipController
            .getAffectedCastmarketBySelectionIds(selectionsThatMightAffectCastmarketBets, eventId);

        return BetslipController
            .tagSelectionsAsInactive(initialSuspendedSelections, affectedSelections);
    },

    /**
     * Uses coordinates coordinates to betslip elements
     * that were affected by these selectionIds onWithdrawal
     *
     * @param {Array} selectionIds array of strings|numbers
     * @param {Number|String} eventId
     *
     * @returns {Array} of castmarket-selections-ids (underscore-separated strings)
     */
    getAffectedCastmarketBySelectionIds: function (selectionIds, eventId) {
        const resultSet = selectionIds.reduce((acc, currSelectionId) => {
            const affected = BetslipController
                .getAffectedCastmarketSelectionIds(currSelectionId, eventId);

            return new Set([ ...acc, ...affected ]);
        }, new Set());

        return [...resultSet];
    },

    /**
     * Uses coordinates coordinates to select betslip elements
     * that were affected by this selectionId onWithdrawal
     *
     * @param {Number|String} selectionId
     * @param {Number|String} eventId
     *
     * @returns {Array} of strings with castmarket-selections-ids (underscore-separated)
     */
    getAffectedCastmarketSelectionIds: function (selectionId, eventId) {
        const affectedCastmarketSelectionIds = [];
        const castMarketSelector = '.betslip-selections.betslip-selections--castmarket';
        const allCastmarketSelectionsSelector = `${castMarketSelector}[data-event-id="${eventId}"]`;

        BetslipController.betslipElt
            .find(allCastmarketSelectionsSelector)
            .filter(function() {
                const id = this.getAttribute('data-selection-id');

                return id.match(`\_${selectionId}|${selectionId}\_`);
            })
            .each((_, e) => {
                affectedCastmarketSelectionIds.push(e.getAttribute('data-selection-id'));
            });

        return affectedCastmarketSelectionIds;
    },

    /**
     * Tags as { selection_active: false } any selection-id existing in the initial map
     * and/or creates a new entries in the map
     *
     * @param {Object} initialSuspendedSelections selectionId-keyed map
     * @param {Array} toSuspend castmarket-selections-ids (underscore-separated strings)
     *
     * @returns {Object} same structure as initial, enhaced with new entries and tags
     */
    tagSelectionsAsInactive: function (initialSuspendedSelections, toSuspend) {
        return toSuspend.reduce(
            (acc, id) => {
                const selectionStatus = acc[id] ? {
                    ...acc[id],
                    selection_active: false,
                } : { selection_active: false };

                return {
                    ...acc,
                    [id]: selectionStatus,
                };
            },
            initialSuspendedSelections,
        );
    },

    /**
     * Updates the prices labels and related elements on the betslip
     * @param {Array} selections List of price updates
     */
    updatePrices: function(selections) {
        var synchronizeBetslip = false;

        for (var selectionId in selections) {
            // [Legacy note: EventsHandler is gone] Note that due to the way EventsHandler is made, "this" refers to the
            // EventsHandler object, rather than BetslipController, so we need to refer
            // to the latter using "BetslipController".
            if (typeof BetslipController.selectionsDetails !== 'undefined' && typeof BetslipController.selectionsDetails[selectionId] !== 'undefined') {
                var betslipSelectionEl = $('#betslip .betslip-selections[data-selection-id="' + selectionId + '"]');
                var betslipSelectionPriceLabel = betslipSelectionEl.find('.selection-stake-details__price');
                var updatedPrice = addAmericanOdds(selections[selectionId]);
                var updatedPriceLabel = '';
                var originalPriceLabel = '';
                var originalPrice = addAmericanOdds(BetslipController.originalPrices[selectionId]);
                var skipLabelUpdate = false;
                var chooseOddsEl = $('#betslip-select-odds[data-choose-odds-id="' + selectionId + '"] .betslip-select-odds-choice .betslip-select-odds-price');
                const selectionSportSlug = this.selectionsDetails[selectionId].sport;

                if (updatedPrice.sp_only) {
                    betslipSelectionPriceLabel.addClass('selection-stake-details__price--select-odds--disabled');
                    betslipSelectionEl.data('selectedPriceIsSp', true).attr('data-selected-price-is-sp', true);
                    updatedPriceLabel = this.lang.sp;
                    synchronizeBetslip = true;
                } else if (BETSLIP_RACING_SPORTS.includes(selectionSportSlug) && !updatedPrice.tradable) {
                    /**
                     * tradable flag only for preplay racing sports and inplay - this only relates to price SP (i.e. racing) so we only
                     * check for racing sports
                     * @see https://dedsert.atlassian.net/wiki/spaces/DEV/pages/2240872692/Websockets+Speakerbox+-+message+structure+and+flags
                     */
                    betslipSelectionPriceLabel.addClass('selection-stake-details__price--select-odds--disabled');
                    updatedPriceLabel = this.lang.sp;
                } else {
                    betslipSelectionPriceLabel.removeClass('selection-stake-details__price--select-odds--disabled');

                    if (BetslipController.oddsFormat === 'FRACTION') {
                        updatedPriceLabel = updatedPrice.fraction_price;
                    } else if (BetslipController.oddsFormat === 'AMERICAN') {
                        updatedPriceLabel = updatedPrice.american_price;
                    } else {
                        updatedPriceLabel = decimalPriceOdds(updatedPrice.decimal_price);
                    }

                    if (betslipSelectionEl.data('selectedPriceIsSp')) {
                        skipLabelUpdate = true;
                    }
                }

                if (BetslipController.oddsFormat === 'FRACTION') {
                    originalPriceLabel = !originalPrice.sp ? originalPrice.fraction_price : this.lang.sp;
                } else if (BetslipController.oddsFormat === 'AMERICAN') {
                    originalPriceLabel = !originalPrice.sp ? originalPrice.american_price : this.lang.sp;
                } else {
                    originalPriceLabel = !originalPrice.sp ? decimalPriceOdds(originalPrice.decimal_price) : this.lang.sp;
                }

                if (!skipLabelUpdate) {
                    betslipSelectionPriceLabel.html(updatedPriceLabel);
                }

                BetslipController.updateOddsChangedMessage(betslipSelectionEl, originalPriceLabel, updatedPriceLabel);

                if (chooseOddsEl.length) {
                    chooseOddsEl.html(updatedPriceLabel);
                }

                BetslipController.selectionsDetails[selectionId].sp_only = updatedPrice.sp_only;
                BetslipController.selectionsDetails[selectionId].fraction_price = updatedPrice.fraction_price;
                BetslipController.selectionsDetails[selectionId].decimal_price = updatedPrice.decimal_price;
            }
        }

        return synchronizeBetslip;
    },

    /**
     * Updates the message telling the user that odds have changed for a selection
     * @param  {jQuery} selection   jQuery element of the selection
     * @param  {float|string} oldPrice    The old price
     * @param  {float|string} newPrice    The new price
     */
    updateOddsChangedMessage: function(selection, oldPrice, newPrice) {
        var oldPriceEl = selection.find('.betslip-selections__odds-changed--old');
        var newPriceEl = selection.find('.betslip-selections__odds-changed--new');

        oldPriceEl.html(oldPrice);
        newPriceEl.html(newPrice);

        // Make sure the odds have changed message is hidden if prices are the same.
        if ((oldPrice != newPrice) && !selection.data('selectedPriceIsSp')) {
            selection.addClass('betslip-selections--odds-have-changed');
        } else {
            selection.removeClass('betslip-selections--odds-have-changed');
        }
    },

    /**
     * suspend selections form price update and event_off
     * and update Related contingencies selections
     * @param  {Array} selections of Jquery elements   list of selections id
     * @param  {Array} relatedContingencies
     * @param  {String} level    eg: 'market' || 'selection' || 'event'
     */
    suspendSelections: function(selections, relatedContingencies, level) {
        selections.forEach(function(betslipSelectionElt) {
            $(betslipSelectionElt).addClass('betslip-selections--' + level + '-suspended');

            //update the RC selections if this selection is RC
            if (relatedContingencies && relatedContingencies.length) {
                BetslipController.updateRelatedContingenciesWhenSuspended($(betslipSelectionElt), relatedContingencies, level);
            }
       });
    },

    /**
     * unsuspend  suspended selections form price update
     * update Related contingencies selections
     * @param  {Array} selections of Jquery Elements   list of selections id
     * @param  {Array} relatedContingencies
     * @param  {String} level
     */
    unsuspendSelections: function(selections, relatedContingencies, level) {
        selections.forEach(function(betslipSelectionElt) {
            $(betslipSelectionElt).removeClass('betslip-selections--'+ level +'-suspended');

            //update the Related contingencies in the view
            if (relatedContingencies && relatedContingencies.length) {
                BetslipController.updateRelatedContingenciesWhenUnsuspended($(betslipSelectionElt), relatedContingencies, level);
            }
        });
    },

    /**
    * Remove the related contingencies css style for the selections related to the suspended one
    * @param {Jquey Element} suspendedSelectionElt
    * @param {Array} relatedContingencies
    * @param {String} level    eg: 'market' || 'event' || 'selection'
    */
    updateRelatedContingenciesWhenSuspended: function(suspendedSelectionElt, relatedContingencies, level) {
        //update the RC selections if this selection is RC
        var $suspendedSelectionElt = $(suspendedSelectionElt);

        // Don't try to do something on a selection that is not in the betslip
        if (!$suspendedSelectionElt.length) {
            return;
        }

        var classes = $suspendedSelectionElt.attr('class').split(' ');
        if (classes.indexOf('betslip-selections--related-contingency') > -1 ||
            classes.indexOf('betslip-selections--suspended-event-related-contingency') > -1 ||
            classes.indexOf('betslip-selections--suspended-market-related-contingency') > -1 ||
            classes.indexOf('betslip-selections--suspended-selection-related-contingency') > -1
        ) {
            $suspendedSelectionElt.removeClass('betslip-selections--related-contingency');
            $suspendedSelectionElt.addClass('betslip-selections--suspended-' + level +'-related-contingency');
            var selectionId = $suspendedSelectionElt.data('selectionId');

            //update the related contingencies selections
            if (relatedContingencies.length) {
                for (var i = 0; i < relatedContingencies.length; i++) {
                    //look for the other selection with who this suspended bet is in RC with
                    var rc = relatedContingencies[i];
                    if (rc.indexOf(selectionId) > -1) {
                        //we need to know how many selections are suspended in the same RC
                        var unsuspendedSelectionsIds = [];

                        for (var j = 0; j < rc.length; j++) {
                            //convert to String as scorecast selection id is a String
                            if (BetslipController.suspendedSelections.indexOf(String(rc[j])) < 0 &&
                                BetslipController.suspendedMarketsSelections.indexOf(String(rc[j])) < 0 &&
                                BetslipController.suspendedEventsSelections.indexOf(String(rc[j])) < 0
                            ) {
                                unsuspendedSelectionsIds.push($("#betslip-selection-" + rc[j]));
                            }
                        }

                        if (unsuspendedSelectionsIds.length === 1) {
                            //if there is only one selection in the RCs that is not suspended then remove the RC class for this selection
                            $(unsuspendedSelectionsIds[0]).removeClass('betslip-selections--related-contingency');
                        }
                    }
                }
            }

            //if no more RC printed in the view hide warning label
            if (!$('.betslip-selections--related-contingency').length) {
                $('#betslip-selections-warnings').addClass('hide');
            }

        }
    },

    /**
    * Remove the related contingencies css style for the selections related to the suspended one
    * @param {Jquey Element} unsuspendedSelectionElt
    * @param {Array} relatedContingencies
    * @param {String} level    eg: 'market' || 'selection' || 'event'
    */
    updateRelatedContingenciesWhenUnsuspended: function(unsuspendedSelectionElt, relatedContingencies, level) {
        //update the RC selections if this selection is RC
        var $unsuspendedSelectionElt = $(unsuspendedSelectionElt);
        if ($unsuspendedSelectionElt.hasClass('betslip-selections--suspended-' + level + '-related-contingency')) {
            $unsuspendedSelectionElt.removeClass('betslip-selections--suspended-' + level + '-related-contingency');
            var selectionId = $unsuspendedSelectionElt.data('selectionId');
            //update the related contingencies selections
            if (relatedContingencies.length) {
                for (var i = 0; i < relatedContingencies.length; i++) {
                    //look for the other selection with who this unsuspended bet is in RC with
                    var rc = relatedContingencies[i];
                    if (rc.indexOf(selectionId) > -1) {
                        //we need to know how many selections are suspended in the same RC
                        var unsuspendedSelectionsIds = [];

                        for (var j = 0; j < rc.length; j++) {
                            //convert to String as scorecast selection id is a String
                            if (BetslipController.suspendedSelections.indexOf(String(rc[j])) < 0 &&
                                BetslipController.suspendedMarketsSelections.indexOf(String(rc[j])) < 0 &&
                                BetslipController.suspendedEventsSelections.indexOf(String(rc[j])) < 0
                            ) {
                                unsuspendedSelectionsIds.push($("#betslip-selection-" + rc[j]));
                            }
                        }

                        if (unsuspendedSelectionsIds.length > 1) {
                            //if there is more than 1 selection in the RCs that is not suspended add back the class for RC
                            for (var k = 0 ; k < unsuspendedSelectionsIds.length; k++) {
                                 $(unsuspendedSelectionsIds[k]).addClass('betslip-selections--related-contingency');
                            }
                        }
                    }
                }
            }

            //if at least RC printed in the view show warning label
            if ($('.betslip-selections--related-contingency').length) {
                $('#betslip-selections-warnings').removeClass('hide');
            }
        }
    },

    /**
     * Updates and displays the number of selections that received a price update
     * @param  {integer} count
     */
    toggleNumberOfOddsChanges: function(count) {
        if (count) {
            const acceptGetOnText = i18n.t('betslip.accept_get_on')
            $('#betslip-get-on__open-login-popup').addClass('betslip-dialog__login-get-on--odds-changed');
            $('#betslip-get-on__open-login-popup').text(acceptGetOnText);
            $('#betslip-get-on').addClass('betslip-footer__get-on--odds-changed');
            $('#betslip-get-on').text(acceptGetOnText);
            $('#betslip-odds-have-changed').removeClass('betslip-footer__odds-have-changed--hidden')
                .html(i18n.t('betslip.odds_have_changed_[n]_selections', { count: count }));
        } else {
            $('#betslip-get-on__open-login-popup').removeClass('betslip-dialog__login-get-on--odds-changed');
            $('#betslip-get-on__open-login-popup').text(i18n.t('betslip.login_get_on'));
            $('#betslip-get-on').removeClass('betslip-footer__get-on--odds-changed');
            $('#betslip-get-on').text(i18n.t('betslip.get_on'));
            $('#betslip-odds-have-changed').addClass('betslip-footer__odds-have-changed--hidden');
        }
    },

    /**
     * adds gtm for bet type info on expand/collapse
     * 
     * @param {string} input - expand/collapse of the information icon on betslip 
     */
    creatGtmForBetTypeInfoButton: function(input) {
        pushToDataLayer({
            event: GTM_BET_TYPE_INFO_EVENT, 
            parameter: `${GTM_BETSLIP};${GTM_BET_TYPE_INFO};${input}`,
            ecommerce: undefined,
        });
    },

    toggleMultipleInfo: function(multipleEl, expand) {
        if (expand) {
            $(multipleEl).addClass('betslip-multiples__bet-type__info-button--expanded');
            $(multipleEl).closest('.betslip-multiples__bet-type').find('.betslip-multiples__bet-type__description').addClass('betslip-multiples__bet-type__description--expanded')
                .end()
                .find('.betslip-multiples__bet-type__main').addClass('betslip-multiples__bet-type__main--description-expanded');
            this.creatGtmForBetTypeInfoButton(GTM_EVENT_EXPAND);
        } else {
            $(multipleEl).removeClass('betslip-multiples__bet-type__info-button--expanded');
            $(multipleEl).closest('.betslip-multiples__bet-type').find('.betslip-multiples__bet-type__description').removeClass('betslip-multiples__bet-type__description--expanded')
                .end()
                .find('.betslip-multiples__bet-type__main').removeClass('betslip-multiples__bet-type__main--description-expanded');
            this.creatGtmForBetTypeInfoButton(GTM_EVENT_COLLAPSE);
        }
    },

    showLoadingSpinner: function displayLoadingSpinner(){
        if (typeof window.bbLoader !== 'undefined') {
            window.bbLoader('show');
        }
    },

    hideLoadingSpinner: function hideLoadingSpinner(){
        if (typeof window.bbLoader !== 'undefined') {
            window.bbLoader('hide');
        }
    },

    /**
     * This method takes what's currently in the betslip that has a stake and builds the object to
     * pass to the bet() method in order to (try) to place bets.
     * @param {object} selections The current selections in the betslip
     * @param {object} multiples The current multiples in the betslip
     * @param {boolean} isFreeBetCheck Need bet structure if checking free bets on betslip
     *
     * @return {boolean} boolean
     */
    buildBetsStructure: function(selections, multiples, isFreeBetCheck = false, isBabyBetslip = false) {
        let selectedBets = {
            selections: [],
            singles: [],
            scorecast: [],
            fc_tc: [],
            multiples: [],
            channel: (getIsMobileWrapperFlag()) ? 'MOBILE' : 'WEB',
        };

        let suspendedSelections = false;

        if (selections.allSelectionsOrdered.length) {
            let selectionEl = null;

            if (selections.singles.length) {
                for (let s = 0; s < selections.singles.length; s++) {
                    const selectionId = selections.singles[s];

                    //we only bet on the selections that aren't suspended
                    if (this.suspendedEventsSelections.indexOf(String(selectionId)) < 0 &&
                        this.suspendedMarketsSelections.indexOf(String(selectionId)) < 0 &&
                        this.suspendedSelections.indexOf(String(selectionId)) < 0 &&
                        this.selectionsDetails
                    ) {
                        selectionEl = $('#betslip .betslip-selections[data-selection-id="' + selectionId + '"]');
                        const selection = this.selectionsDetails[selectionId];
                        const stakeEl = selectionEl.find(`#stake-selection-${selectionId}`);
                        const singleStake = stakeEl.data('value');
                        const freeBetId = parseInt(stakeEl.data('freebetId'), 10) || null;
                        const singleEw = selectionEl.find(`#each-way-selection-${selectionId}`);
                        const placeOddsDivisor = singleEw.data('placeOddsDivisor') || null;
                        const placesPaid = singleEw.data('placesPaid') || null;
                        const selectedPriceIsSp = selectionEl.data('selectedPriceIsSp');
                        const selectedGaElement = this.betLocateGet(selectionId) || 'unknown_component';
                        const jsIdentifier = `single_${s}`;

                        selectedBets.selections.push({
                            id: selections.singles[s],
                            price: (selection.decimal_price && !selection.sp_only && !selectedPriceIsSp) ? selection.decimal_price : 0,
                            sp: selection.sp_only || !selection.decimal_price || selectedPriceIsSp ? true : false,
                            place_odds_divisor: placeOddsDivisor,
                            places_paid: placesPaid,
                            bet_locate: selectedGaElement,
                            survey_id: this.surveySelections[selectionId] || null,
                        });

                        // If stake is empty, skip this single
                        if (!singleStake && !isFreeBetCheck) {
                            continue;
                        }

                        selectedBets.singles.push({
                            selection: selections.singles[s],
                            stake: singleStake && freeBetId === null ? parseFloat(singleStake) : 0,
                            is_each_way: singleEw.is(':checked'),
                            free_bet_id: freeBetId,
                            js_identifier: jsIdentifier,
                        });
                    } else {
                        suspendedSelections = true;
                    }
                }
            }

            if (selections.fc_tc.length) {
                for (let i = 0; i < selections.fc_tc.length; i++) {
                    const castmarketSelectionId = selections.fc_tc[i].join('_');
                    selectionEl = $('#betslip .betslip-selections[data-selection-id="' + castmarketSelectionId + '"]');
                    const stakeEl = selectionEl.find(`#stake-selection-${castmarketSelectionId}`);
                    const fctcStake = stakeEl.data('value');
                    const castmarketSelectedGaElement = this.betLocateGet(castmarketSelectionId) || 'unknown_component';
                    const isAny = this.userBetslip.selections[castmarketSelectionId].is_any;
                    const jsIdentifier = `fc_tc_${i}`;

                    //we only bet on the selections that aren't suspended
                    if (this.suspendedEventsSelections.indexOf(castmarketSelectionId) < 0 &&
                        this.suspendedMarketsSelections.indexOf(castmarketSelectionId) < 0 &&
                        this.suspendedSelections.indexOf(castmarketSelectionId) < 0
                    ) {
                        const castmarketStakeEl = $(`#stake-selection-${castmarketSelectionId}`);
                        const castmarketStake = castmarketStakeEl.data('value');
                        const castmarketFreeBetId = parseInt(castmarketStakeEl.data('freebetId'), 10) || null;

                        // If stake is empty, skip this single
                        if (!fctcStake && !isFreeBetCheck) {
                            continue;
                        }

                        selectedBets.fc_tc.push({
                            selections: selections.fc_tc[i],
                            stake: castmarketStake ? parseFloat(castmarketStake) : 0,
                            free_bet_id: castmarketFreeBetId,
                            bet_locate: castmarketSelectedGaElement,
                            js_identifier: jsIdentifier,
                            any: isAny,
                        });
                    } else {
                        suspendedSelections = true;
                    }
                }
            }

            if (selections.scorecast.length && this.selectionsDetails) {
                for (let i = 0; i < selections.scorecast.length; i++) {
                    const scorecastSelectionId = `${selections.scorecast[i][0]}_${selections.scorecast[i][1]}`;
                    selectionEl = $('#betslip .betslip-selections[data-selection-id="' + scorecastSelectionId + '"]');
                    const scorecastSelection = this.selectionsDetails[scorecastSelectionId];
                    const scorecastSelectedGaElement = this.betLocateGet(scorecastSelectionId) || 'unknown_component';

                    //we only bet on the selections that aren't suspended
                    if (this.suspendedEventsSelections.indexOf(scorecastSelectionId) < 0 &&
                        this.suspendedMarketsSelections.indexOf(scorecastSelectionId) < 0 &&
                        this.suspendedSelections.indexOf(scorecastSelectionId) < 0
                    ) {
                        const scorecastStakeEl = $('#stake-selection-' + scorecastSelectionId);
                        const scorecastStake = scorecastStakeEl.data('value');
                        const scorecastFreeBetId = parseInt(scorecastStakeEl.data('freebetId'), 10) || null;
                        const jsIdentifier = `scorecast_${i}`;

                        // If stake is empty, skip this scorecast
                        if (!scorecastStake && !isFreeBetCheck && !isBabyBetslip) {
                            continue;
                        }


                        selectedBets.scorecast.push({
                            selection: `${selections.scorecast[i][0]}_${selections.scorecast[i][1]}`,
                            first_goal_scorer_id: selections.scorecast[i][0],
                            correct_score_id: selections.scorecast[i][1],
                            stake: scorecastStake ? parseFloat(scorecastStake) : 0,
                            free_bet_id: scorecastFreeBetId,
                            price: scorecastSelection.decimal_price,
                            js_identifier: jsIdentifier,
                            bet_locate: scorecastSelectedGaElement,
                        });
                    } else {
                        suspendedSelections = true;
                    }
                }
            }

            if (typeof multiples !== 'undefined') {
                // eslint-disable-next-line guard-for-in
                for (const m in multiples) {
                    const multiple = multiples[m];
                    //if there is any suspended selection we only bet on Singles
                    if (!multiple || (suspendedSelections && multiple.id !== 1)) {
                        continue;
                    }

                    const multipleIdentfier = this.replaceSpaceWithUnderscore(multiple.name);
                    const multipleStakeEl = $(`#stake-multiples-${multipleIdentfier}`);
                    const multipleStake = multipleStakeEl.data('value');
                    const multipleFreeBetId = parseInt(multipleStakeEl.data('freebetId'), 10) || null;
                    const multipleEw = $(`#each-way-multiples-${multipleIdentfier}`);
                    const jsIdentifier = `multi_${m}`;

                    // If stake is empty, skip this multiple
                    if (!multipleStake && !isFreeBetCheck && !isBabyBetslip) {
                        continue;
                    }
                    let foldLength = multiple['fold_length'];

                    selectedBets.multiples.push({
                        multiple_id: multiple.type_id,
                        stake: multipleStake ? parseFloat(multipleStake) : 0,
                        is_each_way: multipleEw.is(':checked'),
                        fold_length: foldLength, //if nfold number of n
                        free_bet_id: multipleFreeBetId,
                        js_identifier: jsIdentifier,
                    });
                }
            }
        }

        this.selectedBets = selectedBets;

        return true;
    },

    /**
     * Get current the BetLocateArray Array or a single value
     * @param {String} selectionId selection id
     * @returns {(Array|String|Booklean)} The BetLocate array or (if a selectionId is provided) a single bet_locate
     * value for a selectionId or false if not found.
     */
    betLocateGet: function(selectionId=null) {
        if (typeof this.betLocateArray === 'undefined') {
            this.betLocateArray = {};
        }
        if (selectionId === null) {
            return this.betLocateArray;
        } else if (typeof this.betLocateArray[selectionId] === 'undefined') {
            return false;
        }

        return this.betLocateArray[selectionId];
    },

    /**
     * Add an entry to the BetLocateArray
     * @param {String} selectionId the selection id
     * @param {String} gaComponentName the GA component name
     * @returns {Void} Nothing at all
     */
    betLocateAdd: function(selectionId, gaComponentName) {
        if (typeof selectionId === 'undefined' || typeof gaComponentName === 'undefined') {
            return false;
        }
        var betLocateArray = this.betLocateGet();
        betLocateArray[selectionId] = gaComponentName;

        return true;
    },

    /**
     * Retrieve or pop an entry off the BetLocateArray
     * @param {String} selectionId the selection id the entry
     * @returns {(String|false)} The gaComponent name or Boolean false
     */
    betLocatePop: function(selectionId) {
        var betLocateArray = this.betLocateGet();
        var returnValue = false; // default
        if (typeof selectionId !== 'undefined' && typeof betLocateArray[selectionId] !== 'undefined') {
            returnValue = betLocateArray[selectionId];
            delete betLocateArray[selectionId];
        }

        return returnValue;
    },

    /**
     * Save arbitrary meta data on selections.
     *
     * Stored as arbitrary properties of the userBetslip.selection object. Stored here so
     * meta data can be persisted when betslip is rebuilt. You must edit this function to
     * add meta data. Be sure not to overwrite any existing selection data. It is likely
     * you will need to edit betslip.php and awesome_betslip_model.php (add method) if you
     * add properties.
     * NB: The 'bet_locate' property of a selection submitted to the BE contains the closest
     * element with data-ga_component attribute when the selection was added to the betslip.
     * @see {buildBetslipStructure()}
     * @returns {void}
     */
    pushSelectionMetaData: function() {
        if (this.userBetslip.selections !== undefined) {
            var bsSelections = this.userBetslip.selections;
            var savedMeta = this.savedSelectionMetaData;
            Object.keys(bsSelections).forEach(function(selectionId) {
                if (savedMeta[selectionId] === undefined) {
                    savedMeta[selectionId] = {};
                }
                savedMeta[selectionId].recommended =
                    bsSelections[selectionId].recommended !== undefined ?
                    bsSelections[selectionId].recommended : false;
                savedMeta[selectionId].recommendation_location =
                    bsSelections[selectionId].recommendation_location !== undefined ?
                    bsSelections[selectionId].recommendation_location : '';
            });
        }
    },

    /**
     * Restore saved selection meta data to the users betslip selections
     * @returns {void}
     */
    popSelectionMetaData: function() {
        if (this.userBetslip.selections !== undefined) {
            var bsSelections = this.userBetslip.selections;
            Object.keys(this.userBetslip.selections).forEach(function(selectionId) {
                bsSelections[selectionId] = BetslipController.popOneSelectionMetaData(selectionId);
            });
        }
    },

    /**
     * Restore meta data to a user betslip selection and remove it from the saved data.
     * @see {savedSelectionMetaData}
     * @param {Object} userBetslipSelection Current users selections
     * @returns {Object}
     */
    popOneSelectionMetaData: function(userBetslipSelection) {
        var selectionId = userBetslipSelection.id;
        var savedMeta = this.savedSelectionMetaData;
        if (savedMeta[selectionId] !== undefined) {
            Object.keys(savedMeta[selectionId]).forEach(function(propName) {
                userBetslipSelection[propName] = savedMeta[selectionId][propName] !== undefined ? savedMeta[selectionId][propName] : null;
            });
        }

        return userBetslipSelection;
    },

    /**
     * This method build the user new betslip object
     * pass to the synchronizeBetslip() method in order to save the user current betslip.
     * @param selections {object}  The currents selections in the betslip
     * @return {boolean}
     * BE CAREFULL : IF YOU CHANGE THIS STRUCTURE YOU WILL HAVE TO CHANGE IT AS WELL IN THE MODEL TO ADD SELECTION FROM DEEPLINK (add())
     */
    buildBetslipStructure: function(selections, availableBetTypes) {

        this.pushSelectionMetaData();

        var userBetslip = {
            selectionsOrder: [],
            selections: {},
            multiples: {},
            originalPrices: this.originalPrices,
            betLocateArray: this.betLocateArray,
        };
        var selectionEl = null;
        var selectionStakeEl = null;
        var selectionStake = null;
        var selectionId = null;
        var scorecastBet = false;
        var castmarketBet = false;

        if (selections.allSelectionsOrdered.length) {
            userBetslip.selectionsOrder = selections.allSelectionsOrdered;
            for (var s = 0; s < selections.allSelectionsOrdered.length; s++) {
                const currOrderedSelection = selections.allSelectionsOrdered[s];
                castmarketBet = (currOrderedSelection[0] && typeof(currOrderedSelection[0].fc_tc) !== 'undefined');
                scorecastBet = typeof(currOrderedSelection.scorecast) !== 'undefined';

                if (scorecastBet) {
                    selectionId = currOrderedSelection.scorecast.join('_');
                } else if (castmarketBet) {
                    selectionId = currOrderedSelection[0].fc_tc.join('_');
                } else {
                    selectionId = currOrderedSelection.single;
                }

                selectionStakeEl = $('#stake-selection-' + selectionId);
                selectionStake = selectionStakeEl.data('value');
                selectionEl = $('#betslip .betslip-selections[data-selection-id="' + selectionId + '"]');

                const isAny = castmarketBet && currOrderedSelection[0].isAny;

                userBetslip.selections[selectionId] = {
                    id: selectionId,
                    stake: (selectionStake === '') ? 0 : parseFloat(selectionStake),
                    each_way_selected: $('#each-way-selection-' + selectionId).is(':checked'),
                    free_bet_id: selectionStakeEl.data('freebetId') || null,
                    sp_selected: selectionEl.data('selectedPriceIsSp'),
                    is_scorecast: scorecastBet,
                    is_cast_market: castmarketBet,
                    is_any: isAny,
                    survey_id: this.surveySelections[selectionId] || null,
                };

                userBetslip.selections[selectionId] = this.popOneSelectionMetaData(userBetslip.selections[selectionId]);
            }

            if (availableBetTypes) {
                for (var m in availableBetTypes) {
                    var betType = availableBetTypes[m];
                    var multipleIdentfier = this.replaceSpaceWithUnderscore(betType.name);
                    var multipleStakeEl = $('#stake-multiples-' + multipleIdentfier);
                    var multipleStake = multipleStakeEl.data('value');

                    userBetslip.multiples[multipleIdentfier] = {
                        id: betType.type_id,
                        stake: (multipleStake === "") ? 0 : parseFloat(multipleStake),
                        each_way_selected: $('#each-way-multiples-' + multipleIdentfier).is(':checked'),
                        free_bet_id : multipleStakeEl.data('freebetId') || null
                    };
                }
            }
        }

        this.userBetslip = userBetslip;
        return true;
    },

    /**
     * Add an overlay to bet slip
     * @returns {void}
     */
    disabledBetSlip: function() {
        this.betslipElt.addClass('disabled');
    },

    /**
     * Remove overlay from bet slip
     * @returns {void}
     */
    enableBetSlip: function() {
        this.betslipElt.removeClass('disabled');
    },

    /**
     * Add an overlay and keep button from opening betslip
     * @returns {void}
     */
    disableBabyBetSlip: function () {
        this.betslipButton.addClass('disabled');
        this.openBetslipButton.addClass('disabled');
        $('.baby-betslip__container').addClass('disabled');
    },

    /**
     * Remove overlay from baby bet slip
     * @returns {void}
     */
    enableBabyBetSlip: function () {
        this.betslipButton.removeClass('disabled');
        this.openBetslipButton.removeClass('disabled');
        $('.baby-betslip__container').removeClass('disabled');
    },


    /**
     * This function will send the json object of bets in the betslip to PHP (and then backend)
     * in order to place bets. The bets parameter is a json object previously build by this class.
     * We pass it via a parameter rather than using a BetslipController property in order to make
     * unit testing simpler.
     *
     * @param  {object} bets Bets object. See selectedBets docblock.
     * @return {boolean}
     */
    bet: function(bets) {
        var that = this;
        $('#betslip-get-on, #betslip-get-on-odds-changed, #betslip-get-on-selection-suspended')
            .addClass('betslip-footer__get-on betslip-footer__get-on--disabled loading');

        // Disable BetSlip.
        that.disabledBetSlip();
        that.disableBabyBetSlip();

        // Add Loading to buttons.
        that.betslipGetOnButton.addClass('loading');
        $('.baby-betslip__button').addClass('loading');

        // facilitates quick lookups
        var betLocateDataBySelectionId = {};
        bets.selections.forEach(function(selection) {
            if (typeof selection.bet_locate !== 'undefined') {
                betLocateDataBySelectionId[selection.id] = selection.bet_locate;
            }
        });
        this.betLocateDataBySelectionId = betLocateDataBySelectionId;

        if (this.fancyKeyboard.isVisible) {
            this.fancyKeyboard.fkDisappear();
        }

        this.showLoadingSpinner();
        this.betslipElt.trigger('betslip:bet_request');
        $.ajax(base_url + 'betslip/bet', {
            async: true,
            cache: false,
            context: this, // Allow the use of "this" as BetslipController rather than jQuery
                           // reference in callbacks.
            data: {
                'bets': JSON.stringify(bets)
            },
            dataType: 'json',
            method: 'POST',
            type: 'POST',
            xhrFields: {
                withCredentials: true,
            },
        }).always(function() {
            if (!this.betslipElt.is(':visible')) { //open betslip if invisible for the receipt
                bbModal_open(this.betslipElt);
            }
            this.betslipElt.trigger('betslip:bet_response');
            //Remove Loading from buttons after done.
            that.betslipGetOnButton.removeClass('loading');
            $('.baby-betslip__button').removeClass('loading');
            // enable BetSlip After done.
           that.enableBetSlip();
           that.enableBabyBetSlip();
           this.hideLoadingSpinner();
        }).done(function(response) {
            that.scrollToTopOfBetslip();
            // This will handle both success and application errors (ie: bet placement has failed)
            if (response.success === true) {
                this.onSuccessfulBetPlacement(response.response);
            } else {
                this.onErrorBetPlacement(response.errno || null, response.response || null);
            }
        }).fail(function() {
            // This will handle all ajax related errors (ie: timeout, error in php, and so on..)
            this.onErrorBetPlacement(500);
        })
    },

    /**
    * Scroll back to top of the betslip on mobile
    * @returns {void}
    */
    scrollToTopOfBetslip: function() {
        const betslip = this.betslipElt;
        if (betslip.hasClass('bb-modal-visible')) {
            const scrollPosition = $(window).scrollTop();
            const topOffset = betslip.offset().top;
            if (scrollPosition > topOffset) {
                $(window).scrollTop(topOffset);
            }
        }
    },

    /**
    * When at least one bet has been placed draw receipt
    * @param datas {object}
    */
    onSuccessfulBetPlacement: function(datas) {
        if (datas && typeof(datas['bets']) !== 'undefined') {
            betPlacementSucceeded();
            this.drawReceipt(datas, this.selectionsDetails, this.userBetslip.selections);
            this.updatePotentialReturnsAndStakes();

            this.betslipElt.trigger('betslip.bet_confirmed');
            var updateOpenBetsCounterCount;
            if (this.shouldReloadSite === true) {
                updateOpenBetsCounterCount = false;
            } else {
                updateOpenBetsCounterCount = datas['totalSuccessfulBets'];
            }
            this.updateOpenBetsCounter(updateOpenBetsCounterCount);
        }
    },

    /**
    * Update the betslip openbet counter and the main header openbet counter.
    *
    * @param {integer|boolean} value The value to increment the counter to. If false the value will be fetched from the BE
    * @param {boolean} isIncrementValue Wether to increment by or set the counter to the value of "value"
    * @returns {void}
    */
    updateOpenBetsCounter: function(value = false, isIncrementValue = true) {
        var self = this;

        if (value !== false) {
            let count = parseInt(value);
            let newCount;

            if (isIncrementValue === true) {
                // just increment the counters
                let currentCount = parseInt(self.betslipOpenBetsCounter.text());
                newCount = currentCount + count;
            } else {
                newCount = count;
            }

            self.betslipOpenBetsCounter.text(newCount);
            updateWrapperOpenBetsNumber(newCount);
        } else {
            $.ajax({
                url: base_url + 'betslip/getTotalOpenBets',
                type: 'GET',
                crossDomain: false,
                xhrFields: {
                    withCredentials: true,
                },
            })
            .done(function(response) {

                //Update the respective totals
                self.betslipOpenBetsCounter.text(response);
                updateWrapperOpenBetsNumber(response);
            });
        }
    },

    onErrorBetPlacement: function(errno, datas) {
        if (this.allBetDeclinedErrorStatuses.includes(errno)) {
            // This is a top level error
            if (datas) {
                var updateBetslipFooter = true;

                datas.errors = datas.errors.filter(
                    error => this.popupOnErrorCodes.indexOf(error.id) > -1
                );

                if (datas.errors.length) {
                    // The frontend currently just handle one error at a time at bet placement
                    let pendingAction = false;
                    let priceChanged = false;
                    let selectionSuspendedMultibet = false;
                    let selectionSuspendedSingle = false;
                    let genericErrorDialogCode = false;
                    let betErrorGeneral = false;
                    let limitDialogCode = false;
                    let inplayLimitDialogCode = false;
                    const inplayWageringLimits = {event: '', amount: 0};
                    const limits = {time: 'daily', amount: 0};
                    const mapSelectionIdToCombinations = getMapSelectionIdToCombinations(datas.bets);

                    for (let i = 0; i < datas.errors.length; i++) {
                       const { id: errorCode, data: errorData } = datas.errors[i];
                       limits.amount = (errorData && errorData.remaining_limit) ? errorData.remaining_limit : 0;
                       switch (errorCode) {
                            case 'SELECTION_SUSPENDED_SINGLE':
                                selectionSuspendedSingle = getSelectionSuspendedSingle(
                                    datas.errors[i], mapSelectionIdToCombinations,
                                );
                                break;
                            case 'SELECTION_SUSPENDED_MULTIBET':
                                selectionSuspendedMultibet = datas.errors[i];
                                break;
                            case 'PLAYER_HAS_PENDING_ACTION':
                                pendingAction = true;
                                break;
                            case 'PRICE_CHANGED':
                                priceChanged = datas.errors[i];
                                break;
                            case 'CHARGE_FAILED':
                            case 'INSUFFICIENT_FUNDS':
                            case 'UNAUTHORIZED':
                                genericErrorDialogCode = errorCode;
                                break;
                            case 'REACHED_DAILY_WAGER_LIMIT':
                                limits.time = 'daily';
                                limitDialogCode = 'BET_LIMITS';
                                break;
                            case 'REACHED_WEEKLY_WAGER_LIMIT':
                                limits.time = 'weekly';
                                limitDialogCode = 'BET_LIMITS';
                                break;
                            case 'REACHED_MONTHLY_WAGER_LIMIT':
                                limits.time = 'monthly';
                                limitDialogCode = 'BET_LIMITS';
                                break;
                            case 'REACHED_DAILY_LOSS_LIMIT':
                                limits.time = 'daily';
                                limitDialogCode = 'LOSS_LIMITS';
                                break;
                            case 'REACHED_WEEKLY_LOSS_LIMIT':
                                limits.time = 'weekly';
                                limitDialogCode = 'LOSS_LIMITS';
                                break;
                            case 'REACHED_MONTHLY_LOSS_LIMIT':
                                limits.time = 'monthly';
                                limitDialogCode = 'LOSS_LIMITS';
                                break;
                            case 'CUSTOMER_EXCEEDED_SPAIN_INPLAY_WAGERING_LIMIT':
                                inplayLimitDialogCode = errorCode;
                                inplayWageringLimits.event = errorData.event_name;
                                inplayWageringLimits.amount = errorData.exceeded_live_betting_amount;
                                break;
                            case 'GEO_ERROR':
                                genericErrorDialogCode = errorCode;
                                break;
                            case 'TIME_LIMIT_REACHED':
                                genericErrorDialogCode = errorCode;
                                break;
                            default:
                                betErrorGeneral = true;
                                break;
                       }
                    }

                    if (genericErrorDialogCode) {
                        this.displayBetErrorDialog(genericErrorDialogCode);
                    } else if (inplayLimitDialogCode) {
                        this.displayBetErrorDialog(inplayLimitDialogCode, inplayWageringLimits);
                    } else if (limitDialogCode) {
                        this.displayBetErrorDialog(limitDialogCode, limits);
                    } else if (pendingAction) {
                        playerHasPendingAction();
                    } else if (priceChanged && priceChanged.data.selections.length) {
                        var updatePricesSelections = {};
                        for (var s in priceChanged.data.selections) {
                            var selection = priceChanged.data.selections[s];
                            selection.old_price_american = calculateAmericanPrice(selection.old_price_decimal);
                            selection.new_price_american = calculateAmericanPrice(selection.new_price_decimal);
                            updatePricesSelections[selection.id] = {
                                'decimal_price': selection.new_price_decimal,
                                'fraction_price': selection.new_price_fraction,
                                'american_price': selection.new_price_american,
                                'sp_only': selection.new_price_decimal === '0.00',
                            };
                        }

                        this.genericErrorHandler('changedOdds', priceChanged.data);

                        // Update the prices labels and related elements
                        var synchronize = this.updatePrices(updatePricesSelections);
                        if (synchronize) {
                            this.buildBetslipStructure(this.selectionsIds, this.availableBetTypes);
                            this.synchronizeBetslip();
                        }
                    } else if (selectionSuspendedSingle && typeof selectionSuspendedSingle.data.selections !== 'undefined') {
                        //draw the suspended selections
                        this.drawSuspendedSelections(selectionSuspendedSingle.data.selections);
                        this.genericErrorHandler('selectionSuspendedSingle', selectionSuspendedSingle.data);
                        updateBetslipFooter = false; //done already in drawSuspendedSelections()
                    } else if (selectionSuspendedMultibet && typeof selectionSuspendedMultibet.data.selections !== 'undefined') {
                        //draw the suspended selections
                        this.drawSuspendedSelections(selectionSuspendedMultibet.data.selections);
                        this.genericErrorHandler('selectionSuspendedMultibet', selectionSuspendedMultibet.data);
                        updateBetslipFooter = false; //done already in drawSuspendedSelections()
                    } else if (betErrorGeneral) {
                        this.displayBetErrorDialog();
                    }

                    if (updateBetslipFooter) { //when a selection get suspended we do already call these methods below
                        // Update potential returns and stakes
                        this.updatePotentialReturnsAndStakes();

                        // Make sure the odds have changed messages are up to date
                        this.toggleNumberOfOddsChanges(this.betslipElt.find('.betslip-selections--odds-have-changed:not(.betslip-selections--selection-suspended, .betslip-selections--market-suspended, .betslip-selections--event-suspended)').length);

                        // Make sure the submit button is enabled back after the first submit
                        this.toggleSubmitButton();
                    }
                } else {
                    this.drawReceipt(datas, this.selectionsDetails, this.userBetslip.selections);
                }
            }
        } else if (errno === 500) {
            this.displayBetErrorDialog();
        }

        console.error('bet() method failed with error', errno);
    },

    /**
    * Update the view to show the suspended selection and update the multibets, Potential Return, Get On button, and keybord
    * @param {Object} selectionsDetails eg: {selection_id: event_active: true, market_active: false, selection_active: true}
    */
    drawSuspendedSelections: function(selectionsDetails) {
        //update the corresponding list
        this.updateSuspendedList(selectionsDetails);
        //update the betslip view to mark the suspended selections
        var suspendedEvents = [];
        var suspendedMarkets = [];
        var suspendedSelections = [];
        for (var selection_id in selectionsDetails) {
            if (typeof selectionsDetails[selection_id]['event_active'] !== 'undefined' &&
                !selectionsDetails[selection_id]['event_active']) {
                suspendedEvents.push(this.betslipElt.find('.betslip-selections[data-selection-id='+ selection_id +']'));
            }

            if (typeof selectionsDetails[selection_id]['market_active'] !== 'undefined' &&
                !selectionsDetails[selection_id]['market_active']) {
                suspendedMarkets.push(this.betslipElt.find('.betslip-selections[data-selection-id='+ selection_id +']'));
            }

            if (typeof selectionsDetails[selection_id]['selection_active'] !== 'undefined' &&
                !selectionsDetails[selection_id]['selection_active']) {
                suspendedSelections.push(this.betslipElt.find('.betslip-selections[data-selection-id='+ selection_id +']'));
            }
        }

        if (suspendedEvents.length) {
            this.suspendSelections(suspendedEvents, this.contingencies, 'event');
        }

        if (suspendedMarkets.length) {
            this.suspendSelections(suspendedMarkets, this.contingencies, 'market');
        }

        if (suspendedSelections.length) {
            this.suspendSelections(suspendedSelections, this.contingencies, 'selection');
        }

        this.updateBetslipFooterOnSuspendedStateChange(true);
    },

    /**
    * Update the view to remove the suspended selection and update the multibets, Potential Return, Get On button
    * @param {Object} selectionsDetails eg: {selection_id: event_active: true, market_active: false, selection_active: true}
    */
    drawUnsuspendedSelections: function(selectionsDetails) {
        //update the betslip view to mark the suspended selections
        var unsuspendedEvents = [];
        var unsuspendedMarkets = [];
        var unsuspendedSelections = [];
        var index;

        for (var selection_id in selectionsDetails) {
            if (selectionsDetails[selection_id]['event_active']) {
                index = this.suspendedEventsSelections.indexOf(String(selection_id));
                if (index > -1) {
                    this.suspendedEventsSelections.splice(index, 1);
                    unsuspendedEvents.push(this.betslipElt.find('.betslip-selections[data-selection-id='+ selection_id +']'));
                }
            }

            if (selectionsDetails[selection_id]['market_active']) {
                unsuspendedMarkets.push(this.betslipElt.find('.betslip-selections[data-selection-id='+ selection_id +']'));
                index = this.suspendedMarketsSelections.indexOf(String(selection_id));
                if (index > -1) {
                    this.suspendedMarketsSelections.splice(index, 1);
                    unsuspendedMarkets.push(this.betslipElt.find('.betslip-selections[data-selection-id='+ selection_id +']'));
                }
            }

            if (selectionsDetails[selection_id]['selection_active']) {
                unsuspendedSelections.push(this.betslipElt.find('.betslip-selections[data-selection-id='+ selection_id +']'));
                index = this.suspendedSelections.indexOf(String(selection_id));
                if (index > -1) {
                    this.suspendedSelections.splice(index, 1);
                    unsuspendedSelections.push(this.betslipElt.find('.betslip-selections[data-selection-id='+ selection_id +']'));
                }
            }
        }

        if (unsuspendedEvents.length) {
            this.unsuspendSelections(unsuspendedEvents, this.contingencies, 'event');
        }

        if (unsuspendedMarkets.length) {
            this.unsuspendSelections(unsuspendedMarkets, this.contingencies, 'market');
        }

        if (unsuspendedSelections.length) {
            this.unsuspendSelections(unsuspendedSelections, this.contingencies, 'selection');
        }

        this.updateBetslipFooterOnSuspendedStateChange(false);
    },

    /**
    * When a selection get suspended and unsuspended we need to update the related betslip components
    * - Odds have changed in the betslip footer
    * - Toggle multibets
    * - Re-calculate the potential returns
    * - Toggle the submit buttons
    * @param {Boolean} suspended
    */
    updateBetslipFooterOnSuspendedStateChange: function(suspended) {
        BetslipController.toggleNumberOfOddsChanges(BetslipController.betslipElt.find('.betslip-selections--odds-have-changed:not(.betslip-selections--selection-suspended, .betslip-selections--market-suspended, .betslip-selections--event-suspended)').length);

        //update multibets
        BetslipController.toggleMultibets();

        //update potential returns
        BetslipController.updatePotentialReturnsAndStakes();

        //toggle the submit button (in case all selection are suspended)
        BetslipController.toggleSubmitButton();
        var betslipFancyKeyboard = this.fancyKeyboard;
        if (suspended) {
            //check the the keyboard is currently open on a suspended selection and hide it if it's true
            if (betslipFancyKeyboard.boundToElement !== null &&
                (betslipFancyKeyboard.boundToElement.hasClass('betslip-selections--market-suspended') ||
                betslipFancyKeyboard.boundToElement.hasClass('betslip-selections--event-suspended') ||
                betslipFancyKeyboard.boundToElement.hasClass('betslip-selections--selection-suspended'))) {
                betslipFancyKeyboard.fkDisappear();
            }
        }
    },

    /*
    * Initializes the array selectionsIds with the selections that are already in the betslip on page reload
    */
    initSelectionsIds: function() {
        let selections = $('#betslip').find(".betslip-selections");
        let scorecast = false;
        let selectionId = null;
        let fc_tc = false;

        for (let i = 0; i < selections.length; i++) {
            let selection = {};
            scorecast = $(selections[i]).hasClass('betslip-selections--scorecast');
            fc_tc = $(selections[i]).hasClass('betslip-selections--castmarket');
            selectionId = $(selections[i]).data('selectionId');

            this.highlightSelection(selectionId);

            if (scorecast) {
                const selectionIds = selectionId.split('_');
                selection.scorecast = [parseInt(selectionIds[0], 10), parseInt(selectionIds[1], 10)];
            } else if (fc_tc) {
                const castSelections = selectionId.split('_');
                selection.fc_tc = castSelections.map(x => { return { id: parseInt(x) }; });
            } else {
                selection.single = selectionId;
            }
            this.updateSelectionsIds(selection, true);
        }
    },

    getSelectionsIds: function() {
        return this.selectionsIds;
    },

    /**
     * Displays/Removes an overlay from multiples list
     *
     * @param  {Boolean} isAwaiting   Defines if multiples list is waiting
     *                                to be updated
     * @return {void}
     */
    mutliplesListAwaitingData(isAwaiting) {
        var action = isAwaiting ? 'addClass' : 'removeClass';
        $('#betslip-multiples-list')[action](
            'betslip-multiples__list--awaiting-data'
        );
        $('#betslip-accumulator-list')[action](
            'betslip-accumulator__list--awaiting-data'
        );
    },

    /**
     * This method improves the perception of the betslip speed.
     * It's just doing some visibility hacks before the content is being re-rendered.
     *  - Emits the event betslip:awaiting_data
     *  - Hides loading spinner
     *  - displays an overlay over available mutliples
     *  - updates the betslip counter immediately
     *
     * @param  {string}    action              Defines the customer action.
     * @param  {integer}   selectionsCounter   Amount of selections which were
     *                                         affected for a given action
     * @return {void}
     */
    betslipPerceptionOfSpeed(action, selectionsCounter) {
        this.betslipElt.trigger('betslip:awaiting_data');
        this.hideLoadingSpinner();
        this.mutliplesListAwaitingData(true);

        var betslipCounter = +(this.betslipCounterBtn.text());
        if (action === 'remove') {
            selectionsCounter *= -1;
        }
        betslipCounter += selectionsCounter;

        this.setBetslipCounter(betslipCounter > 0 && betslipCounter || 0);
    },

    /**
     * Improves perception of speed while adding selection to the betslip
     * @param {list} addedSelectionIds   List of selections ids added to betslip
     */
    addToBetslipPerceptionOfSpeed(addedSelectionIds) {
        var selectionsAmount = addedSelectionIds.length;
        this.betslipPerceptionOfSpeed('add', selectionsAmount);

        var skeletonMarkup = '<li class="betslip-selections betslip-selections--skeleton">' +
                '<span></span>' +
                '<span></span>' +
                '<span></span>' +
            '</li>';

        $('#betslip-selections-list').prepend(
            new Array(selectionsAmount + 1).join(skeletonMarkup)
        );
    },

    /**
     * Improves perception of speed while deleting selection from the betslip
     * @param {Object} removedSelectionIds   List of selections ids removed to betslip
     */
    removeFromBetslipPerceptionOfSpeed(removedSelectionIds) {
        var selectionIds = Object.keys(removedSelectionIds);
        this.betslipPerceptionOfSpeed('remove', selectionIds.length);

        selectionIds.forEach(function(selectionId) {
            $('#betslip-selection-' + selectionId).remove();
        });
    },

    /**
    * update the betslip total counter
    * @param total {Number}
    */
    setBetslipCounter: function(total) {
        var that = this;
        if (this.betslipCounterBtn !== null && this.betslipBetsCounter !== null) {
            this.betslipCounterBtn.text(total);
            this.betslipBetsCounter.text(total);
            this.betslipBetsHeaderCounter.text(total);
            if (total > 0 && !that.modalIsOpened) {
                this.betslipLaunchPointContainer.removeClass('hide');
                $('.l-baby-betslip').css('display', 'block');
            } else {
                this.betslipLaunchPointContainer.addClass('hide');
            }
            this.checkForClearButton();
        }
    },

    /**
    * store the selection to redis and get the detail for the selection
    * @param selections {Array} eg: [{single: 1 || scorecast: [2, 3](optional)}]
    * @param gaComponent {Jquery Object}
    * @param mouseClickPos {Object} Position of mouse pointer when user click
    * @param addToEnd {Bool} Add selections at the end of betslip list
    * @param shouldChangeView {Boolean} Should change to bet placement view
    * @param isDeepLinked {Boolean} Check if selections came from DeepLink
    * @param isFromRetainSelection {Boolean} check if the selection is coming from RetainSelections(), this is use for surveySelections
    * @return {Jquery Promise - Deferred}
    */
    add: function (selections, gaComponent, mouseClickPos, addToEnd, shouldChangeView, isDeepLinked, isFromRetainSelection = false) {
        var that = this;
        var selectionAdded = [];
        var unAddedSelections = [];
        var selectionId;
        var i; //loop iterator
        let fc_tc = undefined;

        var messages = [
            i18n.t('betslip.limit_message', {max: this.maxSelections}),
            i18n.t('betslip.remove_selection'),
        ];

        shouldChangeView = (typeof shouldChangeView !== 'boolean') ? true : shouldChangeView;

        //catch the lenght to be sure it's array and not a real object
        if (typeof(selections) === "object" && selections.length > 0) {
            for (i = 0; i < selections.length; i++) {
                if (this.canAddSelectionToBetslip(selections[i])) {
                    /*
                        if mobile color the selections even if we haven't call the ajax yet - this is to fake speed
                        select the added selectionsIds
                    */

                    if (selections[i].scorecast) {
                        selectionId = selections[i].scorecast.join('_');
                    } else if (selections[i].single) {
                        selectionId = selections[i].single;
                    } else if (selections[i].fc_tc) {
                        fc_tc = selections[i].fc_tc[0].market;
                        selectionId = selections[i].fc_tc.map(({id}) => id).join('_');
                    }

                    if (this.updateSelectionsIds(selections[i], addToEnd)) {
                        selectionAdded.push(selectionId);
                        this.newAddedSelections.push(selectionId);
                        // show accept odds section when selection is added to betslip
                        showHideAcceptOdds(true);
                    }

                    if (
                        !isDeepLinked
                        && !isFromRetainSelection
                        && that.surveySelections[selectionId]) {
                            delete that.surveySelections[selectionId];
                    }
                } else {
                    unAddedSelections.push(selections[i]);
                }
            }

            if (selectionAdded.length) {
                this.betslipCheckbox.prop('checked', false);
                /**
                 * Open "My Betslip" tab if selection added
                 * @since Navigation enhancements
                 */
                that.betslipTabbed.bb_tabs('select', 0); // 'My Betslip' tab

                that.addClassSelected(selectionAdded);
                that.addToBetslipPerceptionOfSpeed(selectionAdded);

                //construct the betslip object
                clearTimeout(this.betslipAddSyncTimer);
                this.betslipAddSyncTimer = setTimeout( function betslipAddSyncTimeout() {
                    that.storeUserBetslip().done(function(response) {
                        that.hideLoadingSpinner();
                        var selectionDetails = response.betslip.betslipDetails.selection_details;
                        var selectionIds = [];
                        var i;

                        //update the counter
                        that.setBetslipCounter(response.betslip.userBetslip.selectionsOrder.length);

                        for (i = 0; i < that.newAddedSelections.length; i++) {
                            selectionId = that.newAddedSelections[i];

                            // Notify rest of the site about new additon

                            that.betslipElt.trigger('betslip:added', selectionId);
                            emit(BETSLIP_SELECTION_ADDED_EVENT, {id: selectionId} );

                            selectionIds.push(selectionId);
                            // Remove the class from the button so it can be clicked again and add data-spectate-product back in
                            that.updateSelectionButtonDetails(selectionId);
                            that.updateGtmTag(selectionId, true);
                            eCommerceGTMSelection(selectionDetails[selectionId], selectionId, actionTypes[0], 'addToCart', );
                        }

                        //clean newAddedSelections from the selections we just added
                        for (i = 0; i < selectionIds.length; i++) {
                            var index = that.newAddedSelections.indexOf(selectionIds[i]);
                            that.newAddedSelections.splice(index, 1);
                        }

                        //initialise the suspendedList
                        that.updateSuspendedList(selectionDetails);

                        // Make sure the keyboard is reset after adding a new selection
                        that.fancyKeyboard.fkDisappear();

                        //update betslip view
                        that.drawBetslip(response);

                        // Make sure potential returns and stakes are up to date
                        that.updatePotentialReturnsAndStakes();

                        //change to the betslip placement view if the betslip is not already in that view ( for exemple the view is bet Receipt)
                        if (shouldChangeView && $('.bb-modal-current-page').attr('id') !== 'betslip-placement') {
                            bbModal_changePage(that.betslipElt, 0);
                        }

                        //register the selections events to get websocket updates
                        that.updateWebsocketEventsToListen(selectionIds);

                        //reset checkboxes for cast markets
                        if (fc_tc) {
                            document.dispatchEvent(new CustomEvent('fc_tc:betslip:added', {
                                detail: { market: fc_tc },
                            }));
                        }
                    }).fail(function() {
                        that.hideLoadingSpinner();
                        if (that.selectionsIds.allSelectionsOrdered.length >= that.maxSelections) {
                            that.show_bet_slip_popup(i18n.t('betslip.betslip_limit'), messages);
                        }
                    });
                }, this.betslipSyncTimeout);
            } else {
                //Either the selection is already in the betslip or the total of selection has reach the maximum
                var orderedSelections = this.selectionsIds.allSelectionsOrdered.length;
                if (orderedSelections >= this.maxSelections) {
                    if (unAddedSelections.length) {
                        orderedSelections -= unAddedSelections.filter(this.isSelectionInOrdered).length;
                    }
                    if (orderedSelections >= this.maxSelections) {
                        that.show_bet_slip_popup(i18n.t('betslip.betslip_limit'), messages);
                    }
                }
            }

            if (unAddedSelections.length && !isDeepLinked) {
                //this selection exist already in the betslip so remove it
                this.removeSelectionsFromBetslip(unAddedSelections, true);
            }
        } else {
            console.log("add() is expecting an array");
        }
    },

    /**
    * store the user betslip in redis
    * @return {jQuery Defferer}
    */
    storeUserBetslip: function() {
        var that = this;
        var deferred = new $.Deferred();

        //construct the betslip object
        this.buildBetslipStructure(this.selectionsIds, this.availableBetTypes);

        emit(BETSLIP_BEFORE_SYNC_EVENT, { userBetslip: this.userBetslip });

        //store in redis and get details
        $.ajax({
            url: base_url + 'betslip/updateSelectionToBetslip',
            type: 'POST',
            crossDomain: false,
            xhrFields: {
                withCredentials: true,
            },
            data: {betslip: JSON.stringify(this.userBetslip)}
        })
        .done(function(response) {
            if (response) {
                that.selectionsDetails = response.betslip.betslipDetails.selection_details;
                const respAvailableBetTypes = response.betslip.betslipDetails.available_bet_types;
                that.availableBetTypes = that._normalizeAvailableBetTypes(respAvailableBetTypes);
                that.contingencies = response.betslip.betslipDetails.contingencies;
                that.originalPrices = response.betslip.userBetslip.originalPrices;
                that.userBetslip.originalPrices = response.betslip.userBetslip.originalPrices;

                setState(BETSLIP_USER_BETSLIP_KEY, that.userBetslip);
                setState(BETSLIP_SELECTIONS_DETAILS_KEY, that.selectionsDetails);
                setAvailableBetTypes(respAvailableBetTypes);
                setState(BETSLIP_CONTINGENCIES_KEY, that.contingencies);

                // Notify rest of the site that Betslip has been saved in Redis
                that.betslipElt.trigger('betslip:stored');

                deferred.resolve(response);

                emit(BETSLIP_AFTER_SYNC_EVENT, { userBetslip: that.userBetslip });
            }
        })
        .fail(function() {
            deferred.reject({message: "something went wrong on adding a bet"});
        });

        return deferred;
    },

    /**
    * update the object selectionsIds with a new type of selection
    * @param selection {Object} eg: {scorecast: [firstGoalScorrerId, correctScoreId] || {selectionId: 123}
    * @param append {Boolean} (optional),
    * when append is true we push the selection at this and of the this.selectionsIds.allSelectionsOrdered Array
    * (used on page load where the selections are already ordered in the view eg: last added first is the fist in the betslip )
    * @return {Boolean}
    */
    updateSelectionsIds: function(selection, append) {
        if (typeof(selection['scorecast']) !== 'undefined') {
            var scorecasts = {
                    scorecast: [
                        parseInt(selection.scorecast[0], 10),
                        parseInt(selection.scorecast[1], 10)
                    ]
                };

            if (append) {
                this.selectionsIds.allSelectionsOrdered.push(scorecasts);
            } else {
                this.selectionsIds.allSelectionsOrdered.unshift(scorecasts);
            }
            this.selectionsIds.scorecast.push(scorecasts.scorecast);
            return true;
        }

        if (typeof(selection['single']) !== 'undefined') {
            var singles = {
                single: parseInt(selection.single, 10)
            };

            if (append) {
                this.selectionsIds.allSelectionsOrdered.push(singles);
            } else {
                this.selectionsIds.allSelectionsOrdered.unshift(singles);
            }
            this.selectionsIds.singles.push(singles.single);

            return true;
        }

        if (typeof(selection['fc_tc']) !== 'undefined') {
            const castmarket = [{
                fc_tc: selection.fc_tc.map(({id}) => parseInt(id, 10)),
                isAny: selection.fc_tc[0].variant === 'any',
            }];

            if (append) {
                this.selectionsIds.allSelectionsOrdered.push(castmarket);
            } else {
                this.selectionsIds.allSelectionsOrdered.unshift(castmarket);
            }
            this.selectionsIds.fc_tc = this.selectionsIds.fc_tc ?
                [...this.selectionsIds.fc_tc, castmarket[0].fc_tc] : [castmarket[0].fc_tc];

            return true;
        }
        return false;
    },

    /**
    * check if the selection can be added to the betslip
    * @param selection {Object}
    * @return {Boolean}
    */
    canAddSelectionToBetslip: function(selection) {
        return !this.isSelectionInOrdered(selection)
            && this.selectionsIds.allSelectionsOrdered.length < this.maxSelections;
    },

    /**
    * check if the selection is an ordered one
    * @param {Object} selection The selection object
    * @return {Boolean} boolean
    */
    isSelectionInOrdered: function(selection) {
        if (typeof(selection.scorecast) !== 'undefined') {
            for (var i = 0; i < this.selectionsIds.scorecast.length; i++) {
                if (this.selectionsIds.scorecast[i][0] === parseInt(selection.scorecast[0], 10) &&
                    this.selectionsIds.scorecast[i][1] === parseInt(selection.scorecast[1], 10)) {

                    return true;
                }
            }

            return false;
        } else {
            return (
                this.selectionsIds.singles.indexOf(parseInt(selection.single, 10)) !== -1
            );
        }
    },

    /**
    * add the selected class to a selection element
    * @param selectionIds {Array} of selections ids
    */
    addClassSelected: function(selectionIds) {
        if (typeof(selectionIds) !== 'undefined') {
            for (var i in selectionIds) {
                this.highlightSelection(selectionIds[i]);
            }
            //TODO: Button for recommender tech,betfinder adding all bets on home page
        }
    },

    /**
     * Update the GTM tag for bet buttons
     * @param {String|Number} selectionId The selection ID
     * @param {Boolean} selectionStatus The selected status of the selection
     * @return {void}
     */
    updateGtmTag: function(selectionId, selectionStatus) {
        var selectionHighlighted = $('.bb-sport-event__selection[data-selection-id="' + selectionId + '"]');
        selectionHighlighted.each(function(i) {
            var gtmAttribute = $(this).attr('data-spectate-product');
            var gtmEnd = selectionStatus ? ';remove-from-bet-slip': ';add-to-bet-slip';

            if (typeof(gtmAttribute) !== 'undefined') {
                var gtmBase = gtmAttribute.split(';');
                gtmBase.pop();
                var gtmUpdate = gtmBase.join(';') + gtmEnd;
                $(this).attr('data-spectate-product', gtmUpdate);
            }
        });
    },

    /**
     * Highlights the selection view
     * @param {String|Number} selectionId The selection ID
     * @return {void}
     */
    highlightSelection: function(selectionId) {
        $('.bb-sport-event__selection[data-selection-id="' + selectionId + '"]').addClass('bb-sport-event__selection--selected');

        if (typeof(this.selectionsDetails) !== 'undefined') {
            var selections = $('#betslip-selection-' + selectionId);
            var currentSelection = this.selectionsDetails[selectionId];

            if (typeof(currentSelection) !== 'undefined') {
                if (currentSelection.market_group_name == 'Bet Builder') {
                    selections.addClass('betslip-selections--brightbundle');
                } else {
                    selections.removeClass('betslip-selections--brightbundle');
                }
            }
        }
    },

    /**
    * remove the selected class to a selection element
    * @param selectionsIds {Object} of selections ids
    */
    removeClassSelected: function(selectionsIds) {
        if (typeof(selectionsIds) !== 'undefined') {
            for (var selectionID in selectionsIds) {
                $('.bb-sport-event__selection[data-selection-id="' + selectionID + '"]').removeClass('bb-sport-event__selection--selected');
                this.updateGtmTag(selectionID, false);
            }

            //TODO: Button for recommender tech,betfinder adding all bets on home page
        }
    },

    /**
     * Parses an array of objects with long selections name
     * @param {array} selectionName
     * @return {string} parsedSelectionName
     */
    parseSelectionName: function (selectionName) {
        var parsedSelectionName = '';
        selectionName.forEach(function(item) {
            parsedSelectionName += '<div class="long-selection">';
            parsedSelectionName += '<span class="long-selection__name">' + item.selection + '</span> ';
            parsedSelectionName += '<span class="long-selection__market">' + item.market + '</span>';
            parsedSelectionName += '</div>';
        });
        return parsedSelectionName;
    },

    /**
    * Add selection(s) to the betslip view
    * @param betslip {Object}
    */
    drawBetslip: function(betslip) {
        var suspendedSelectionsList = [];
        var betslipFancyKeyboard = this.fancyKeyboard;
        var hasBetslip = typeof(betslip) !== 'undefined';
        var hasChildBetslip = typeof(betslip['betslip']) !== 'undefined';
        var hasUserBetslip = typeof(betslip['betslip']['userBetslip']) !== 'undefined';
        var hasSelectionsOrder = typeof(betslip['betslip']['userBetslip']['selectionsOrder']) !== 'undefined';
        var hasBetslipDetails = typeof(betslip['betslip']['betslipDetails']) !== 'undefined';
        var hasAvailableBetTypes = typeof(betslip['betslip']['betslipDetails']['available_bet_types']) !== 'undefined';
        const isBogRestricted = getIsBogRestricted();
        const eachWayAllowed = getEachwayAllowed();

        if (hasBetslip &&
        hasChildBetslip &&
        hasUserBetslip &&
        hasSelectionsOrder &&
        hasBetslipDetails
        ) {
            var betslip_selections = '';
            var selections = betslip['betslip']['userBetslip']['selections'];
            var selectionInfos = betslip['betslip']['betslipDetails']['selection_details'];
            var selectionOrdered = betslip['betslip']['userBetslip']['selectionsOrder'];
            var multiples = (typeof(betslip['betslip']['betslipDetails']['available_bet_types']) !== 'undefined' && betslip['betslip']['betslipDetails']['available_bet_types'].length > 1) ? true : false;
            var relatedContingencies = typeof(betslip['betslip']['betslipDetails']['contingencies']) ? betslip['betslip']['betslipDetails']['contingencies'] : false;
            var isContengencies = false; // we cannot check just with the var relatedContingencies has scorecast bets are not included in relatedContingencies
            var betslipWarnings = false;
            let scorecastCounter = 0;
            let fcTcCounter = 0;
            let singleCounter = 0;
            let selectionOrder = 0;
            let betType = '';

            for (var i = 0; i < selectionOrdered.length; i++) {
                var classes = '';
                var selectionId = null;
                var scorecast = false;
                var suspendedSelection = false;
                var brightbundleTitle = '';
                let isCastmarket = false;

                if (typeof(selectionOrdered[i].scorecast) !== 'undefined') {
                    selectionId = selectionOrdered[i].scorecast.join('_');
                    classes = 'betslip-selections--scorecast ';
                    scorecast = true;
                    selectionOrder = scorecastCounter++;
                    betType = 'scorecast';
                } else if (selectionOrdered[i][0] && typeof(selectionOrdered[i][0].fc_tc) !== 'undefined') {
                    isCastmarket = true;
                    selectionId = selectionOrdered[i][0].fc_tc.join('_');
                    classes = 'betslip-selections--castmarket ';
                    selectionOrder = fcTcCounter++;
                    betType = 'fc_tc';
                } else {
                    selectionId = selectionOrdered[i].single;
                    selectionOrder = singleCounter++;
                    betType = 'single';
                }

                // Check if the original price of this selection is different from the updated one.
                // If so, display the odds changed message.
                var oddsHaveChanged = false;

                if (typeof this.originalPrices[selectionId] !== 'undefined') {
                    if (selectionInfos[selectionId].decimal_price !== null && this.originalPrices[selectionId].decimal_price !== null) {
                        oddsHaveChanged = parseFloat(selectionInfos[selectionId].decimal_price) !== parseFloat(this.originalPrices[selectionId].decimal_price);
                    } else {
                        if (this.originalPrices[selectionId].decimal_price !== null) {
                            oddsHaveChanged = true;
                        }
                    }
                }

                if (this.suspendedSelections.indexOf(String(selectionId)) > -1) {
                    classes += ' betslip-selections--selection-suspended ';
                    suspendedSelection = true;
                    if (suspendedSelectionsList.indexOf(selectionId) < 0) {
                        suspendedSelectionsList.push(selectionId);
                    }
                }

                if (this.suspendedMarketsSelections.indexOf(String(selectionId)) > -1) {
                    classes += ' betslip-selections--market-suspended ';
                    suspendedSelection = true;
                    if (suspendedSelectionsList.indexOf(selectionId) < 0) {
                        suspendedSelectionsList.push(selectionId);
                    }
                }

                if (this.suspendedEventsSelections.indexOf(String(selectionId)) > -1) {
                    classes += ' betslip-selections--event-suspended ';
                    suspendedSelection = true;
                    if (suspendedSelectionsList.indexOf(selectionId) < 0) {
                        suspendedSelectionsList.push(selectionId);
                    }
                }

                var contingency = this.isRelatedContingencySelection(selectionId, relatedContingencies, scorecast, multiples, suspendedSelection);
                if (!suspendedSelection && contingency) {
                    classes += ' betslip-selections--related-contingency ';
                    isContengencies = true;
                } else if (suspendedSelection && contingency) {
                    if (this.suspendedSelections.indexOf(String(selectionId)) > -1) {
                        classes += ' betslip-selections--suspended-selection-related-contingency ';
                    }

                    if (this.suspendedMarketsSelections.indexOf(String(selectionId)) > -1) {
                        classes += ' betslip-selections--suspended-market-related-contingency ';
                    }

                    if (this.suspendedEventsSelections.indexOf(String(selectionId)) > -1) {
                        classes += ' betslip-selections--suspended-event-related-contingency ';
                    }
                }

                if (!isCastmarket &&
                    (!(selections[selectionId].sp_selected) && oddsHaveChanged
                    || (!this.originalPrices[selectionId]['sp'] && selectionInfos[selectionId].sp_only))) {
                    classes += 'betslip-selections--odds-have-changed ';
                }

                var selection_details = '<div class="selection-details">';

                if (isCastmarket) {
                    const {
                        selection_names: selectionNames,
                    } = selectionInfos[selectionId];
                    const { is_any: isAny } = selections[selectionId];
                    const selectionsHtml = selectionNames.map((name, idx) => {
                        const place = isAny ? '' : i18n.t(`racing.fctc_header_${idx + 1}`);
                        const placeHtml = `<span class="selection-details__place">${place}</span>`;
                        const fcTcName = `${name}${placeHtml}`;
                        return `<span class="selection-details__name block-elt">${fcTcName}</span>`;
                    });
                    selection_details += selectionsHtml.join('');
                } else {
                    // This is for betbuilder, it is used to format the betbuilder name when it exists
                    var selectionDetailsName = selectionInfos[selectionId].selection_name;
                    if (selectionInfos[selectionId].selection_long_name) {
                        selectionDetailsName = this.parseSelectionName(
                            selectionInfos[selectionId].selection_long_name
                        );
                    }
                    selection_details += '<span class="selection-details__name block-elt">' + selectionDetailsName +'</span>';
                }
                selection_details += '<span class="selection-details__market-name block-elt">' + selectionInfos[selectionId].market_name +'</span>';
                selection_details += '<span class="selection-details__event-name block-elt">';
                selection_details += selectionInfos[selectionId].is_outright ? selectionInfos[selectionId].tournament_name : selectionInfos[selectionId].event_name + ' ';
                if (BETSLIP_RACING_SPORTS.indexOf(selectionInfos[selectionId].sport) > -1) {
                    selection_details += '<time dynamic-legacy-date datetime="' + selectionInfos[selectionId].scheduled_start + '" />';
                }
                selection_details += '</span>';

                if (selectionInfos[selectionId].each_way_allowed && eachWayAllowed) {
                    const ewTerms = i18n.t('sports.ew_conditions', {
                        divisor: selectionInfos[selectionId].place_odds_divisor,
                        places: selectionInfos[selectionId].places_paid,
                    });
                    const ewPlus = selectionInfos[selectionId].each_way_plus;
                    const ewPlusClass = ewPlus ? 'selection-details__ew-plus-text' : '';
                    const ewPlusIcon = ewPlus ? `<span class="selection-details__ew-plus-icon">${i18n.t('racing.ew_plus')}</span>` : '';
                    selection_details += `
                        <span class="selection-details__ew-terms block-elt">
                            ${i18n.t('sports.ew_terms')}:
                            <span class="${ewPlusClass}">${ewTerms}</span>
                            ${ewPlusIcon}
                        </span>
                    `;
                }
                selection_details += '</div>';

                var each_way = '';
                if (selectionInfos[selectionId].each_way_allowed && eachWayAllowed) {
                    each_way += '<div class="selection-stake-details__each-way betslip-each-way-block">';
                    each_way += '<input type="checkbox" id="each-way-selection-' + selectionId + '" data-place-odds-divisor="' + selectionInfos[selectionId].place_odds_divisor + '" data-places-paid="' + selectionInfos[selectionId].places_paid + '" data-spectate-product="' + GTM_BETSLIP + ';' + GTM_EW_ENABLE + '" name="each-way-selection-' + selectionId + '" class="each-way-checkbox" ' + (selections[selectionId].each_way_selected ? 'checked' : '') + '/>';
                    each_way += '<label for="each-way-selection-' + selectionId + '"></label>';
                    each_way += '<span class="selection-stake-details__each-way__text betslip-each-way-block__text">' + this.lang.ew + '</span>';
                    each_way += '</div>';
                }

                var stakeValue = (parseFloat(selections[selectionId].stake) > 0) ? parseFloat(selections[selectionId].stake).toFixed(2) : '';
                var stakeValueLabel = (stakeValue === '' ) ? this.lang.stake : stakeValue;
                var stake_row = '<div class="selection-stake-details__stake-row">';
                stake_row += '<div class="selection-stake-details__stake-row--stake-container stake-selection-container">';
                stake_row += '<label id="stake-selection-' + selectionId + '" data-id="' + selectionId + '" data-value="' + stakeValue +'" data-freebet-id="' + (selections[selectionId].free_bet_id || '') + '" data-spectate-product="' + GTM_BETSLIP + ';' + GTM_STAKE + '" name="stake-selection-' + selectionId + '" class="selection-stake-details__stake-holder fancyKeyboard-bindable">'+ stakeValueLabel + '</label>';
                stake_row += '</div>';

                stake_row += each_way;
                stake_row += '</div>';

                var stake_price = this.getPrice(selectionInfos[selectionId].decimal_price, selectionInfos[selectionId].fraction_price, selectionInfos[selectionId].sp_only || selections[selectionId].sp_selected, selectionInfos[selectionId].american_price);
                var stake_classes = ([1, 121, 122].indexOf(selectionInfos[selectionId].market_id) > -1) ? 'selection-stake-details__price--select-odds' : '';
                stake_classes += selectionInfos[selectionId].sp_only ? ' selection-stake-details__price--select-odds--disabled' : '';

                var selection_stake_details = '<div class="selection-stake-details';
                selection_stake_details += '">';

                selection_stake_details += '<span id="selection-stake-details-price-' + selectionId +'" class="selection-stake-details__price block-elt ' + stake_classes + '" data-choose-odds-id=' + selectionId + '>' + stake_price + '</span>';

                var return_label = '<label for="stake-selection-' + selectionId + '" class="selection-stake-details__single-return-block">'
                    + i18n.t('betslip.return') +': <span class="selection-stake-details__single-return">'
                    + formatCurrency('0.00')
                    + '</span></label>';

                selection_stake_details += stake_row;
                selection_stake_details += return_label;
                selection_stake_details += '</div>';
                const freeBetType = `${betType}_${selectionOrder}`

                var betslip_selection = '<li id="betslip-selection-' + selectionId + '" data-freebet-type="' + freeBetType + '" class="betslip-selections ' + classes + '" data-selection-id="' + selectionId + '" data-market-id="' + selectionInfos[selectionId].market_id + '" data-event-id="' + selectionInfos[selectionId].event_id + '" data-selected-price-is-sp="' + (selectionInfos[selectionId].sp_only || selections[selectionId].sp_selected ? 'true' : 'false') + '" data-original-price="' + this.getPrice(selectionInfos[selectionId].decimal_price, selectionInfos[selectionId].fraction_price, selectionInfos[selectionId].sp_only) + '" data-sport-slug="' + selectionInfos[selectionId].sport + '">';
                if (!isBogRestricted && (selectionInfos[selectionId].bog_singles || selectionInfos[selectionId].bog_multiples)) {
                    betslip_selection += '<span class="racing-bog-header betslip-bog"><i class="racing-bog-header__icon"></i>' + i18n.t('racing.bog') + '</span>';
                }
                if (selectionInfos[selectionId].boosted_odds === 1) {
                    betslip_selection += `<span class="boosted_odds-banner"><i class="boosted_odds-banner__icon"></i>${i18n.t('boosted_odds.title')}</span>`;
                }
                betslip_selection += brightbundleTitle;
                if (selectionInfos[selectionId].sport === '888-special') {
                    betslip_selection += '<span class="specials-banner">' +
                        '<i class="specials-banner__icon"></i>' +
                        i18n.t('specials.title') + '</span>';
                }
                betslip_selection += '<div class="selection__content">';
                betslip_selection += '<span class="remove" data-market-name="' + selectionInfos[selectionId].market_name + '" data-spectate-product="betslip;remove-from-bet-slip" data-remove-selection-id="' + selectionId + '"></span>';
                betslip_selection += selection_details + selection_stake_details;
                betslip_selection += '</div>';
                betslip_selection += '<div class="betslip-selections__odds-changed">' + i18n.t('betslip.odds_changed');
                betslip_selection += '<span class="betslip-selections__odds-changed--old">' + this.getPrice(this.originalPrices[selectionId].decimal_price, this.originalPrices[selectionId].fraction_price, false, this.originalPrices[selectionId].american_price) + '</span>';
                betslip_selection += '<span class="betslip-selections__odds-changed--new">' + this.getPrice(selectionInfos[selectionId].decimal_price, selectionInfos[selectionId].fraction_price, selectionInfos[selectionId].sp_only, selectionInfos[selectionId].american_price) + '</span>';
                betslip_selection += '</div>';
                betslip_selection += '<div class="betslip-selections__suspended">' + i18n.t('betslip.selection_suspended') + '</div>';
                betslip_selection += '</li>';
                betslip_selections += betslip_selection;
            }

            if (isContengencies) {
                betslipWarnings = i18n.t('betslip.selections_cannot_be_combined');
            }

            // close keyboard if it is still visible
            if (betslipFancyKeyboard.isVisible) {
                betslipFancyKeyboard.fkDisappear();
            }

            if (betslipWarnings) {
                $("#betslip-selections-warnings").html(betslipWarnings).removeClass('hide');
            } else {
                $("#betslip-selections-warnings").addClass('hide');
            }

            $("#betslip-selections-list").html(betslip_selections);
            $('time[dynamic-legacy-date]').updateDynamicDateLegacy();
        }

        const notFcTcSelectionsCount = getNotFcTcSelectionsCount(betslip.betslip.userBetslip.selectionsOrder);

        if (hasBetslip &&
        hasBetslipDetails &&
        hasAvailableBetTypes &&
        notFcTcSelectionsCount > 1) {
            var betslipAccumulator = '';
            var betslipMultiples = '';
            var template = '';
            var availableBetTypes = betslip.betslip.betslipDetails.available_bet_types;
            var suspendedSelectionsCount = suspendedSelectionsList.length;

            for (var bt in availableBetTypes) {
                var betType = availableBetTypes[bt];
                var multipleIdentfier = this.replaceSpaceWithUnderscore(betType.name);
                var totalAvailableBets = (betType.name.toLowerCase() === 'singles' && suspendedSelectionsCount) ? betType.total - suspendedSelectionsCount : betType.total;
                var isAccumulator = betType.name === 'Accumulator';
                var odds = getPriceOdds(
                    betType.potential_returns_multiplier,
                    this.oddsFormat,
                    SELECTION_ODDS_DECIMAL_PRECISION_LOWER
                );

                // reset template if it is accumulator
                if (isAccumulator) {
                    template = '';
                } else {
                    template = betslipMultiples;
                }

                template += '<li id="betslip-multibet-type-' + multipleIdentfier + '" class="betslip-multiples__bet-type " data-type-id="' + multipleIdentfier + '" data-freebet-available="' + betType.free_bet_available + '">';
                template += '<div class="betslip-multiples__bet-type__main">';
                template += '<a href="#" class="betslip-multiples__bet-type__info-button"></a>';
                template += '<div class="betslip-multiples__bet-type__data">';
                template += '<span class="betslip-multiples__bet-type__name">' + i18n.t(`bet_types.name.${betType.name}`) + '</span>';
                template += '<span class="betslip-multiples__bet-type__total"> (' + totalAvailableBets + ')</span>';
                template += '<p class="betslip-multiples__bet-type__odds">' + i18n.t(`betslip.odds`) + ': <span class="betslip-multiples__bet-type__odds--value">' + odds + '</span></p>';
                template += '<p class="betslip-multiples__bet-type__returns">' + i18n.t('betslip.returns') + ': <span class="betslip-multiples__bet-type__returns--value" id="betslip-multiples-type-' + multipleIdentfier + '-returns">0.00</span></p>';
                template += '</div>';
                template += '<div class="betslip-multiples__bet-type__stake-details">';
                template += '<div class="betslip-multiples__bet-type__stake-details--stake-container stake-selection-container">';
                template += '<label id="stake-multiples-' + multipleIdentfier + '" data-id="' + multipleIdentfier + '" data-spectate-product="' + GTM_BETSLIP + ';' + GTM_STAKE + '" data-value="" class="betslip-multiples__bet-type__stake fancyKeyboard-bindable">' + this.lang.stake + '</label>';
                template += '</div>';
                if (betType.each_way_allowed && eachWayAllowed) {
                    template += '<div class="betslip-multiples__bet-type__each-way betslip-each-way-block">';
                    template += '<input type="checkbox" id="each-way-multiples-' + multipleIdentfier + '" data-spectate-product="' + GTM_BETSLIP + ';' + multipleIdentfier + ';' + GTM_EW_ENABLE + '" name="each-way-multiples-' + multipleIdentfier + '" class="each-way-checkbox"/>';
                    template += '<label for="each-way-multiples-' + multipleIdentfier + '"></label>';
                    template += '<span class="betslip-multiples__bet-type__each-way__text betslip-each-way-block__text">' + this.lang.ew + '</span>';
                    template += '</div>';
                }
                template += '</div></div>'; // Close "stake-details" and "main"
                template += `<div class="betslip-multiples__bet-type__description">${i18n.t(`bet_types.desc.${betType.name}`)}<div>`;
                template += '</li>';

                // use the template in the proper container
                if (isAccumulator) {
                    betslipAccumulator = template;
                } else {
                    betslipMultiples = template;
                }
            }

            var accumulatorBetsListElt = $('#betslip #betslip-accumulator-list');
            accumulatorBetsListElt.html(betslipAccumulator);

            var multibetsListElt = $('#betslip #betslip-multiples-list');
            multibetsListElt.html(betslipMultiples);
            this.mutliplesListAwaitingData(false);

            var multiplesCounter = availableBetTypes.length;
            multiplesCounter = multiplesCounter >= 6 ? (multiplesCounter-1) : multiplesCounter;

            //if any suspended selection disable multibets
            if (suspendedSelectionsList.length > 0) {
                accumulatorBetsListElt.addClass('betslip-accumulator__list--disabled');
                multibetsListElt.addClass('betslip-multiples__list--disabled');
                //if at least on selection suspended only show singles
                $('#betslip #betslip-multiples-counter').html(1)
                    .attr('data-multiples-counter', multiplesCounter);
            } else {
                accumulatorBetsListElt.removeClass('betslip-accumulator__list--disabled');
                multibetsListElt.removeClass('betslip-multiples__list--disabled');
                $('#betslip #betslip-multiples-counter').html(multiplesCounter)
                    .attr('data-multiples-counter', multiplesCounter);
            }

            if (!this.areAllSelectionsSuspended()) {
                this.betslipElt.find('#betslip-accumulator').removeClass('betslip-accumulator__panel--hidden');
                this.betslipElt.find('#betslip-multiples').removeClass('betslip-multiples__panel--hidden');
            } else {
                this.betslipElt.find('#betslip-accumulator').addClass('betslip-accumulator__panel--hidden');
                this.betslipElt.find('#betslip-multiples').addClass('betslip-multiples__panel--hidden');
            }
        } else {
            //if drawBetslip() from removing a selection from betslip and only one type available
            this.betslipElt.find('#betslip-multiples').addClass('betslip-multiples__panel--hidden'); //no multibets to be seen
            this.betslipElt.find('#betslip-multiples-list').empty();
            this.betslipElt.find('#betslip-multiples-counter').html(0).attr('data-multiples-counter', 0);
        }

        if (isContengencies || notFcTcSelectionsCount < 4) {
            this.betslipElt.find('#betslip-accumulator').addClass('betslip-accumulator__panel--hidden'); //no multibets to be seen
            this.betslipElt.find('#betslip-accumulator-list').empty();
        } else {
            this.betslipElt.find('#betslip-accumulator').removeClass('betslip-accumulator__panel--hidden');
        }

        this.getAllFreeBets();

        //update the number of selections with price changes
        this.toggleNumberOfOddsChanges(this.betslipElt.find('.betslip-selections--odds-have-changed:not(.betslip-selections--selection-suspended, .betslip-selections--market-suspended, .betslip-selections--event-suspended)').length);

        //update the get on button
        this.toggleSubmitButton();
    },

    /**
    * the should create the bet receipt view
    * @param bets {Object}
    * @param selectionsDetails {Object}
    * @param userBetslipSelection {Object}
    */
    drawReceipt: function(bets, selectionsDetails, userBetslipSelection) {
        var betReceiptSuccessBets = '';
        var betReceiptDeclinedBets = '';
        var successSelectionIds = [];
        const isBogRestricted = getIsBogRestricted();

        const originalSelectionNamesById = getOriginalSelectionNamesById(selectionsDetails);

        if (!bets || typeof(bets['bets']) === 'undefined' || !selectionsDetails) {
            return;
        }

        /*
            clear all stakes from the betslip
            this step is placed in the top because what ever the user clicks *continue/ back to betslip/ retain
            all stakes should be empty
        */
        this.resetUserEntry();
        this.declinedSelectionsToRetain = [];

        var prices = bets.prices;
        let hasFreeBet = false;

        for (var i = 0; i < bets['bets'].length ; i++) {
            var bet = bets['bets'][i];
            let isBog = false;
            let is888Special = false;
            let isBoostedOdds = false;
            if (bet.bet_type.toLowerCase() === 'singles') {
                const [betSelectionId] = bet.selection_ids;
                isBog = selectionsDetails[betSelectionId].bog_singles;
                is888Special = selectionsDetails[betSelectionId].sport === '888-special';
                isBoostedOdds = selectionsDetails[betSelectionId].boosted_odds === 1;
            } else if (bet.bet_type.toLowerCase() === 'multiples') {
                isBog = bet.selection_ids.some(selectionId => selectionsDetails[selectionId].bog_multiples);
                is888Special = bet.selection_ids.some(selectionId => selectionsDetails[selectionId] === '888-special');
                isBoostedOdds = bet.selection_ids.some(selectionId => selectionsDetails[selectionId].boosted_odds === 1);
            }

            var betRow = "";
            var betHeaderSelections = '';
            var betName;
            var isScorecast = bet.bet_type.toLowerCase() === "scorecast";
            const isCastMarket = bet.bet_type.toLowerCase() === 'forecast' || bet.bet_type.toLowerCase() === 'tricast';
            var price;

            var betInfoSign = (bet.success) ? "check-sign-icon" : "red-decline-sign-icon";
            var betStatus = '<span class="' + betInfoSign + ' betslip-receipt-bet__info">';
            betStatus += i18n.t(`betslip.${bet.success ? 'bet_placed' : 'bet_declined'}`);
            betStatus += '</span>';
            var selectionLongName;
            let castmarketId = '';

            if (isCastMarket) {
                castmarketId = getCastmarketId(bets['bets'], bet, selectionsDetails);
            }

            // Add values to data layer for GTM
            eCommerceGTMPurchase(bet, prices, selectionsDetails, castmarketId);

            if (isScorecast) {
                //scorecast bet we pass the array of ids
                if (!bet.success) {
                    this.declinedSelectionsToRetain.push({scorecast: bet.selection_ids});
                } else {
                    successSelectionIds.push({scorecast: bet.selection_ids});
                }
            } else if (isCastMarket) {
                //cast bet we pass the array of ids
                if (!bet.success) {
                    this.declinedSelectionsToRetain.push([{fc_tc: bet.combinations}]);
                } else {
                    successSelectionIds.push([{fc_tc: bet.combinations}]);
                }
            } else {
                for (var kd in bet.selection_ids) {
                    if (!bet.success) {
                        this.declinedSelectionsToRetain.push({single: bet.selection_ids[kd]});
                    } else {
                        successSelectionIds.push({single: bet.selection_ids[kd]});
                    }
                }
                selectionLongName = selectionsDetails[bet['selection_ids'][0]].selection_long_name;
            }

            if (hasFreeBet === false && bet.free_bet_id !== null) {
                hasFreeBet = true;
            }

            if (bet['selection_ids'].length > 1 && !isScorecast) {
                betName = i18n.t(`bet_types.name.${bet.bet_type}`);
                betHeaderSelections = '<span class="betslip-receipt-bet__total-selections">(' + i18n.t('betslip.selection', {count: bet.selection_ids.length}) + ')</span>';
            } else {
                if (isScorecast) {
                    betName = selectionsDetails[bet['selection_ids'].join('_')].selection_name;
                } else if (isCastMarket) {
                    betName = bet.combinations.map(sId => originalSelectionNamesById[sId]).join(', ');
                } else {
                    betName = selectionsDetails[bet['selection_ids'][0]].selection_name;

                    if (selectionLongName) {
                        betName = selectionsDetails[bet['selection_ids'][0]].market_name;
                    }
                }
            }

            var receiptHeader = `<a href="#" class="betslip-receipt-bet__header">
                <span class="betslip-receipt-bet__name-container">
                    <span class="betslip-receipt-bet__name">${betName} ${betHeaderSelections}</span>
                    <span class="betslip-receipt-bet__dropdown"></span>
                </span>
                ${betStatus}
            </a>`;

            var betSelectionDetails = '<ul class="betslip-receipt-bet__selections-details hide">';

            if (isScorecast) {
                var scorecastSelectionId = bet['selection_ids'].join('_');
                price = this.getPrice(
                    decimalPriceOdds(prices[scorecastSelectionId].decimal),
                    prices[scorecastSelectionId].fraction,
                    prices[scorecastSelectionId].decimal === 0 || userBetslipSelection[scorecastSelectionId].sp_selected,
                    calculateAmericanPrice(prices[scorecastSelectionId].decimal)
                );
                betSelectionDetails += '<li>' + selectionsDetails[scorecastSelectionId].selection_name + ' <span class="betslip-receipt-bet__selections-details__selection-odds"> ' + price + '</span> ' + selectionsDetails[scorecastSelectionId].event_name + '</li>';
            } else if (isCastMarket) {
                const details = selectionsDetails[castmarketId];
                const fcTcName = bet.combinations
                    .map((sId, idx) => {
                        const place = i18n.t(`racing.fctc_header_${idx + 1}`);
                        const name = originalSelectionNamesById[sId];
                        const placeHtml = (details.is_any) ? '' : ` <span class="betslip-receipt-bet__selections-details__place">${place}</span>`;

                        return `${name}${placeHtml}`;
                    }, '')
                    .join(', ');

                betSelectionDetails += `
                    <li>
                        ${fcTcName}
                        <div>
                            <span class="betslip-receipt-bet__selections-details__selection-odds">
                                ${i18n.t('betslip.sp')}
                            </span>
                            ${details.event_name}
                        </div>
                    </li>
                `;
            } else {

                for (var j = 0; j < bet['selection_ids'].length; j++) {

                    // If it's betbuilder we display the selection name differently to normal selection names
                    selectionLongName = selectionsDetails[bet['selection_ids'][j]].selection_long_name;
                    const selectionDetailsName = selectionLongName ? this.parseSelectionName(selectionLongName) : selectionsDetails[bet['selection_ids'][j]].selection_name;

                    price = this.getPrice(
                        decimalPriceOdds(prices[bet['selection_ids'][j]].decimal),
                        prices[bet['selection_ids'][j]].fraction,
                        prices[bet['selection_ids'][j]].decimal === 0 || userBetslipSelection[bet['selection_ids'][j]].sp_selected,
                        calculateAmericanPrice(prices[bet['selection_ids'][j]].decimal)
                    );
                    betSelectionDetails += '<li>' + selectionDetailsName + ' <span class="betslip-receipt-bet__selections-details__selection-odds"> ' + price + '</span> ' + selectionsDetails[bet['selection_ids'][j]].event_name + '</li>';
                }
            }

            const freeBetIcon = (bet.free_bet_id !== null) ? '<span class="betslip-receipt-bet__free-bet"></span>' : '';
            let betErrorMsg = '';

            if (bet.success) {
                betSelectionDetails += '<li class="betslip-receipt-bet__bet-id">' + i18n.t('betslip.bet_id') + ': ' + bet.id + '</li>';
                betSelectionDetails += '<div class="bet-content">';

                if (bet.each_way) {
                    betSelectionDetails += '<p class="betslip-receipt-bet__stake-row"> <span class="betslip-receipt-bet__stake">'
                    + this.lang.stake + ': ' + '</span> <span class="betslip-receipt-bet__stake--value">'
                    + formatCurrency(bet.stake)
                    + '</span>'+ ' ' + this.lang.ew
                    + ' <span class="betslip-receipt-bet__total-stake">(' + i18n.t('betslip.total_stake') + ' </span>' + '<span class= "betslip-receipt-bet__total-stake--value">'
                    + formatCurrency(bet.total_stake)
                    + ')</span>'
                    + freeBetIcon
                    + '</p>';
                } else {
                    betSelectionDetails += '<p class="betslip-receipt-bet__stake-row"> <span class="betslip-receipt-bet__stake">'
                    + this.lang.stake + ': ' + '</span> <span class="betslip-receipt-bet__stake--value"> '
                    + formatCurrency(bet.stake)
                    + '</span>'
                    + freeBetIcon
                    + '</p>';
                }

                betSelectionDetails += '<span class="betslip-receipt-bet__potential-return">' + i18n.t('betslip.potential_returns') + ': ' + '</span> <span class="betslip-receipt-bet__potential-return betslip-receipt-bet__potential-return--value">'
                      + ((typeof bet.potential_returns !== 'undefined')
                          ? formatCurrency(bet['potential_returns'])
                          : this.lang.na) + '</span>';
                          betSelectionDetails += '<div>';
            } else {

                const {
                    id,
                    info,
                } = bet.error;

                const {
                    minimum_odds_allowed: minOdds,
                    stake_allowed: stakeAllowed,
                } = info || {}; // if null or undefined

                const param = formatCurrency(
                    minOdds || stakeAllowed,
                    null,
                    null,
                    !minOdds,
                    true,
                    DEFAULT_DECIMAL_PLACES
                );
                const msg = i18n.t(`betslip.${getI18nBetErrorKey(id)}`, { param });
                betErrorMsg += `<p class="betslip-receipt-bet__error-msg">${msg}</p><div>`;
            }

            betSelectionDetails += '</ul>';
            betRow += '<li class="betslip-receipt-bet">';
            if (isBog && !isBogRestricted) {
                betRow += `<span class="racing-bog-header betslip-bog"><i class="racing-bog-header__icon"></i>${i18n.t('racing.bog')}</span>`;
            }
            if (is888Special) {
                betRow += `<span class="specials-banner"><i class="specials-banner__icon"></i>${i18n.t('specials.title')}</span>`;
            }
            if (isBoostedOdds) {
                betRow += `<span class="boosted_odds-banner"><i class="boosted_odds-banner__icon"></i>${i18n.t('boosted_odds.title')}</span>`;
            }
            betRow += receiptHeader;
            betRow += betSelectionDetails;
            betRow += betErrorMsg;
            betRow += '</li>';

            if (bet.success) {
                betReceiptSuccessBets += betRow;
            } else {
                betReceiptDeclinedBets += betRow;
            }
        }


        // Remove selections ids that have been declined from the successful ones array in case they
        // are there because of a multibet that has been placed.
        // Also the labelled for loops are ugly, but since we can't object.indexOf(subObject), we have
        // to use the loops :(
        var realSuccessSelectionIds = [];
        successFor: for (var sid in successSelectionIds) {
            let successfulId = successSelectionIds[sid].single;
            if (typeof successSelectionIds[sid].scorecast !== 'undefined') {
                successfulId = successSelectionIds[sid].scorecast.join('_');
            }
            if (successSelectionIds[sid][0] && typeof successSelectionIds[sid][0].fc_tc !== 'undefined') {
                successfulId = successSelectionIds[sid][0].fc_tc.join('_');
            }

            declinedFor: for (var did in this.declinedSelectionsToRetain) {
                let declinedId = this.declinedSelectionsToRetain[did].single;
                if (typeof this.declinedSelectionsToRetain[did].scorecast !== 'undefined') {
                    declinedId = this.declinedSelectionsToRetain[did].scorecast.join('_');
                }
                if (this.declinedSelectionsToRetain[did][0] && typeof this.declinedSelectionsToRetain[did][0].fc_tc !== 'undefined') {
                    declinedId = this.declinedSelectionsToRetain[did][0].fc_tc.join('_');
                }

                if (successfulId === declinedId) {
                    continue successFor;
                }
            }

            realSuccessSelectionIds.push(successSelectionIds[sid]);
        }

        successSelectionIds = realSuccessSelectionIds;

        var betsList = '';
        if (betReceiptSuccessBets.length > 0) {
            betsList += `<div id="betslip-receipt__content__success">
                            <div class="betslip-receipt-msg-success">
                                ${i18n.t('betslip.your_bet_placed_good_luck')}
                            </div>
                            <ul class="betslip-receipt-bets betslip-receipt-bets--success">${betReceiptSuccessBets}</ul>
                        </div>`;
            const shouldRetainSurveySelections = !isEmpty(this.surveySelections);
            // Remove the successfull bets from the view and userBetslip redis and reconstruct multibets
            this.removeSelectionsFromBetslip(successSelectionIds, true, false, shouldRetainSurveySelections);
        }

        if (betReceiptDeclinedBets.length > 0) {
            betsList += '<div id="betslip-receipt__content__declined">' +
                        '<ul class="betslip-receipt-bets betslip-receipt-bets--declined">' +betReceiptDeclinedBets + '</ul>' +
                        '<a href="#" id="betslip-retain-declined-bet-only" data-bb-modal-changepage="0">' + this.lang.back + '</a></div>';
        }

        if (!successSelectionIds.length) { //all single selections are declined
            //remove stakes form multibets
            $('.betslip-multiples__bet-type__stake').val('');
            //synchronize the bet declined's stakes and multibets
            this.buildBetslipStructure(this.selectionsIds, this.availableBetTypes);
            this.synchronizeBetslip();
            this.updatePotentialReturnsAndStakes();
        }

        const freeBetIcon = hasFreeBet ? '<span class="betslip-receipt-bet__free-bet"></span>' : '';

        $('#betslip-receipt__content').html(betsList);
        $('#betslip-receipt__total-stake').html(formatCurrency(bets.total_stake) + freeBetIcon);
        $('#betslip-receipt__potential-return').html((bets.total_potential_returns !== null)
          ? formatCurrency(bets['total_potential_returns'])
          : this.lang.na);
        $('#betslip-balance').removeClass('betslip-title__balance--hidden');
        this.handleDisplayTaxMessage('betslip-receipt__tax-message', bets.total_potential_returns);

        //show the receipt to user
        bbModal_changePage("#betslip", $('#betslip-get-on').attr('data-bb-modal-page'));

        emit(BETSLIP_BET_PLACED_EVENT, {
            bets: bets,
            selectionsDetails: selectionsDetails,
            userBetslipSelection: userBetslipSelection,
            successSelectionIds: successSelectionIds
        });

        const receiptSwitch = document.querySelector('#betslipOddsToggle-bet-receipt .betslipOddsToggle__switch');
        if (receiptSwitch) {
            toggleAcceptOdds(receiptSwitch);
        }

        this.checkForClearButton();
    },

    /**
    * get the price according to the user betting preferences
    * @param decimal {number}
    * @param fraction {float}
    * @param sp_only {Boolean}
    * @return price {String}
    */
    getPrice: function(decimal, fraction, sp_only, american = null) {

        if (sp_only || decimal === null) {
            return this.lang.sp;
        } else {
            switch (this.oddsFormat) {
                case 'FRACTION':
                    return fraction;
                case 'AMERICAN':
                    return american;
                default:
                    return decimalPriceOdds(decimal);
            }
        }
    },

    /**
    * Reset all var from the betslip and empty the view
    */
    resetBetslip: function() {
        $('#betslip-selections-list').empty().hide().show('fast'); //hide/show is a workaround for forcing IE to recalculate styles for clearing a betsliip
        $('#betslip-selections-warnings').addClass('hide');
        //clear Multibets if there is any
        if (!$.isEmptyObject(this.availableBetTypes)) {
            $('#betslip-accumulator').addClass('betslip-accumulator__panel--hidden');
            $('#betslip-accumulator-list').empty();
            $('#betslip-multiples').addClass('betslip-multiples__panel--hidden');
            $('#betslip-multiples-list').empty();
            $('#betslip-multiples-counter').text(0).attr('data-multiples-counter', 0);
            this.availableBetTypes = {};
        }
        this.selectionsIds = {allSelectionsOrdered: [], singles: [], scorecast: [], fc_tc: []};
        this.setBetslipCounter(0);
        this.selectionsDetails = {};
        this.selectedBets = null;
        this.contingencies = [];
        this.originalPrices = {};
        this.resetBetReceipt();
        this.toggleNumberOfOddsChanges(0);
        this.toggleSubmitButton();
        this.updatePotentialReturnsAndStakes();
        this.declinedSelectionsToRetain = [];
        this.selectionsToRetain = [];
        this.suspendedSelections = [];
        this.suspendedMarketsSelections = [];
        this.suspendedEventsSelections = [];
        this.toggleMultibets();
        this.userBetslip = {originalPrices: {}};
        this.betslipSaveChangesSyncTimer = null;
        this.betslipRemoveSyncTimer = null;
        this.betslipAddSyncTimer = null;
        this.betLocateArray = {};
        this.newAddedSelections = [];
        this.hideLoadingSpinner();
    },

    show_bet_slip_popup: function(title, messages) {
        this.hideLoadingSpinner();
        this.displayBetErrorDialog('BETSLIP_LIMIT');
    },

    toggleSubmitButton: function() {
        var enabled = false;
        var multibetsStakes = null;
        var selections = null;
        //if not all bets suspended
        if (!this.areAllSelectionsSuspended()) {
            selections = this.betslipElt.find('.betslip-selections:not(.betslip-selections--selection-suspended, .betslip-selections--event-suspended, .betslip-selections--market-suspended)');
            var stakes = selections.find('.selection-stake-details__stake-holder');

            stakes.each(function() {
                if (parseFloat($(this).data('value'))) {
                    enabled = true;
                    return false; // Just need one input with a stake to enable the button
                }
            });

            if (this.getTotalSuspendedSelections()) {
                //only single multibets availables
                multibetsStakes = this.betslipElt.find('#stake-multiples-singles');
            } else {
                multibetsStakes = this.betslipElt.find('.betslip-multiples__bet-type__stake');
            }

            multibetsStakes.each(function() {
                if (parseFloat($(this).data('value'))) {
                    enabled = true;
                    return false;
                }
            });
        }

        if (enabled) {
            $('#betslip-get-on').removeClass('betslip-footer__get-on--disabled');
            $('#betslip-need-stake-to-get-on').addClass('betslip-footer__need-stake--hidden');
        } else {
            $('#betslip-get-on').addClass('betslip-footer__get-on--disabled');
            $('#betslip-need-stake-to-get-on').removeClass('betslip-footer__need-stake--hidden');
        }
    },

    /*
        This function is used to round from .5 down (potential returns pre bet placement)
        roundHalfDown round a number down from .5 to coincide with how it works on the BE (potential returns on bet receipt)
        BE rounds the number to the floor value by design
    */
    roundHalfDown: function(n) {
        return -Math.round(-n*100) / 100;
    },

    /**
     * Calculate potential returns based on a list of stakes and prices
     * @param singlesReturn {Number}
     * @param multiplesReturn {Number}
     * @return {Number}
     */
    calculateTotalPotentialReturns: function(singlesReturn, multiplesReturn) {
        return bsNumber(parseFloat(singlesReturn) + parseFloat(multiplesReturn));
    },

    /**
    * Recursive method
    * Caclulate a potential return for each possible combination
    * we do care about each way bets when we do calculate the potential return for a combination
    *
    * @param selections {Array} of objects
    * @param depth {Number} how deep with need to loop
    * @param relatedContingencies {Array} eg: [[123, 569], [7896, 56, 87]] (set of related contingencies bets)
    * @param isEachWay {Boolean}
    * @param index {Number} (optionial) index to dertermine where the loop must start
    * @return {Float} return the Total potential return for each combination found
    *
    * eg:   selections = [{A}, {B}, {C}]
    *       depth = 2 //find comnination for doubles multibet and for each calculate the potential return
    *       relatedContengencies = [A, B]
    *       isEachWay = false
    *       Different Combinations => [A, C], [B, C] -- carefull related contingencies if no RC [A, B], [A, C], [B, C]
    *       Total potential Return = (A.price * C.price) + (B.price * C.price)
    */
    getCombinations: function(selections, depth, relatedContingencies, isEachWay, index) {

        var totalCombination = 1;
        var totalPotentialReturn = 0;
        var totalPlacePart = 1;

        if (!depth) {

            if (!this.combinationLegal(selections, relatedContingencies)) {
                //no legal because of related contingencies
                return 0;
            }

            for (var s1 = 0; s1 < selections.length; s1++) {
                if (isEachWay) {
                    //for eachWay we calculate first the place bet and the win bet together
                    var eachWayReturns = this.calculateEachWayReturn(selections[s1].eachWay.divisor, selections[s1].price); //place + win
                    // then we extract the place part
                    var place = eachWayReturns - selections[s1].price; //place part
                    //in order to multiply all place part in between them
                    totalPlacePart *= place ;
                }
                //we multiply all the wins together
                totalCombination *= selections[s1].price; // win part
            }

            if (isEachWay) {
                totalCombination += totalPlacePart; // all place part + all win parts
            }

            return totalCombination;
        }

        depth--;

        if (!index) {
            index = 0;
        }

        for (var s2 = index; s2 < selections.length; s2++) {
            var reducedSelection = selections.slice(0);
            reducedSelection.splice(s2,1);
            totalPotentialReturn += this.getCombinations(reducedSelection, depth, relatedContingencies, isEachWay, s2);
        }
        return totalPotentialReturn;
    },

    /**
    * look if the Array of objects (Selections) are a valid combination against the selections that are in the array relatedContingencies
    * @param selections {Array} of objects
    * @param relatedContingencies {Array}
    * @return {Boolean}
    */
    combinationLegal: function(selections, relatedContingencies) {
        var selectionIds = $.map(selections, function(selection) { return selection.selectionId;});

        for (var rc in relatedContingencies) {
            var common = [];

            for (var selection in relatedContingencies[rc]) {
                if (selectionIds.indexOf(relatedContingencies[rc][selection]) > -1) {
                    common.push(relatedContingencies[rc][selection]);
                }
            }

            if (common.length >= 2) {
                // if there are at least 2 selections in common this combination is not legal
                return false;
            }
        }

        return true;
    },

    /**
    * calculate the potential return for one or many multibets
    * @param stakes {Object}
    * eg: {
    *   singles: [
    *       {
    *            price: 2,
    *            stake: 1,
    *            eachWay: { isSet: true, divisor: 1.02}
    *        }
    *    ],
    *    multiples: [
    *        {
    *            type: 1,
    *            stake: 1,
    *            isEachWay: true
    *        }
    *    ]
    *}
    * @param relatedContingencies {Array} eg: [[123, 569], [7896, 56, 87]] (set of related contingencies bets)
    * @return potentialReturn {Float}
    */
    calculateMultiBetsPotentialReturn: function(stakes, relatedContingencies) {
        var potentialReturn = 0;
        var i, m;

        //calculate total potential return for each multibets
        for (m = 0; m < stakes.multiples.length; m++) {
            var multiple = stakes.multiples[m];
            if (multiple.type === 2  || multiple.type === 3 ) {
                // 2 => Doubles, 3 => Trebles
                // stakes.singles.length - multiple.type
                // the total of selections minus the multibet id (2 or 3) indicates how deep we should loop to get all combination for this types
                potentialReturn += this.getCombinations(stakes.singles, stakes.singles.length - multiple.type, relatedContingencies, multiple.isEachWay) * multiple.stake;
            } else if (multiple.type === 26) {
                // 26 => Type accumulator, Each N Folds are now Accumulator types
                // so for one multibet with the id 26 we can have a name like '4 Folds', '5 Folds', ..., 'N Folds'
                // the total of selections minus the number of folds indicates how deep we should loop to get all combination for the type of Fold
                var fold = multiple['foldLength']; //length is the number of folds
                potentialReturn += this.getCombinations(stakes.singles, stakes.singles.length - fold, relatedContingencies, multiple.isEachWay) * multiple.stake;
            } else if (multiple.type === 21) {
                //Trixie  = Doubles + Trebles
                potentialReturn += this.getCombinations(stakes.singles, stakes.singles.length - 2, relatedContingencies, multiple.isEachWay) * multiple.stake;
                potentialReturn += this.getCombinations(stakes.singles, stakes.singles.length - 3, relatedContingencies, multiple.isEachWay) * multiple.stake;
            } else if (multiple.type < 25) {
                //case 22: lucky 15 => Singles + Doubles + Trebles + 4 selections accumulator
                //case 23: lucky 31 => Singles + Doubles + Trebles + 4 selections accumulators + 5 selections accumulator
                //case 24: lucky 63 => Singles + Doubles + Trebles + 4 selections accumulators + 5 selections accumulators + 6 selections accumulator
                potentialReturn += this.sumSelectionsPrice(stakes.singles, multiple.isEachWay) * multiple.stake; // Calculate singles
                for (i = 2; i <= stakes.singles.length; i++ ) {
                    potentialReturn += this.getCombinations(stakes.singles, stakes.singles.length - i, relatedContingencies, multiple.isEachWay) * multiple.stake;
                }
            } else if (multiple.type <= 30) {
                //case 25: Yankee => Doubles + Trebles + 4 selections accumulator
                //case 27: Canadian => Doubles + Trebles + 4 selections accumulator + 5 selections accumulator
                //case 28: Heinz => Doubles + Trebles + 4 selections accumulator + 5 selections accumulator + 6 selections accumulator
                //case 29: Super Heinz => Doubles + Trebles + 4 selections accumulator + 5 selections accumulator + 6 selections accumulator + 7 selections accumulator
                //case 30: Goliath => Doubles + Trebles + 4 selections accumulator + 5 selections accumulator + 6 selections accumulator + 7 selections accumulator + 8 selections accumulator
                for (i = 2; i <= stakes.singles.length; i++ ) {
                    potentialReturn += this.getCombinations(stakes.singles, stakes.singles.length - i, relatedContingencies, multiple.isEachWay) * multiple.stake;
                }
            }

            if (multiple.isFreeBet) {
                if (multiple.isEachWay) {
                    potentialReturn = (potentialReturn / 2);
                }
                potentialReturn -= multiple.stake;
            }
        }

        return this.roundHalfDown(potentialReturn);
    },

    /**
    * Sum all selections prices together (used for mulibets lucky numbers)
    * @param selections {Array} of Object eg: [{price: 1, stake: 2}, etc..]
    * @parem isEachWay {Boolean}
    */
    sumSelectionsPrice: function(selections, isEachWay) {
        var total = 0;
        var that = this;

        selections.filter(function(selection) {
            if (isEachWay) {
                total += that.calculateEachWayReturn(selection.eachWay.divisor, selection.price);
            } else {
                total += selection.price;
            }
        });

        return total;
    },
    /**
    * Return the potential return for a single bet or an array of bets
    * @param selection {Object} eg: {price: 2, stake: 1, sp: false, freebet: false, eachWay: {isSet: false, divisor: 1}}
    */
    calculateSingleBetPotentialReturn: function(selection) {
        var potentialReturn = 0;

        if (selection.sp) {
            return this.lang.na;
        }

        var singlePotentialReturn = selection.stake * selection.price;

        // If it's a freebet, the stake must be subtracted from the return.
        if (selection.isFreeBet) {
            singlePotentialReturn = singlePotentialReturn - selection.stake;
        }

        if (selection.eachWay.isSet) {
            var eachWayReturn = this.calculateEachWayReturn(selection.eachWay.divisor, selection.price);

            if (selection.isFreeBet) {
                singlePotentialReturn  = eachWayReturn * (selection.stake/2); //in case of a freebet we need to divide the stake in half as we cannot increase it
                singlePotentialReturn -= selection.stake; //we do not include the freebet as a potential return
            } else {
                singlePotentialReturn = eachWayReturn * selection.stake;
            }
        }

        potentialReturn += singlePotentialReturn;

        return this.roundHalfDown(potentialReturn);
    },

    /**
    * Calculate each way for a given price and a given divisor
    * @param divisor {Float}
    * @param price {Float}
    * @return {Float}
    */
    calculateEachWayReturn: function(divisor, price) {
        //the stake will be multiplied to the eachWay return after calling this method this is because this method is called in singles and multiples
        //we consider the stake to be 1 in the formula,
        //Formula : (stake / divisor) * (price - 1) + stake

        var eachWayDivisor = parseFloat(divisor);
        var eachWayReturn = ((price - 1) / eachWayDivisor) + 1;

        return price + eachWayReturn;
    },

    /**
    * - Updates returns for selections and multibets that have a stake defined
    * - Update the potential returns and total stakes
    * If any price is SP, then the for the concerned selection or multibet return and total potential returns is not calculated.
    */
    updatePotentialReturnsAndStakes: function() {
        var that = this;
        var selections = this.betslipElt.find('.betslip-selections:not(.betslip-selections--selection-suspended, .betslip-selections--event-suspended, .betslip-selections--market-suspended)').find('.selection-stake-details__stake-holder');
        var multibets = this.betslipElt.find('.betslip-multiples__bet-type__stake');
        var stakes = {singles: [], multiples: []}; // This is passed to the calculatePotentialReturns object to calc the total potential returns
        var singlesReturns = 0; //Total single bet return
        var multiplesReturn = 0; //Total multibets return
        var potentialReturns = 0; // singlesReturns + multiplesReturn
        var totalStake = 0;
        var spSelected = false; // if there is at least on selection that is SP
        var spWithStake = false; //if there is an SP in the betslip that is related to a stake (single or multiple)
        var equalSinglesStakes = true; //determine if all the single stakes are different do not calculate single multibets if stake in multibet defined
        var previousStake = null;
        var totalSuspended = that.getTotalSuspendedSelections();

        selections.each(function calculatePotentialReturnsForEachSingle() {
            var singleReturn = $(this).closest('.selection-stake-details').find('.selection-stake-details__single-return');
            var selectionId = $(this).closest('[data-selection-id]').data('selectionId');
            var selectedPriceIsSp = $(this).closest('[data-selection-id]').data('selectedPriceIsSp');
            var selectionDetails = that.selectionsDetails[selectionId];
            var price = parseFloat(decimalPriceOdds(selectionDetails.decimal_price));
            var stake = bsNumber(deLocalizeNumberString($(this).data('value').toString()) || 0);
            var eachWayCheckbox = $('#each-way-selection-' + selectionId);
            var selectionFreeBet = $(this).data('freebetId') ? true : false ;
            var single = {};
            var singleBetReturn = 0;
            var spSelectedForThisSelection = false;

            // this is needed to check if all selections stakes are the same for the multibet type 1 -Singles-
            if (previousStake === null) {
                previousStake = stake;
            } else if (stake !== previousStake) {
                equalSinglesStakes = false;
            }

            if (selectionDetails.sp_only || selectionDetails.decimal_price === null || selectedPriceIsSp) {
                spSelected = true;
                spSelectedForThisSelection = true;
            }

            //if the selection is not a scorecast selection we add it to the array of selection in order to
            //calculate the multiple combination for multibets
            single = {
                selectionId: selectionId,
                price: price,
                stake: stake,
                eachWay: {
                    isSet: eachWayCheckbox.is(':checked') ? true : false,
                    divisor: eachWayCheckbox.data('placeOddsDivisor')
                },
                isFreeBet: selectionFreeBet
            };

            if (!selectionDetails.is_scorecast) {
                stakes.singles.push(single);
            }

            if (stake === 0) {
                singleReturn.html(formatCurrency('0.00'));
                return;
            }

            if (spSelectedForThisSelection) {
                singleReturn.html(that.lang.na);
                spWithStake = true;
            } else {
                singleBetReturn = that.calculateSingleBetPotentialReturn(single);
                singlesReturns += singleBetReturn;
                singleReturn.html(formatCurrency(singleBetReturn));
            }

            if (eachWayCheckbox.is(':checked') && !selectionFreeBet) {
                stake *= 2;
            }

            if (selectionDetails.is_cast_market && that.userBetslip.selections[selectionId].is_any) {
                let multiplier = 1;
                const selectionCount = selectionDetails.selection_names.length;
                // forecast has 2 selections, tricast has 3 selections
                if (selectionCount === 2) {
                    multiplier = 2;
                } else if (selectionCount === 3) {
                    multiplier = 6;
                }

                stake *= multiplier;
            }

            //Total stake calculation PART 1 (singles)
            //add each single stakes to the total stake
            totalStake += stake;
        });

        if (!$.isEmptyObject(that.availableBetTypes)) {
            multibets.each(function calculatePotentialReturnsForEachMultibets() {
                var multibetId = $(this).data('id');
                var multibetElement = $('#betslip-multibet-type-' + multibetId);
                var multiBetStake = bsNumber($(this).data('value') || 0);
                var singleMultibetReturn = multibetElement.find('#betslip-multiples-type-' + multibetId + '-returns');
                var totalBets = parseInt(multibetElement.find('.betslip-multiples__bet-type__total').html().replace( /^\D+/g, ''), 10);
                var isEachWay = multibetElement.find('.each-way-checkbox').is(":checked");
                var multibetFreeBet = $(this).data('freebetId') ? true : false ;
                var multibetReturn;

                if (multiBetStake === 0) {
                    singleMultibetReturn.html(formatCurrency(0));
                    if (totalSuspended && multibetId === 'singles') {
                        return false; //we only do calculate for singles when at least one selection is suspended
                    } else {
                        return; //next one
                    }
                }

                if (spSelected) {
                    singleMultibetReturn.html(that.lang.na);
                    spWithStake = true;
                } else {
                    if (multibetId === 'singles') {
                        if (equalSinglesStakes) {
                            //singles bet are already calculated
                            multibetReturn = singlesReturns;
                        } else {
                            multibetReturn = 0; // some stakes are differents in the singles so the customer might have changed one single stake after adding single multibets
                        }
                    } else {
                        var multibet = {
                            singles: stakes.singles,
                            multiples: [{
                                type: that.availableBetTypes[multibetId].type_id,
                                stake: multiBetStake,
                                foldLength: that.availableBetTypes[multibetId]['fold_length'], //this is use for accumulators that are Folds
                                isEachWay: isEachWay,
                                isFreeBet: multibetFreeBet
                            }]
                        };

                        multibetReturn = that.calculateMultiBetsPotentialReturn(multibet, that.contingencies);
                        multiplesReturn += multibetReturn;

                    }

                    singleMultibetReturn.html(formatCurrency(multibetReturn));
                }

                if (isEachWay && !multibetFreeBet) {
                    multiBetStake *= 2;
                }

                if (totalSuspended && multibetId === 'singles') {
                    return false; //we only do calculate for singles when at least one selection is suspended
                }

                //Total stake calculation PART 2 (multibets that are not singles)
                //update the total stake with the multibets
                if (multibetId !== 'singles') {
                    // we add the multibets stake to the total stake for each multibets type execpts the singles one as it is already calculated in PART 1
                    totalStake += (totalBets * multiBetStake);
                }

            });
        }

        this.betslipElt.find('#betslip-total-stake').html(
            formatCurrency(totalStake)
        );

        if (!spWithStake) {
            potentialReturns = this.calculateTotalPotentialReturns(singlesReturns, multiplesReturn);
        } else {
            // if a selection is sp and has a stake
            // or if a selection is sp  with no stake but there is a multibet stake
            potentialReturns = this.lang.na;
        }

        this.betslipElt.trigger('betslip:content_change');
        let potentialReturnsMessage;
        if (!isNaN(parseFloat(potentialReturns))) {
            potentialReturnsMessage = formatCurrency(potentialReturns);
        } else if (potentialReturns === this.lang.na) {
            potentialReturnsMessage = this.lang.na;
        } else {
            potentialReturnsMessage = '';
        }
        this.betslipElt.find('#betslip-potential-returns').text(potentialReturnsMessage);
        this.handleDisplayTaxMessage('betslip-placement__tax-message', potentialReturns);
    },

    calculateTaxOnReturns: function (potentialReturns) {
        const taxOnReturns = getUserTaxOnReturns();

        return bsNumber(potentialReturns * taxOnReturns);
    },

    handleDisplayTaxMessage: function($taxMessageContainerId, potentialReturns) {
        if (this.shouldDisplayTaxMessage) {
            const displayTaxAmount = !isNaN(parseInt(potentialReturns)) && (potentialReturns !== this.lang.na);
            const formatedTaxAmount = displayTaxAmount ? ` (${formatCurrency(this.calculateTaxOnReturns(potentialReturns))})` : '';
            this.betslipElt.find(`#${$taxMessageContainerId} .betslip_tax_percentage`).text(getUserTaxOnReturnsForDisplay());
            this.betslipElt.find(`#${$taxMessageContainerId} .betslip_tax_amount`).text(formatedTaxAmount);
            this.taxMessageEl.removeClass('betslip-footer__tax-message--hidden');
        } else {
            this.taxMessageEl.addClass('betslip-footer__tax-message--hidden');
        }
    },

    /**
    * Create a timer do avoid to many ajax request on updating a stake
    */
    synchronizeBetslip: function() {
        var that = this;
        window.clearTimeout(this.betslipSaveChangesSyncTimer);
        if (this.userBetslip) {
            this.betslipSaveChangesSyncTimer = window.setTimeout(that._synchronize_betslip, that.betslipSyncTimeout, that.userBetslip);
        }

    },

    /**
    * Synchronizes server's and browser's betslips by sending all
    * updates that have been aggregated by `synchronizeBetslip`.
    * @param userBetslip {Object}
    */
    _synchronize_betslip: function(userBetslip) {
        if (!userBetslip) {
            return;
        }

        $.ajax({
            url:  base_url + 'betslip/synchronizeBetslip',
            type: 'POST',
            crossDomain: false,
            xhrFields: {
                withCredentials: true,
            },
            data: {userBetslip: JSON.stringify(userBetslip)}
        });
    },

    /**
     * Used to have an object with the bet type id as key
     * @param  {array} availableBetTypes The available bet types as returned by BE
     * @return {object}
     */
    _normalizeAvailableBetTypes: function(availableBetTypes) {
        var normalized = {};
        for (var bt in availableBetTypes) {
            //we cannot use the type_id as a key as the n-folds all have the same type_id
            normalized[this.replaceSpaceWithUnderscore(availableBetTypes[bt].name)] = availableBetTypes[bt];
        }

        return normalized;
    },

    /**
    * @param selectionId {Number}
    * @param contingencies {Array} of arrays
    * @param scorecastSelection {Boolean}
    * @param multiples {Boolean}
    * @param selectionSuspended {Boolean}
    * @return {Boolean}
    */
    isRelatedContingencySelection: function(selectionId, contingencies, scorecastSelection, multiples, selectionSuspended) {
        if (scorecastSelection && multiples) {
            return true;
        }

        if (!selectionSuspended && contingencies.length) {
            for (var i = 0; i < contingencies.length; i++) {
                //check if the selectionID is in a RC
                var rc = contingencies[i];
                var suspendedContingencies = 0;

                //we need to know how many selections are suspended in the same RC
                for (var j = 0; j < rc.length; j++) {
                    if (this.suspendedSelections.indexOf(String(rc[j])) > -1 &&
                        this.suspendedMarketsSelections.indexOf(String(rc[j])) > -1 &&
                        this.suspendedEventsSelections.indexOf(String(rc[j])) > -1
                    ) {
                        suspendedContingencies++;
                    }
                }

                if (rc.indexOf(selectionId) > -1 && (rc.length - suspendedContingencies) > 1) {
                    return true;
                }
            }
        }

        if (contingencies.length) {
            //flatten the array
            return [].concat.apply([], contingencies).indexOf(selectionId) > -1;
        }

        return false;
    },

    /**
    * Reset the bet Receipt view
    */
    resetBetReceipt: function() {
        $('#betslip-receipt__total-stake').empty();
        $('#betslip-receipt__potential-return').empty();
        $('#betslip-receipt__content').empty();
    },

    /**
    * Remove one or many selection(s) from the view and from all object that contains this selection
    * call the backend to get the new values (related contingencies, multibets etc..)
    * and store userBetslip
    * @param selectionsIdsToRemove {Array} of objects eg: [{single: 123}, {scorecast:[123, 56]}]
    * @param {Boolean} doNotCloseBetslip Set to true to avoid closing the betslip when the number of selections is 0 (used after bet placement)
    */
    removeSelectionsFromBetslip: function(selectionsIdsToRemove, doNotCloseBetslip, sendGTMData=true, shouldRetainSurveySelections = false) {
        var that = this;
        var anySelectionRemoved = false;
        var removedSelectionIds = {};
        var removedIds = [];

        this.mainWsHandler.unsubscribe(this.formatDataToSubscribeWebsocketEvents_v2(selectionsIdsToRemove, this.selectionsDetails));

        for (var i in selectionsIdsToRemove) {
            let allSelectionsOrderedProperty;
            if (selectionsIdsToRemove[i][0] && typeof(selectionsIdsToRemove[i][0].fc_tc) !== 'undefined') {
                allSelectionsOrderedProperty = 'fc_tc';
            } else if (typeof(selectionsIdsToRemove[i].scorecast) !== 'undefined') {
                allSelectionsOrderedProperty = 'scorecast';
            } else {
                allSelectionsOrderedProperty = 'single';
            }
            var selectionId, suspendedId, selectionBusyId;
            //remove from selectionsIds
            if (allSelectionsOrderedProperty === 'single') {
                selectionId = suspendedId = selectionBusyId = parseInt(selectionsIdsToRemove[i].single, 10);
                var selectionIdSinglesIndex = this.selectionsIds.singles.indexOf(selectionId);
                if (selectionIdSinglesIndex > -1) {
                    this.selectionsIds.singles.splice(selectionIdSinglesIndex, 1);
                    removedSelectionIds[selectionId] = true;
                    removedIds.push(selectionId);
                    this.betLocatePop(selectionId);
                    if (sendGTMData) {
                        eCommerceGTMSelection(this.selectionsDetails[selectionId], selectionId, actionTypes[1], 'removeFromCart');
                    }
                }
            } else {
                selectionId = selectionsIdsToRemove[i][allSelectionsOrderedProperty];
                if (allSelectionsOrderedProperty === 'fc_tc') {
                    selectionId = selectionsIdsToRemove[i][0][allSelectionsOrderedProperty];
                }
                var id = selectionBusyId = selectionId.join('_');
                removedSelectionIds[id] = true;

                suspendedId = id;

                const index = this.findCastBet(this.selectionsIds[allSelectionsOrderedProperty], selectionId);
                if (index > -1) {
                    removedIds.push(id);
                    this.selectionsIds[allSelectionsOrderedProperty].splice(index, 1);
                    if (sendGTMData) {
                        eCommerceGTMSelection(this.selectionsDetails[id], id, actionTypes[1], 'removeFromCart');
                    }
                }
            }

            //remove from the suspended arrays
            var suspendedIndex = this.suspendedSelections.indexOf(String(suspendedId));
            if (suspendedIndex > -1) {
                this.suspendedSelections.splice(suspendedIndex, 1);
            }

            suspendedIndex = this.suspendedEventsSelections.indexOf(String(suspendedId));
            if (suspendedIndex > -1) {
                this.suspendedEventsSelections.splice(suspendedIndex, 1);
            }

            suspendedIndex = this.suspendedMarketsSelections.indexOf(String(suspendedId));
            if (suspendedIndex > -1) {
                this.suspendedMarketsSelections.splice(suspendedIndex, 1);
            }

            for (var orderedIndex in this.selectionsIds.allSelectionsOrdered) {
                var orderedElement = (allSelectionsOrderedProperty === 'fc_tc') ?
                    this.selectionsIds.allSelectionsOrdered[orderedIndex][0] : this.selectionsIds.allSelectionsOrdered[orderedIndex];
                if (orderedElement && typeof(orderedElement[allSelectionsOrderedProperty]) !== 'undefined' &&
                    (orderedElement[allSelectionsOrderedProperty] === selectionId ||
                        this.findCastBet([orderedElement[allSelectionsOrderedProperty]], selectionId) > -1
                    )
                ) {
                    this.selectionsIds.allSelectionsOrdered.splice(orderedIndex, 1);
                    anySelectionRemoved = true;
                    // Notify rest of the site about every removal
                    that.betslipElt.trigger('betslip:removed', selectionId);
                    emit(BETSLIP_SELECTION_REMOVED_EVENT, { id: selectionId });
                }
            }

            if (!shouldRetainSurveySelections && this.surveySelections[selectionId]) {
                delete this.surveySelections[selectionId];
            }

            // Remove the class from the button so it can be clicked again and add data-spectate-product back in
            this.updateSelectionButtonDetails(selectionBusyId);
        }

        if (anySelectionRemoved) {
            //remove the selected class to selections removeClassSelected
            that.removeClassSelected(removedSelectionIds);

            // If there are no more selection left
            if (!this.selectionsIds.allSelectionsOrdered.length) {
                // Reset the availableBetTypes as there cannot be multibets available.
                this.availableBetTypes = {};
                // Notify rest of the site that betslip becomes empty
                that.betslipElt.trigger(BETSLIP_EMPTY_EVENT);
                emit(BETSLIP_EMPTY_EVENT);
                /**
                 * No selections left, override the betslipSyncTimeout value. There are edge cases where the betslip
                 * is refreshed before the timeout occurs, causing the old betslip to be reloaded
                 */
                this.overrideBetslipSyncTimeout = true;
                // hide accept odds section when no selections in betslip
                showHideAcceptOdds();
            }

            this.removeFromBetslipPerceptionOfSpeed(removedSelectionIds);

            //store the changes to redis and update the related contingencies, multibets etc..
            clearTimeout(this.betslipRemoveSyncTimer);
            this.betslipRemoveSyncTimer = setTimeout( function() {
                that.storeUserBetslip().done(function(response) {
                    var selectionDetails = response.betslip.betslipDetails.selection_details;

                    that.hideLoadingSpinner();

                    //update the counter
                    that.setBetslipCounter(that.selectionsIds.allSelectionsOrdered.length);

                    //initialise the suspended selection
                    that.updateSuspendedList(selectionDetails);

                    //redraw the betslip
                    that.drawBetslip(response);

                    // Update potential returns and stakes
                    that.updatePotentialReturnsAndStakes();

                    if (!that.selectionsIds.allSelectionsOrdered.length && !doNotCloseBetslip) {
                        bbModal_close(that.betslipElt);
                    }

                    // Notify rest of the site about the removals
                    emit(BETSLIP_SELECTIONS_REMOVED_EVENT, { selectionIds: removedIds });
                });
            },
            this.overrideBetslipSyncTimeout === undefined ? that.betslipSyncTimeout : 0
            );
        }
    },

    /**
    * find a scorecast/forecast/tricast bet in an array
    * @param list {Array} of Arrays (two or three elements)
    * @param selectionsIds {Array} two or three elements (eg: [123,12])
    * @return index {Number} in the array or -1 if not found
    */
    findCastBet: function (list, selectionsIds) {
        if (selectionsIds.length > 1) {
            const listIds = list.map(id => id.join('_'));
            const id = selectionsIds.join('_');

            return listIds.indexOf(id);
        }
        return -1;
    },

    displaySelectionSuspendedOverlayMessage: function(errorType, errorData) {
        var selection_id;
        var bbModal = this.betslipElt.data('bbModal');
        var contents = '<h2 class="bb-modal-overlay-dialog-title">' + i18n.t('betslip.selection_suspended') + '</h2>';
        contents += '<span class="bb-modal-overlay-dialog-icon"></span>';
        contents += '<ul class=betslip-dialog__suspended-selections>';
        if (errorType === 'selectionSuspendedSingle') {
            for (selection_id in errorData.selections) {
                var currentSelectionSingle = this.selectionsDetails[selection_id];
                contents += '<li>' + currentSelectionSingle.selection_name + '</li>';
            }
            contents += '</ul>';

            if (this.selectionsIds.allSelectionsOrdered.length > 1 && !this.areAllSelectionsSuspended()) {
                contents += '<span class="betslip-dialog__text-label">' + i18n.t('betslip.continue_w_remain_selections') + '</span>';
                contents += '<a href="#" id="betslip-get-on-selection-suspended" class="betslip-dialog__get-on betslip-dialog__get-on--selection-suspended" data-bb-modal-page="1" data-bb-modal-overlay-dialog-close>' + i18n.t('betslip.yes_get_on') + '</a>';
                contents += '<span class="betslip-dialog__or-label">' + i18n.t('betslip.or') + '</span>';
            } else {
                //all selections are suspended
                contents += `<span class="betslip-dialog__text-unavailable">${i18n.t('betslip.selection_unavailable', {count: this.selectionsIds.allSelectionsOrdered.length})}</span>`;
            }
        } else if (errorType === 'selectionSuspendedMultibet') {
            for (selection_id in errorData.selections) {
                var currentSelectionMultiple = this.selectionsDetails[selection_id];
                contents += '<li>' + currentSelectionMultiple.selection_name + '</li>';
            }

            contents += '</ul>';
            contents += '<span class="betslip-dialog__text-label" >' + i18n.t('betslip.multi_bet_unavailable') + '</span>';
        }

        contents += '<a href="#" class="betslip-dialog__back-to-betslip" data-bb-modal-overlay-dialog-close>' + '<span>' + this.lang.back + '</span>' + '</a>';
        bbModal.loadOverlayDialogContent(contents);
        var openEvenIfModalClosed = true;
        bbModal.openOverlayDialog(
            'betslip-dialog betslip-dialog--selection-suspended',
            openEvenIfModalClosed
        );
    },

    displayOddsHaveChangedOverlayMessage: function(errorData) {
        if (typeof errorData.selections !== 'undefined') {
            var bbModal = this.betslipElt.data('bbModal');
            var contents = '<h2 class="bb-modal-overlay-dialog-title">' + i18n.t('betslip.odds_have_changed') + '</h2>';
            contents += '<span class="bb-modal-overlay-dialog-icon"></span>';
            contents += '<ul class="betslip-dialog__changed-odds">';

            for (var e in errorData.selections) {
                var selectionError = errorData.selections[e];
                var selectionDetails = this.selectionsDetails[selectionError.id];
                var oldPrice, newPrice;
                switch (this.oddsFormat) {
                    case 'FRACTION':
                        oldPrice = selectionError.old_price_fraction;
                        newPrice = selectionError.new_price_fraction;
                    break;
                    case 'AMERICAN':
                        oldPrice = selectionError.old_price_american;
                        newPrice = selectionError.new_price_american;
                    break;
                    default:
                        oldPrice = decimalPriceOdds(selectionError.old_price_decimal);
                        newPrice = decimalPriceOdds(selectionError.new_price_decimal);
                }
                var oldIsSp = selectionError.old_price_decimal === '0.000' || selectionError.old_price_decimal === '0';
                var newIsSp = selectionError.new_price_decimal === '0.000' || selectionError.new_price_decimal === '0';

                contents += '<li>';
                contents += '<span class="betslip-dialog__changed-odds__selection-name">' + selectionDetails.selection_name + '</span>';
                contents += '<span class="betslip-dialog__changed-odds__odds">';
                contents += '<span class="betslip-dialog__changed-odds__old_price">' + (!oldIsSp ? oldPrice : this.lang.sp) + '</span>';
                contents += '<span class="betslip-dialog__changed-odds__new_price">' + (!newIsSp ? newPrice : this.lang.sp) + '</span>';
                contents += '</span>';
                contents += '</li>';
            }

            contents += '</ul>';
            contents += '<a href="#" id="betslip-get-on-odds-changed" class="betslip-dialog__get-on betslip-dialog__get-on--odds-changed" data-bb-modal-page="1" data-bb-modal-overlay-dialog-close>' + i18n.t('betslip.get_on') + '</a>';
            contents += '<span class="betslip-dialog__or-label">' + i18n.t('betslip.or') + '</span>';
            contents += '<a href="#" class="betslip-dialog__back-to-betslip betslip-dialog__back-to-betslip--secondary" data-bb-modal-overlay-dialog-close>' +  '<span>' + this.lang.back + '</span>' + '</a>';

            contents += this.generateToggleSwitchHtml();
            bbModal.loadOverlayDialogContent(contents);
            var openEvenIfModalClosed = true;
            bbModal.openOverlayDialog(
                'betslip-dialog betslip-dialog--odds-changed',
                openEvenIfModalClosed
            );
        } else {
            console.error('Undefined selections list when displaying odds have changed error dialog');
        }
    },

    /**
     * Creates the switch initialized to the flag value
     * @returns {String} Toggle html
     */
    generateToggleSwitchHtml: function() {
        const context = 'price-movement';
        const customerAcceptOddsFlag = getCustomerAcceptOddsFlag();
        const toggleGtmState = customerAcceptOddsFlag ? 'accept-odds-movement-off' : 'accept-odds-movement-on';
        const gtmTagToggle = `${context};accept-odds-switcher;${toggleGtmState}`;
        const activeSwitchClass = customerAcceptOddsFlag ? 'betslipOddsToggle__switch--active' : '';

        return `<div
            id="betslipOddsToggle-${context}"
            class="betslipOddsToggle">
            <div class="betslipOddsToggle__text">${i18n.t('betslip.accept_odds')}</div>
            <div
                data-spectate-product="${gtmTagToggle}"
                data-odds-toggle="${customerAcceptOddsFlag}"
                class="betslipOddsToggle__switch ${activeSwitchClass}">
            </div>
        </div>`;
    },

    /**
     * handles generic error messages
     * @param  {'changedOdds' || 'selectionSuspended'} errorType the type of error
     * @param  {data} errorData data regarding this error
     */
    genericErrorHandler: function genericError(errorType, errorData) {
        if (errorType === 'changedOdds') {
            this.displayOddsHaveChangedOverlayMessage(errorData);
        } else if (errorType === 'selectionSuspendedSingle') {
            this.displaySelectionSuspendedOverlayMessage(errorType, errorData);
        } else if (errorType === 'selectionSuspendedMultibet') {
            this.displaySelectionSuspendedOverlayMessage(errorType, errorData);
        }
    },

    /**
     * display a generic bet placement error
     *
     */
    displayBetErrorDialog: function(errorType, limits = {}) {
        var bbModal = this.betslipElt.data('bbModal');
        var dialogTitle = '';
        var dialogText = '';
        var betslipCloseTitle = i18n.t('betslip.close');
        const ctaLinks = [];
        /**
         * AM-3439 When React SPA component is unmounted the bb-modal overlays remain in the DOM.
         * We remove them and when the SPA is reloaded they get recreated.
         */
        const removeBbModalOverlays = () => document.querySelectorAll('.bb-modal-overlay').forEach(node => node.remove());

        switch (errorType) {
            case 'SELF_EXCLUDED':
                dialogTitle = i18n.t('betslip.self_excluded');
                dialogText = i18n.t('betslip.bet_not_placed');
                break;
            case 'SELF_TIMEDOUT':
                dialogTitle = i18n.t('betslip.on_time_out');
                dialogText = i18n.t('betslip.bet_not_placed');
                break;
            case 'INSUFFICIENT_FUNDS':
                dialogTitle = i18n.t('betslip.insufficient_funds');
                dialogText = i18n.t('betslip.no_enough_funds_to_bet');
                break;
            case 'BETSLIP_LIMIT':
                dialogTitle = i18n.t('betslip.betslip_limit');
                dialogText = i18n.t('betslip.betslip_limit_reached');
                betslipCloseTitle = i18n.t('betslip.continue');
                break;
            case 'UNAUTHORIZED':
                dialogTitle = i18n.t('betslip.unauthorized');
                dialogText = i18n.t('betslip.login_to_bet');
                break;
            case 'BET_LIMITS':
                dialogTitle = i18n.t('betslip.bet_limit_reached');
                dialogText = i18n.t(`betslip.bet_limit_text_${limits.time}`, {amount: formatCurrency(limits.amount)});
                betslipCloseTitle = i18n.t('betslip.back_betslip');
                break;
            case 'LOSS_LIMITS':
                dialogTitle = i18n.t('betslip.loss_limit_reached');
                dialogText = i18n.t(`betslip.loss_limit_text_${limits.time}`, {amount: formatCurrency(limits.amount)});
                betslipCloseTitle = i18n.t('betslip.back_betslip');
                break;
            case 'CUSTOMER_EXCEEDED_SPAIN_INPLAY_WAGERING_LIMIT':
                const formattedAmount = limits.amount / 100;
                dialogTitle = i18n.t('betslip.live_betting_limit_title');
                dialogText = i18n.t('betslip.live_betting_limit_event', {event: limits.event, limit: formatCurrency(formattedAmount)});
                break;
            case 'GEO_ERROR':
                dialogTitle = i18n.t('betslip.geo_locate_auth_fail_title');
                dialogText = i18n.t('betslip.geo_locate_auth_fail_text');
                // new cta's
                ctaLinks.push({
                    text: i18n.t('betslip.logout_and_retry'),
                    dataAttr: 'data-bb-modal-kickuser',
                    clickHandler: () => {
                        removeBbModalOverlays();
                    },
                });
                ctaLinks.push({
                    text: i18n.t('betslip.contact_us'),
                    dataAttr: 'data-bb-modal-external-navigate="https://sisportsbookco-en.custhelp.com/app/answers/detail/a_id/981/p/1252/"',
                }),
                // disable legacy cta
                betslipCloseTitle = '';
                break;
            case 'TIME_LIMIT_REACHED':
                dialogTitle = i18n.t('betslip.daily_limit');
                dialogText = i18n.t('betslip.bet_not_placed');
                ctaLinks.push({
                    text: i18n.t('betslip.logout'),
                    dataAttr: 'data-bb-modal-kickuser',
                    clickHandler: () => {
                        removeBbModalOverlays();
                    },
                });
                break;
            default:
                dialogTitle = i18n.t('betslip.error');
                dialogText = i18n.t('betslip.try_later');
                break;
        }

        const contents = this.getBetErrorDialog({
            dialogTitle, dialogText, betslipCloseTitle, ctaLinks,
        });

        bbModal.loadOverlayDialogContent(contents);
        var openEvenIfModalClosed = true;
        bbModal.openOverlayDialog(
            'betslip-dialog betslip-dialog--bet-error',
            openEvenIfModalClosed
        );

        // new cta handlers - search for 'off().on()' comment in this code:
        // - we do this to avoid adding duplicate event handlers
        ctaLinks.forEach(({ dataAttr = false, clickHandler = false }) => {
            if (clickHandler && dataAttr) {
                $(`[${dataAttr}]`, bbModal.component).off('click').on('click', (e) => clickHandler(e));
            }
        });
    },

    // used only by getBetErrorDialog - to be deprecated by GT with BS redesign
    createBetErrorDialogCtaHtml: function({ text, href = '', dataAttr = 'data-bb-modal-overlay-dialog-close' }) {
        return `
            <a ${href ? `href="${href}"` : ''} ${dataAttr}
                class="betslip-dialog__back-to-betslip">
                <span>${text}</span>
            </a>
        `;
    },

    // not getting too fussy about new cta's here - GT will refactor
    getBetErrorDialog: function({
        dialogTitle, dialogText, betslipCloseTitle = false, ctaLinks = [],
    }) {

        const legacyBetslipCloseHtml = betslipCloseTitle ? this.createBetErrorDialogCtaHtml({ text: betslipCloseTitle }) : '';

        const ctaLinksHtml = ctaLinks.reduce(
            (ctaLinksHtml, ctaLink) => (ctaLinksHtml += this.createBetErrorDialogCtaHtml(ctaLink)),
            ''
        );

        return `<h2 class="bb-modal-overlay-dialog-title">${dialogTitle}</h2>
            <span class="bb-modal-overlay-dialog-icon"></span>
            <span class="betslip-dialog__text-label">${dialogText}</span>
            ${legacyBetslipCloseHtml}
            ${ctaLinksHtml}
        `;
    },

    /**
    * replace all spaces by '_'
    * Mainly use to format the multiple name to make it as an identifier
    * As N-folds multiples have the same type_id we cannot use the type_id as an identifier
    * @param unformatted {String}
    * @return {string} formatted string
    **/
    replaceSpaceWithUnderscore: function(unformatted) {
        return unformatted.replace(/ /g,'_').toLowerCase();
    },

    /**
     * Update the selectionsToRetain property to match the selectedBets just before betting
     * @param  {[type]} allSelectionsOrdered The selected bets
     */
    updateSelectionsToRetain: function(allSelectionsOrdered) {
        this.selectionsToRetain = allSelectionsOrdered.slice();
    },

    formatFcTcToRetain: function(selection) {
        const market = selection.fc_tc.length === 2 ? 'forecast' : 'tricast';
        const formattedFcTc = selection.fc_tc.map((current, idx) => {
            return {
                id: current,
                variant: idx + 1,
                market: market,
            };
        });

        return { fc_tc: formattedFcTc };
    },

    /**
     * This method will add again the selectionsToRetain to the betstlip
     */
    retainSelections: function(selectionsToRetain) {

        this.pushSelectionMetaData();

        var gaComponent = this.gaComponentLookup(this.betslipElt);
        var selectionsToAddTmp = selectionsToRetain.reverse();
        var selectionsSeen = [];
        var selectionsToAdd = [];

        const that = this;

        Object.keys((this.selectionsDetails || {}))
            .map(function (id) {
                if (!id.includes('_')) {
                    selectionsToAddTmp.push({single: Number.parseInt(id)});
                }
            });

        // lose duplicate entries
        Object.keys(selectionsToAddTmp)
            .forEach(function (id) {
                if (!selectionsSeen.includes(selectionsToAddTmp[id].single)) {
                    let currentSelectionToAdd = selectionsToAddTmp[id];
                    if (currentSelectionToAdd[0] && currentSelectionToAdd[0].fc_tc) {
                        currentSelectionToAdd = that.formatFcTcToRetain(currentSelectionToAdd[0]);
                    } else {
                        selectionsSeen.push(currentSelectionToAdd.single);
                    }
                    selectionsToAdd.push(currentSelectionToAdd);
                }
            });

        this.resetBetslip();
        this.showLoadingSpinner();

        this.add(selectionsToAdd, gaComponent, false, false, false, false, true);
        this.popSelectionMetaData();
        /**
         * Careful now... attaching functions to this event:
         * If a user has done "LOGIN & GET ON" as part of the bet placement process a
         * browser redirect will be triggered (on setTimeout of 0) after this function
         * returns
         */
        this.betslipElt.trigger('betslip:retained');
    },

    /**
    * Reset all stake to 0
    * singles stakes and multiples stakes
    *
    * @param {Boolean} multiplesOnly To reset only multiples stakes
    * @param {Boolean} skipMultibetSingles To avoid resetting the singles multibet (used when disabling multibets)
    */
    resetUserEntry: function(multiplesOnly, skipMultibetSingles) {
        var selector = '.betslip-multiples__bet-type__stake';
        var ewSelector = '#betslip-multiples-list .betslip-each-way-block';

        if (skipMultibetSingles) {
            selector += ':not(#stake-multiples-singles)';
        }

        if (!multiplesOnly) {
            selector += ', .selection-stake-details__stake-holder';
            ewSelector += '#betslip-selections-list .betslip-each-way-block';
        }

        //clean stakes
        var stakeHolders = this.betslipElt.find(selector);
        stakeHolders.attr('data-value', 0)
            .data('value', 0)
            .data('freebetId', '')
            .data('hasFreebet', false)
            .text(this.lang.stake)
            .show()
            .siblings('.offVoucher').remove(); // Remove free bets

        //clean each ways
        var eachWaysBlock = this.betslipElt.find(ewSelector);
        eachWaysBlock.find('.each-way-checkbox').filter(function() {
            return !$(this).is('#each-way-multiples-singles');
        }).prop('checked', false);

        eachWaysBlock.find('.betslip-each-way-block__text').filter(function() {
            return $(this).closest('.betslip-each-way-block').find('#each-way-multiples-singles').length === 0;
        }).removeClass('selected');
    },

    /**
    * Reset singles multi stake
    */
    resetUserEntryMultiSingles: function() {
        //clean stakes
        const stakeHolder = this.betslipElt.find('#stake-multiples-singles');
        stakeHolder.attr('data-value', 0)
            .data('value', 0)
            .data('freebetId', '')
            .data('hasFreebet', false)
            .text(this.lang.stake)
            .show()
            .siblings('.offVoucher').remove(); // Remove free bets

        //clean each ways
        const eachWaysBlock = this.betslipElt.find('#betslip-multibet-type-singles .betslip-each-way-block');
        eachWaysBlock.find('.each-way-checkbox').prop('checked', false);
        eachWaysBlock.find('.betslip-each-way-block__text').removeClass('selected');
    },

    /**
     * Return the list of used freebets ids
     * @return {Array} The list of used freebets ids
     */
    getUsedFreebetsIds: function() {
        var freebetsIds = [];
        this.betslipElt.find('.selection-stake-details__stake-holder, .betslip-multiples__bet-type__stake').each(function() {
            var freeBetId = $(this).data('freebetId');
            if (freeBetId) {
                freebetsIds.push(freeBetId);
            }
        });

        return freebetsIds;
    },

    initSelectedFreeBets: function(availableFreeBets) {
        const that = this;
        this.betslipElt.find('.selection-stake-details__stake-holder, .betslip-multiples__bet-type__stake').each(function() {
            const freeBetId = $(this).data('freebetId');
            const selectedFreebet = (function findSelectedFreebet() {
                for (let freeBetType in availableFreeBets) {
                    const freebet = availableFreeBets[freeBetType].find(({ id }) => freeBetId === id);
                    if (typeof freebet !== 'undefined') {
                        return freebet;
                    }
                }
            }).call(that);

            if (selectedFreebet) {
                var freebetVoucher = that.fancyKeyboard.fkFreebetCreateVoucher(selectedFreebet.id, selectedFreebet.value, selectedFreebet.sport, false);
                that.fancyKeyboard.fkFreebetReplaceStakeField(freebetVoucher, null, $(this));

                // Update the freebet voucher if EW is selected. Note that the freebetVoucher variable above doesn't work when passing it to updateFreeBetLabel,
                // so we need to select the newly appendend voucher off the label.
                that.updateFreeBetLabel($(this).siblings('.offVoucher'), $(this).siblings('.betslip-each-way-block').find('.each-way-checkbox').is(':checked'));
            }
        });
    },

    /**
     * Update the free bet voucher value to half if ew is selected
     * @param  {jQuery} freebetVoucher The free bet voucher element
     * @param  {Boolean} ewSelected    Whether EW is selected
     */
    updateFreeBetLabel: function(freebetVoucher, ewSelected) {
        var value = freebetVoucher.data('freebetValue');
        if (ewSelected) {
            value = value / 2;
        }

        freebetVoucher.find('.freebet--title').html(formatCurrency(value, null, null, false, false));
    },

    /**
     * Enable/disable multibets. Used when a selection is suspended.
     */
    toggleMultibets: function() {
        var multipleElt = this.betslipElt.find('#betslip-multiples');
        var accumulatorElt = this.betslipElt.find('#betslip-accumulator');
        var totalSuspendedSelection = this.getTotalSuspendedSelections();
        var allSuspended = this.areAllSelectionsSuspended();
        var totalSelections = this.betslipElt.find('.betslip-selections:not(.betslip-selections--castmarket)').length;

        //if all selections are suspended do not show multibets
        if (allSuspended) {
            multipleElt.addClass('betslip-multiples__panel--hidden');
            accumulatorElt.addClass('betslip-accumulator__panel--hidden');
        } else {
            if (totalSuspendedSelection) {
                //at least one selection is suspended
                //as only the singles are availables update the counter for singles multibets
                var totalUnsuspendedSelection = totalSelections - totalSuspendedSelection;
                multipleElt.find('#betslip-multibet-type-singles .betslip-multiples__bet-type__total').html(' (' + totalUnsuspendedSelection + ')');
            } else {
                //no selection suspended
                if (typeof this.availableBetTypes['singles'] !== 'undefined') {
                    multipleElt.find('#betslip-multibet-type-singles .betslip-multiples__bet-type__total').html(' (' + this.availableBetTypes['singles']['total'] + ')');
                }
            }
            //only show the multibets pannel where there is more than one selection available in the betslip
            if (totalSelections > 1) {
                multipleElt.removeClass('betslip-multiples__panel--hidden');
            }
            if (totalSelections > 4) {
                accumulatorElt.removeClass('betslip-accumulator__panel--hidden');
            }

            var multiplesCounter = multipleElt.find('#betslip-multiples-counter');
            multiplesCounter.html(!totalSuspendedSelection ? multiplesCounter.data('multiplesCounter') : 1);
            multipleElt.find('#betslip-multiples-list').toggleClass('betslip-multiples__list--disabled', Boolean(totalSuspendedSelection));
            accumulatorElt.find('#betslip-accumulator-list').toggleClass('betslip-accumulator__list--disabled', Boolean(totalSuspendedSelection));

        }

        if (allSuspended) {
            this.resetUserEntry(true, true); // Reset stakes only for multibets, but not the singles multibet
            this.buildBetslipStructure(this.selectionsIds, this.availableBetTypes);
            this.synchronizeBetslip();
        }
    },

    /**
    * return total of suspended selections
    * @return {Number}
    */
    getTotalSuspendedSelections: function() {
        var selectionsElts = this.betslipElt.find('.betslip-selections');
        var totalSuspended = 0;

        for (var i = 0; i < selectionsElts.length; i++) {
            if ($(selectionsElts[i]).attr('class').indexOf('suspended') > -1) {
                totalSuspended ++;
            }
        }

        return totalSuspended;
    },

    /**
    * return an array of unsuspended selections Elt
    * @return {Array}
    */
    getUnsuspendedSelectionsElt: function() {
        return this.betslipElt.find('.betslip-selections:not(.betslip-selections--market-suspended, .betslip-selections--selection-suspended, .betslip-selections--event-suspended)');
    },

    /**
    * return if all selections are suspended
    * @param {Number} totalSuspended
    * @return {Boolean}
    */
    areAllSelectionsSuspended: function() {
        var totalSuspendedSelections = this.getTotalSuspendedSelections();
        return (totalSuspendedSelections > 0) && (totalSuspendedSelections === this.betslipElt.find('.betslip-selections').length);
    },

    /**
     * [openKeyboardOnLoneSelection function to bind and open the keyboard if there is only one selection in the betslip]
     *
     */
    openKeyboardOnLoneSelection: function opensKeyboardOnLoneSelection(){
        //if there is only one selection in the betslip
        if (!this.fancyKeyboard.isVisible
            && this.selectionsIds.allSelectionsOrdered.length === 1
            && !this.getTotalSuspendedSelections()
        ) {
            this.getSelectionFreeBets($(this.betslipElt.find('.fancyKeyboard-bindable')[0]));
        }
    },

    areAllSelectionsOfGivenSport: function(sportSlug) {
        var that = this;
        var unsuspendedSelectionsElts = this.getUnsuspendedSelectionsElt();
        var allOfGivenSport = true;

        unsuspendedSelectionsElts.each(function() {
            var selectionId = $(this).data('selectionId');
            if (typeof that.selectionsDetails[selectionId] !== 'undefined' && that.selectionsDetails[selectionId].sport !== sportSlug) {
                allOfGivenSport = false;
            }
        });

        return allOfGivenSport;
    },

    /**
     * Place a bet from external source (BabyBetslip)
     * @param {string} type of bet - single/multi
     * @param {type} searchMethod - function to search inside the required type of bets
     * @returns {void}
     */
    betExternal: function (type, data, loggedIn) {
        /**
         * @type Array A list of bet types that are supported by this function
         */
        const types = [
            'selections',
            'singles',
            'scorecast',
            'multiples',
            'forecast',
            'tricast',
        ];

        /**
         *
         * @type Array A list of bet types that must be mapped to 'multiples' type
         */
        const mappedTypes = [
            'doubles',
            'trebles',
            'accumulator',
        ]

        const betTypeUi = type; // needed for updateBetslipSelectionUi
        if (mappedTypes.indexOf(type) >= 0) {
            type = 'multiples';
        }

        if (!type || !data || types.indexOf(type) < 0) {
            return false;
        }

        const isCastMarket = ['forecast', 'tricast'].includes(type);

        let selectedBets;
        this.buildBetsStructure(this.selectionsIds, this.availableBetTypes, false, true);
        this.updateSelectionsToRetain(this.selectionsIds.allSelectionsOrdered);
        selectedBets = $.extend({}, this.selectedBets);
        Object.assign(data, { betTypeUi });
        this.updateBetslipSelectionUi(data);
        types.forEach(function (value) {
            if (value !== type && value !== 'selections' && !isCastMarket) { // for this moment store selections here
                selectedBets[value] = [];
            }
        });
        delete data.free_bet_value; // no need to pass to BE

        if (isCastMarket) {
            const {any, selections} = this.selectedBets.fc_tc[0];
            Object.assign(data, { selections, any });
            selectedBets.fc_tc = [data];
        } else if (type === 'scorecast') {
            const { first_goal_scorer_id, correct_score_id, bet_locate, price } = this.selectedBets.scorecast[0];
            Object.assign(data, { first_goal_scorer_id, correct_score_id, bet_locate, price });
            selectedBets.scorecast = [data];
        } else {
            selectedBets[type] = [data];
        }

        delete selectedBets.forecast;
        delete selectedBets.tricast;
        this.bet(selectedBets);
        if (!loggedIn) {
            this.changeLoginState();
        }

    },

    /**
     * Update main betslip UI with stake value or freebet data
     * @param {object} data
     * @returns {Boolean|void}
     */
    updateBetslipSelectionUi(data) {
        if (!data.selection && !data.multiple_id) {
            return false;
        }

        let selectionStakeEl;
        if (data.multiple_id) {
            selectionStakeEl = $('#stake-multiples-' + data.betTypeUi);
        } else {
            selectionStakeEl = $('#stake-selection-' + data.selection);
        }

        // override previous freebets and other changes
        selectionStakeEl.show().siblings('.freebetVoucher').remove();
        if (data.free_bet_id) {
            // if we have freebet and bet is failed we need to update betslip correctly
            selectionStakeEl.data('freebetId', data.free_bet_id);
            selectionStakeEl.data('value', data.free_bet_id);
            this.drawFreebetBlock(data.free_bet_id, selectionStakeEl);
        } else {
            selectionStakeEl.removeData('freebetId');
            selectionStakeEl.text(data.stake).data('value', data.stake);
        }

        this.updateEwSelectionState(data);
    },

    /**
     * This function draws freebet block for one selection/multibet
     * @param {integer} freebetId  - freebet Id
     * @param {object} selectionStakeEl - jquery selector for stake
     */
    drawFreebetBlock(freebetId, selectionStakeEl) {
        let selectedFreebet = null;
        const availableFreeBets = getAvailableFreeBets();
        for (let freeBetType in availableFreeBets) {
            const freebet = availableFreeBets[freeBetType].find(({ id }) => freebetId === id);
            if (typeof freebet !== 'undefined') {
                selectedFreebet = freebet;
                break;
            }
        }

        if (selectedFreebet) {
            const freebetVoucher = this.fancyKeyboard.fkFreebetCreateVoucher(
                selectedFreebet.id,
                selectedFreebet.value,
                selectedFreebet.sport,
                false
            );
            this.fancyKeyboard.fkFreebetReplaceStakeField(
                freebetVoucher,
                null,
                selectionStakeEl
            );
            // Update the freebet voucher if EW is selected
            // so we need to select the newly appendend voucher off the label.
            this.updateFreeBetLabel(
                selectionStakeEl.siblings('.offVoucher'),
                selectionStakeEl
                    .siblings('.betslip-each-way-block')
                    .find('.each-way-checkbox').is(':checked')
            );
        }

    },

    /**
     * Sync each way state between baby bs and bs
     * @param {object} data
     * @returns {Boolean|void}
     */
    updateEwSelectionState: function (data) {
        if (!data.selection && !data.multiple_id) {
            return false;
        }

        let $ewElement;
        let $ewLabel;
        let userBet = null;
        if (data.multiple_id) {
            $ewElement = $('#each-way-multiples-' + data.betTypeUi);
            $ewLabel = $ewElement.siblings(
                '.betslip-multiples__bet-type__each-way__text'
            );
            // RT-4309 if we don't have this bet type we need to create it on EW trigger - mimics BS behaviour
            if (!this.userBetslip.multiples[data.betTypeUi]) {
                this.userBetslip.multiples[data.betTypeUi] = {
                    id: data.multiple_id,
                    stake: data.stake || null,
                    each_way_selected: false,
                    free_bet_id : data.free_bet_id || null,
                }
            }
        } else {
            $ewElement = $('#each-way-selection-' + data.selection);
            $ewLabel = $ewElement.siblings(
                '.selection-stake-details__each-way__text'
            );
        }

        if (!$ewElement || !$ewElement.length) {
            return false;
        }

        if (data.selection) {
            userBet = this.userBetslip.selections[data.selection];
        }

        if (data.multiple_id) {
            userBet = this.userBetslip.multiples[data.betTypeUi];
        }

        // if ew exists for the selection
        if (userBet) {
            userBet['each_way_selected'] = data.is_each_way;
            $ewElement.prop('checked', data.is_each_way);
            $ewLabel.toggleClass('selected', data.is_each_way);
        }

        this.synchronizeBetslip();
    },

    /**
    * Remove the class 'selection-button-busy' from the selection button
    * This will enable the button to be used again
    * Add back in data-spectate-product for GTM clicks
    * @param {int} selectionId - The selection id
    */
    updateSelectionButtonDetails: function(selectionId) {
        const betButton = $('.bb-sport-event__selection[data-selection-id="' + selectionId + '"]');
        betButton.removeClass('selection-button-busy');
        betButton.attr('data-spectate-product', selection_button_gtm);
    },

    isInitialized: function() {
        return typeof this.betslipElt !== 'undefined' && this.betslipElt !== null;
    },

    /**
     * Closes the betslip
     * @returns {void}
     */
    closeBetslip: function() {
        if (!this.isInitialized()) {
            return;
        }

        bbModal_close(this.betslipElt);
    },

    /**
     * Opens the betslip modal
     * @returns {void}
     */
    openBetslip: function() {
        if (!this.isInitialized()) {
            return;
        }

        bbModal_open(this.betslipElt);
    },

    handleOpenBetsPage: function() {
        subscribeToStateChange(BETSLIP_ON_OPEN_BETS_PAGE_KEY, (key, isOnOpenBetsPage) => {
            if (isOnOpenBetsPage) {
                this.disableOpenBetsTab();
                this.selectBetslipTab();
            } else {
                this.enableOpenBetsTab();
            }
        });
    },

    disableOpenBetsTab: function() {
        disableBbTabs(this.betslipTabbed, '#bb-tab-my-bets');
    },

    enableOpenBetsTab: function() {
        enableBbTabs(this.betslipTabbed, '#bb-tab-my-bets');
    },

    selectBetslipTab: function() {
        this.betslipTabbed.bb_tabs('select', '#bb-tab-my-betslip');
    },

    selectMyBetsTab: function() {
        if (!this.isInitialized()) {
            setState(BETSLIP_STARTUP_MY_BETS_KEY, true);
        } else {
            this.betslipTabbed.bb_tabs('select', '#bb-tab-my-bets');
        }
    },

    populateBetslip: function(selections, surveyId = null) {
        if (!this.isInitialized()) {
            setState(BETSLIP_POPULATE_SELECTIONS, selections);
            setState(BETSLIP_POPULATE_SURVEY_ID, surveyId);
        } else {
            // switch to betslip
            this.checkForClearButton();
            bbModal_changePage(this.betslipElt, 0);
            // add bets
            selections.forEach(selection => {
                this.add([{ single: selection }], '', {}, false, false, true);
                if (surveyId) {
                    this.surveySelections[selection] = surveyId;
                }
            });
        }
    },

    /**
     * populates surveySelections from userbetslip on page load
     * @return {void}
     */
    populateSurveySelections: function() {
        if (!isEmpty(this.userBetslip) && !isEmpty(this.userBetslip.selections)) {
            Object.keys(this.userBetslip.selections).forEach(selectionId => {
                const { survey_id: surveyId } = this.userBetslip.selections[selectionId];
                if (surveyId) {
                    this.surveySelections[selectionId] = surveyId;
                }
            });
        }
    },

    changeBabyBetslipPosition: function(data) {
        setState(COOKIE_BANNER_VISIBILITY_STATE_KEY, data);
        if (this.isInitialized()) {
            this.setBabyBetslipBottomPosition();
        }
    },

    gaComponentLookup: function(element) {
        return $(element).closest('[data-ga_component]').attr('data-ga_component') || 'unknown_component';
    },

    handleFreeBetChange: function() {
        this.clientStateSubscribers.push(
            onFreeBetsStateChange((_, freeBets) => {
                this.initSelectedFreeBets(freeBets);

                const betslipFancyKeyboard = this.fancyKeyboard;
                if(betslipFancyKeyboard.isVisible) {
                    // finish keyboard animation
                    betslipFancyKeyboard.keyboardView.finish();
                    // find the stake element with opened keyboard
                    const el = $(this.betslipElt.find('.fancyKeyboard-input-active')[0]);
                    this.getSelectionFreeBets(el, true);
                }
            })
        );
    }
};

export default BetslipController;
